import React, { useEffect, useState , useRef } from "react";
import { Helmet } from "react-helmet";
import ConfigETC from "../Class/ConfigETC.json";
import TimesheetCalendarbarShowStatus from "../PartialView/Timesheet_Calendarbar_ShowStatus";
import TimesheetCellDayProject from "../PartialView/Timesheet_Cell_DayProject";
import TimesheetCellDayTotalTime from "../PartialView/Timesheet_Cell_DayTotalTime";
import TimesheetSubmitCellShowTime from "../PartialView/Timesheet_SubmitCellShowTime"
import SelectTimeoff from "../Library/Select_Timeoff";
import SelectProjectByTimeSheetByAdd from "../Library/Select_ProjectByTimeSheet";
import SelectProjectByTimeSheetBySearch from "../Library/Select_ProjectByTimeSheet";
import SelectTaskMultiGroup from "../Library/Select_TaskMultiGroup";
import SelectCustomer from "../Library/Select_Customer";
import { DateRangePickerComponent } from '@syncfusion/ej2-react-calendars';


import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

import Select from 'react-select'
import {
  RSelect_Group,
} from "../Class/Class_Etc";


import { Class_ETC_MsgError
        ,HtmlTooltip
        ,convertTimeToMinutes
        ,Class_ETC_MsgSuccess
        ,Class_ETC_Warning
        ,Bind_Select_Status
        ,Bind_Presets_Calendar
        ,Class_ETC_MsgWarning
        ,Returncomma
        ,ReturncommaCustom
        ,Class_ETC_Decrypt2
        ,Class_ETC_SessionTimeOut
} from "../Class/Class_Etc";
import MsgDescription from "../Class/MsgDescription.json";
import CurrencyInput from 'react-currency-input-field';


import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimeField } from '@mui/x-date-pickers/TimeField';
import { CP_CheckPermission } from "../Class/Class_Permission"
import { customStylesSelect } from "../Class/Class_Etc"

import { useLocation } from "react-router-dom";
import { TableFooter } from "@mui/material";


/* 
  Create By Poom : 08-06-2023 
  
  Edit BY POOM : 02-05-2024 
    - เพิ่ม fillter ค้นหา  > "Customer" โดยทำเป็น DDL  multi choice
    - จำนวนวัน  (วางหลัง PER DIEM )
    - ระยะทาง(กม.) วางไว้หลัง ช่อง TRAVEL
    (เพิ่มช่องบันทึก แล้ว TS_exp_extra_day,TS_exp_travel_distance)

  Edit BY POOM : 08-05-2024 
    - เพิ่ม service ot เข้ามา เพราะฉนั้น ถ้าไม่มี service ot จะปิดทุกอย่างที่เกี่ยวกับ OT ออกเลย ไม่ให้บันทึกไม่ให้เห็นข้อมูล
  
  Edit By POOM : 13-05-2024  เวลา return API  ให้เช็คว่าถ้า status_ID === 2  ให้เด้ง SessionTimeOut ทันที
    


*/


function Timesheet() {  

  //#region __ Declare ตัวแปร __

  const location = useLocation();
  const [iscnt_setvalue, setIscnt_setvalue] = useState(0);
  const [prm_is, setPrm_is] = useState(-1);
  // eslint-disable-next-line
  const [prm_staffcode, setPrm_staffcode] = useState("");
  // eslint-disable-next-line
  const [prm_staffname, setPrm_staffname] = useState("");
  const [prm_issearch, setPrm_issearch] = useState(0);
  const [prm_searchDateS, setPrm_searchDateS] = useState("");
  const [prm_searchDateE, setPrm_searchDateE] = useState("");
  const [prm_searchstatus, setPrm_searchstatus] = useState("");
  const [prm_searchProject, setPrm_searchProject] = useState("");
  const [prm_searchTimeoff, setPrm_searchTimeoff] = useState("");
  const [prm_searchTask, setPrm_searchTask] = useState("");
  
  const isSVOT = CP_CheckPermission("service_list" , ["ot"],false,false);

  const [isLoadProgress, setIsLoadProgress] = useState(true);
  const [isLoadedConfigData, setIsLoadedConfigData] = useState(false);
  const [isLoadGoto, setIsLoadGoto] = useState(false);
  const [configData, setConfigData] = useState([]);
  const [listcalendar, setListcalendar] = useState([]);
  const [calendaractive, setCalendaractive] = useState("");
  const [listcalendarbyproject, setListcalendarbyproject] = useState([]);

  const [summary_wtot, setSummary_wtot] = useState({

    total_wt_sun: 0,
    total_ot_sun: 0,
    total_wt_time_hr_sun: "0",
    total_wt_time_mm_sun: "0",
    total_ot_time_hr_sun: "0",
    total_ot_time_mm_sun: "0",
    
    total_wt_mon: 0,
    total_ot_mon: 0,
    total_wt_time_hr_mon: "0",
    total_wt_time_mm_mon: "0",
    total_ot_time_hr_mon: "0",
    total_ot_time_mm_mon: "0",

    total_wt_tue: 0,
    total_ot_tue: 0,
    total_wt_time_hr_tue: "0",
    total_wt_time_mm_tue: "0",
    total_ot_time_hr_tue: "0",
    total_ot_time_mm_tue: "0",

    total_wt_wed: 0,
    total_ot_wed: 0,
    total_wt_time_hr_wed: "0",
    total_wt_time_mm_wed: "0",
    total_ot_time_hr_wed: "0",
    total_ot_time_mm_wed: "0",

    total_wt_thu: 0,
    total_ot_thu: 0,
    total_wt_time_hr_thu: "0",
    total_wt_time_mm_thu: "0",
    total_ot_time_hr_thu: "0",
    total_ot_time_mm_thu: "0",

    total_wt_fri: 0,
    total_ot_fri: 0,
    total_wt_time_hr_fri: "0",
    total_wt_time_mm_fri: "0",
    total_ot_time_hr_fri: "0",
    total_ot_time_mm_fri: "0",

    total_wt_sat: 0,
    total_ot_sat: 0,
    total_wt_time_hr_sat: "0",
    total_wt_time_mm_sat: "0",
    total_ot_time_hr_sat: "0",
    total_ot_time_mm_sat: "0",

    totalall_wt: 0,
    totalall_ot: 0,
    totalall_wt_time_hr: "0",
    totalall_wt_time_mm: "0",
    totalall_ot_time_hr: "0",
    totalall_ot_time_mm: "0",

  });


  
  const [listtimesheetSubmit, setListtimesheetSubmit] = useState([]);

  const [listddltimeoff, setListddltimeoff] = useState([]);
  const [listddlTask, setListddlTask] = useState([]);
  const [start_date_byproject, setStart_date_byproject] = useState("");
  const [ssp_sun, setSsp_sun] = useState(0);
  const [ssp_mon, setSsp_mon] = useState(0);
  const [ssp_tue, setSsp_tue] = useState(0);
  const [ssp_wed, setSsp_wed] = useState(0);
  const [ssp_thu, setSsp_thu] = useState(0);
  const [ssp_fri, setSsp_fri] = useState(0);
  const [ssp_sat, setSsp_sat] = useState(0);
  const [iscntreset, setIscntreset] = useState(0);
  const [bindProjectBycusid, setBindProjectBycusid] = useState(0);
  const [iscntreset_ProjectAdd, setIscntreset_ProjectAdd] = useState(0);
  const [iscntreset_TSCall_DP, setIscntreset_TSCall_DP] = useState(0);

  
  const [isdisabled_btnsubmitweek , setIsdisabled_btnsubmitweek] = useState(true);
  const [icontoday, setIcontoday] = useState("");

  const [cntReject, setCntReject] = useState(0);
  const dataPresets = Bind_Presets_Calendar();
  const [isshowDetailTs , setIsshowDetailTs] = useState(false);
  const [issearch , setIssearch] = useState(0);
  const [searchstatus , setSearchstatus] = useState(null);
  const [searchProject, setSearchProject] = useState(null);
  const [searchCus, setSearchCus] = useState(null);
  const [searchTimeoff, setSearchTimeoff] = useState(null);
  const [searchTask, setSearchTask] = useState(null);
  
  const [searchValuedateS , setSearchValuedateS] = useState(null);
  const [searchValuedateE , setSearchValuedateE] = useState(null);
  const [searchValuestatus , setSearchValuestatus] = useState(null);
  const [searchValueProject, setSearchValueProject] = useState(null);
  const [searchValueCus, setSearchValueCus] = useState(null);
  const [searchValueTimeoff, setSearchValueTimeoff] = useState(null);
  const [searchValueTask, setSearchValueTask] = useState(null);

  const [searchValueStaff, setSearchValueStaff] = useState("-1");


  const [selectedtask, setSelectedtask] = useState([]);
  const [selectedtimeoff, setSelectedtimeoff] = useState([]);
  const [selectedproject, setSelectedproject] = useState([]);
  const [isDisabledTimeoff, setIsDisabledTimeoff] = useState(true);
  const [isDisabledTask, setIsDisabledTask] = useState(true);
  const [ischecked_timeofftask, setIschecked_timeofftask] = useState("1");
  const selectRef_Project = useRef(null)
  const selectRef_Timeoff = useRef(null)
  const selectRef_Task = useRef(null)
  
  const [isholiday_sun, setIsholiday_sun] = useState("");
  const [isholiday_mon, setIsholiday_mon] = useState("");
  const [isholiday_tue, setIsholiday_tue] = useState("");
  const [isholiday_wed, setIsholiday_wed] = useState("");
  const [isholiday_thu, setIsholiday_thu] = useState("");
  const [isholiday_fri, setIsholiday_fri] = useState("");
  const [isholiday_sat, setIsholiday_sat] = useState("");


  const [dt_sun, setDt_sun] = useState("");
  const [dt_mon, setDt_mon] = useState("");
  const [dt_tue, setDt_tue] = useState("");
  const [dt_wed, setDt_wed] = useState("");
  const [dt_thu, setDt_thu] = useState("");
  const [dt_fri, setDt_fri] = useState("");
  const [dt_sat, setDt_sat] = useState("");

  const [dt_Full_sun, setDt_Full_sun] = useState("");
  const [dt_Full_mon, setDt_Full_mon] = useState("");
  const [dt_Full_tue, setDt_Full_tue] = useState("");
  const [dt_Full_wed, setDt_Full_wed] = useState("");
  const [dt_Full_thu, setDt_Full_thu] = useState("");
  const [dt_Full_fri, setDt_Full_fri] = useState("");
  const [dt_Full_sat, setDt_Full_sat] = useState("");

  const [data_modalTS_Extra, setData_modalTS_Extra] = useState(0.00);
  const [data_modalTS_Travel, setData_modalTS_Travel] = useState(0.00);
  const [data_modalTS_Other, setData_modalTS_Other] = useState(0.00);

  const [data_modalTS_Extra_day, setData_modalTS_Extra_day] = useState(0.00);
  const [data_modalTS_Travel_distance, setData_modalTS_Travel_distance] = useState(0.00);


  const [data_modalTS_ActProject, setData_modalTS_ActProject] = useState(null);
  const [data_modalTS_act_task_timeoff, setData_modalTS_act_task_timeoff] = useState(null);

  const [data_modalTS_tsid, setData_modalTS_tsid] = useState(0);
  const [data_modalTS_pro_id, setData_modalTS_pro_id] = useState(0);
  const [data_modalTS_task_id, setData_modalTS_task_id] = useState(0);
  const [data_modalTS_timeoff_id, setData_modalTS_timeoff_id] = useState(0);
  const [data_modalTS_ts_date, setData_modalTS_ts_date] = useState("");
  const [data_modalTS_day, setData_modalTS_day] = useState("");


  const [data_modalTS_tss, setData_modalTS_tss] = useState(0);
  const [data_modalTS_tsssn, setData_modalTS_tsssn] = useState("");
  const [data_modalTS_tsrd, setData_modalTS_tsrd] = useState("");
  const [data_modalTS_tsrd2, setData_modalTS_tsrd2] = useState("");
  const [data_modalTS_tsrd3, setData_modalTS_tsrd3] = useState("");
  const [data_modalTS_ud, setData_modalTS_ud] = useState("");

  const [data_modalTS_usn, setData_modalTS_usn] = useState("");
  const [data_modalTS_tsd, setData_modalTS_tsd] = useState("");

  const [data_modalTS_Task, setData_modalTS_Task] = useState("");
  const [data_modalTS_SubTask, setData_modalTS_SubTask] = useState("");
  const [data_modalTS_Timeoff, setData_modalTS_Timeoff] = useState("");
  
  const [data_modalTS_wt_time, setData_modalTS_wt_time] = useState(""); 
  const [data_modalTS_ot_time, setData_modalTS_ot_time] = useState(""); 
  
  
  const [data_modalTS_act_edit, setData_modalTS_act_edit] = useState("");
  const [data_modalTS_act_cancel, setData_modalTS_act_cancel] = useState("");
  const [data_modalTS_act_del, setData_modalTS_act_del] = useState("");
  const [data_modalTS_rowindex, setData_modalTS_rowindex] = useState(0);

  const current = new Date();
  const dateToday = (current.getDate() < 10 ? "0" : "") + current.getDate().toString() + "/" +
               ((current.getMonth()+1 < 10 ? "0" : "") + (current.getMonth()+1).toString()) + "/" + 
               (current.getFullYear() > 2500 ? current.getFullYear() - 543 : current.getFullYear()).toString()


  const itemsdesktop = 10;
  const itemstablet = 2;
  const itemsmobile = 2;
  const _slidesToslide = 2;
  
  const desktopmax = 9000;
  const tabletmax = 768;
  const mobilemax = 600;
  const delay_loadslinde = 1;
  
  const previousSlide_default  = -5;
  const nowSlide_default  = 1;
  const nextSlide_default  = 7;
  const checknextSlide_default  = 6;
  const [previousSlide, setPreviousSlide] = useState(previousSlide_default);
  const [nowSlide, setNowSlide] = useState(nowSlide_default);
  const [nextSlide, setNextSlide] = useState(nextSlide_default);
  const [checknextSlide, setChecknextSlide] = useState(checknextSlide_default);

  const h_holi  = "text-center-input align-top bg-light";
  const h_nholi  = "text-center-input align-top";

  const b_holi  = "bg-light";
  const b_nholi  = "";

  //#endregion

  
  //#region __ useeffect __

  // useEffect(() => {
  //   GetParameter(function() {
  //   });
  //   // eslint-disable-next-line
  // }, []);


  useEffect(() => {
    //if (prm_is !== -1)
    //{
      let perview = CP_CheckPermission("main" , ["my_timesheets_view"] , false , true);
      if (perview)
      {

        GetConfig();
        if (isLoadedConfigData === true) {
          BindDDLTimeOff(function (){
            BindDDLTask(function() {
              BindCntReject(function() {

                if (prm_is === 0)
                {
                  BindListcalendarBar("0" , "0" , "" , function() {
                    if (window.innerWidth < tabletmax)
                    {
                      document.getElementById("hd_Slideindex_Goto").value = "3"
                      setIsLoadGoto(true)
                    }
                    else
                    {
                      setIsLoadProgress(false);
                    }
                  });
                }
                else{
                  if (prm_issearch === 0){
                    BindListcalendarBar("0" , "0" , "" , function() {
                      if (window.innerWidth < tabletmax)
                      {
                        document.getElementById("hd_Slideindex_Goto").value = "3"
                        setIsLoadGoto(true)
                      }
                      else
                      {
                        setIsLoadProgress(false);
                      }
                    });
                  }
                  else{
                    setIscnt_setvalue((iscnt_setvalue) => iscnt_setvalue + 1);
                    ActionBindParameter();
                  }
                }
              })
            });
          });
        }
      }
    //}
    // eslint-disable-next-line
  }, [isLoadedConfigData]);

  useEffect(
    () => {
    if (isLoadGoto)
    {
      let timer1 = setTimeout(() => 
        { 
          document.getElementById("btn_GotoSet").click();
          setIsLoadGoto(false);
          setIsLoadProgress(false);
        }, delay_loadslinde * 500);
      return () => {
        clearTimeout(timer1);
      };
    }
    
  },[isLoadGoto]);

  useEffect(() => {
    // ไม่ต้องทำอะไร ใส่ไว้เพื่อ Reset useState
  },[issearch,isshowDetailTs]);
  
  useEffect(() => {
    // ถ้า listcalendarbyproject ทำงาน เราจะทำการ cnt iscntreset_TSCall_DP ใหม่ เพื่อ Reset ค่าใน textbox 
    setIscntreset_TSCall_DP(iscntreset_TSCall_DP + 1)
    // eslint-disable-next-line
  },[listcalendarbyproject]);

  
  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);
  //#endregion __ useeffect __


  //#region __ Function __ 

  // eslint-disable-next-line
  function GetParameter(_callback) {

    try {

      let Params = new URLSearchParams(location.search);
      if (Params === null) {
        setPrm_is(0);
        if (_callback != null) {
            _callback();
        }
        
      } else {
        let staffcodelogin = localStorage.getItem("Staff_Code");
        let staffcode = Class_ETC_Decrypt2(decodeURIComponent(Params.get('vsc')));
        if (staffcode === "") {
          setPrm_is(0);
          if (_callback != null) {
              _callback();
          }
        } 
        else 
        {

          let staffname = (staffcodelogin === staffcode ? "My Time sheet" : Class_ETC_Decrypt2(decodeURIComponent(Params.get('vsn'))));
          
          setSearchValueStaff(staffcodelogin === staffcode ? "-1" : staffcode);
          setPrm_staffcode(staffcode);
          setPrm_staffname(staffname);

          //let vis = Class_ETC_Decrypt2(decodeURIComponent(Params.get('vis')));
          // let vis2 = 0;
          // if (isNaN(vis) === false) {
          //   vis2 = vis;
          // }
          // console.log(vis2 , "vis2")

          //if (vis2 === 1) {
          setPrm_issearch(1);
          let vsds = Class_ETC_Decrypt2(decodeURIComponent(Params.get('vsds')));
          let vsde = Class_ETC_Decrypt2(decodeURIComponent(Params.get('vsde')));
          let vss = Class_ETC_Decrypt2(decodeURIComponent(Params.get('vss')));
          let vsp = Class_ETC_Decrypt2(decodeURIComponent(Params.get('vsp')));
          let vsto = Class_ETC_Decrypt2(decodeURIComponent(Params.get('vsto')));
          let vst = Class_ETC_Decrypt2(decodeURIComponent(Params.get('vst')));
          setPrm_searchDateS(vsds);
          setPrm_searchDateE(vsde);
          setPrm_searchstatus(vss);
          setPrm_searchProject(vsp);
          setPrm_searchTimeoff(vsto);
          setPrm_searchTask(vst);

          if (vsds !== "" && vsde !== ""){
            document.getElementById("txt_SearchDate").value = vsds + " - " + vsde;
          }

          if (vss !== ""){
            
            let setstatus = {
              0: ConfigETC.TS_InProgress_Text,
              10: ConfigETC.TS_ToReview_Text,
              11: ConfigETC.TS_ToApprove_Text,
              20: ConfigETC.TS_Approved_Text,
              30: ConfigETC.TS_Clearing_Text,
              12: ConfigETC.TS_Reject_Text,
            };
            let arr = [];
            let arrValueshow = vss.split(",");
            for (let i = 0 ; i < arrValueshow.length; i++){
              arr.push({
                value: parseInt(arrValueshow[i]),
                label: setstatus[arrValueshow[i]],
              });
            }
            setSearchstatus(arr);
          }

          document.getElementById("btn_Filter").click();

          // }
          // else {
          //   setPrm_issearch(0);
          // }
          setPrm_is(1);
          
          if (_callback != null) {
            _callback();
          }
        }
      }
    } catch {
      setPrm_is(0);
      if (_callback != null) {
        _callback();
      }

    }

  }

  function ActionBindParameter(){
    let ValueDateS = prm_searchDateS;
    let ValueDateE = prm_searchDateE;
    let ValueStatus = ""
    let ValueProject = ""
    let ValueCus = ""
    let ValueTimeoff = ""
    let ValueTask = ""

    if (prm_searchstatus !== ""){
      let arrValueshow = prm_searchstatus.split(",");
      for (let i = 0 ; i < arrValueshow.length; i++){
        ValueStatus = ValueStatus + (ValueStatus === "" ? "" : ",") + arrValueshow[i].toString();
      }
    }
    
    if (prm_searchProject !== ""){
      let arrValueshow = prm_searchProject.split(",");
      for (let i = 0 ; i < arrValueshow.length; i++){
        ValueProject = ValueProject + (ValueProject === "" ? "" : ",") + arrValueshow[i].toString();
      }
    }
    
    if (prm_searchTimeoff !== ""){
      let arrValueshow = prm_searchTimeoff.split(",");
      for (let i = 0 ; i < arrValueshow.length; i++){
        ValueTimeoff = ValueTimeoff + (ValueTimeoff === "" ? "" : ",") + arrValueshow[i].toString();
      }
    }
    
    if (prm_searchTask !== ""){
      let arrValueshow = prm_searchTask.split(",");
      for (let i = 0 ; i < arrValueshow.length; i++){
        ValueTask = ValueTask + (ValueTask === "" ? "" : ",") + arrValueshow[i].toString();
      }
    }

    setIssearch(1);
    setIsLoadProgress(true);
    if (listcalendar.length > 0)
    {
      document.getElementById("hd_Slideindex_Goto").value = "0"
      document.getElementById("btn_GotoSet").click();
    }

    BindListCalendarBarAPI("0" , "0" , "" , 1 , ValueStatus.toString() , ValueProject.toString() , ValueCus.toString() , ValueTimeoff.toString() , 
                          ValueTask.toString() , ValueDateS , ValueDateE , function() {
      setIsLoadProgress(false);
    });

  }

  const handleKeyDown = (event) => {
    if (event.key === 'Escape') {
      document.getElementById("modalAddProject_Close").click();
      document.getElementById("modalTS_Close").click();
      document.getElementById("modalsubmit_Close").click();
    }
  };

  async function GetConfig() {
    await fetch("../ConfigData.json")
      .then((res) => res.json())
      .then((data) => {
        setConfigData(data);
        setIsLoadedConfigData(true);
      })
      .catch((err) => err);
  }

  async function BindDDLTimeOff(_callback){
    try {
      let token = "";
      token = localStorage.getItem("TStoken");
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + token);
      myHeaders.append("Content-Type", "application/json");
      var raw = JSON.stringify({
        "timeoff_status": "1"
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(
        configData.API_URL + "Timeoff_GetDDL",
        requestOptions
      );

      const json = await response.json();
      if (json.status_ID === 1) {
        if (json.total_Data > 0) {
          setListddltimeoff([
            {
              rowindex : 0  ,value: "-1", label: ConfigETC.ddl_pleaseselect
            },  ...json.data]);
        } else {
          setListddltimeoff([]);
        }
        if (_callback != null) {
            _callback();
        }
      }
      else if (json.status_ID === 2) 
      {
        Class_ETC_SessionTimeOut();
      }
      else{
        setListddltimeoff([]);
        if (_callback != null) {
            _callback();
        }
      }
    } catch {
      setListddltimeoff([]);
      if (_callback != null) {
          _callback();
      }
    }
  }

  async function BindCntReject(_callback){
    try {

      let token = "";
      token = localStorage.getItem("TStoken");
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + token);
      myHeaders.append("Content-Type", "application/json");
      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        redirect: "follow",
      };

      const response = await fetch(
        configData.API_URL + "Timesheet_GetCountReject",
        requestOptions
      );

      const json = await response.json();
      if (json.status_ID === 1) {
        setCntReject(json.countreject);
        if (_callback != null) {
            _callback();
        }
      }
      else if (json.status_ID === 2) 
      {
        Class_ETC_SessionTimeOut();
      }
      else{
        setCntReject(0);
        if (_callback != null) {
            _callback();
        }
      }
    } catch {
      setCntReject(0);
      if (_callback != null) {
          _callback();
      }
    }
  }

  async function BindDDLTask(_callback){
    try {
      let token = "";
      token = localStorage.getItem("TStoken");
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + token);
      myHeaders.append("Content-Type", "application/json");
      
      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        redirect: "follow",
      };

      const response = await fetch(
        configData.API_URL + "Task_GetDDLGroup",
        requestOptions
      );

      const json = await response.json();
      if (json.status_ID === 1) {
        if (json.total_Data > 0) {
          setListddlTask([
              {
                rowindex : 0  ,value: -1, label: ConfigETC.ddl_pleaseselect
              },  ...json.data]);
        } else {
          setListddlTask([]);
        }
        if (_callback != null) {
            _callback();
        }
      }
      else{
        setListddlTask([]);
        if (_callback != null) {
            _callback();
        }
      }
    } catch {
      setListddlTask([]);
      if (_callback != null) {
          _callback();
      }
    }
  }
  
  function BindListcalendarBar(week_beforeafter , slidesToslide , act , _callback) {
    
    BindListCalendarBarAPI(week_beforeafter , slidesToslide , act , 0 , null , null , null , null , null , null , null , function() {
      if (_callback != null) {
          _callback();
      }
    });

  }
  
  async function BindListCalendarBarAPI(week_beforeafter , slidesToslide , act , _issearch,
                                        ValueStatus , ValueProject, ValueCus , ValueTimeoff , ValueTask , 
                                        ValueDateStart , ValueDataEnd ,
                                        _callback){
    try {
      let token = "";
      token = localStorage.getItem("TStoken");
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + token);
      myHeaders.append("Content-Type", "application/json");
      
      var raw;
      let response;
      var requestOptions;

      if (_issearch === 1)
      {
        raw = JSON.stringify({
          "search_date_start": ValueDateStart,
          "search_date_end": ValueDataEnd,
          "search_project": ValueProject,
          "search_task": ValueTask,
          "search_timeoff": ValueTimeoff,
          "search_stauts": ValueStatus,
          "search_staff_code": searchValueStaff,
          "search_cus" : ValueCus,
        });

        setSearchValuedateS(ValueDateStart);
        setSearchValuedateE(ValueDataEnd);
        setSearchValueProject(ValueProject);
        setSearchValueCus(ValueCus);
        setSearchValueTimeoff(ValueTimeoff);
        setSearchValuestatus(ValueStatus);
        setSearchValueTask(ValueTask);

        requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow",
        };
  
        response = await fetch(
          configData.API_URL + "Timesheet_Getcalendarlist_Search",
          requestOptions
        );

      }
      else {


        raw = JSON.stringify({
          "week_beforeafter": week_beforeafter,
          "slidesToslide": slidesToslide
        });

        requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow",
        };
  
        response = await fetch(
          configData.API_URL + "Timesheet_Getcalendarlist",
          requestOptions
        );

      }


      const json = await response.json();
      if (json.status_ID === 1) {
        if (json.total_Data > 0) {
          if (act === "next")
          {
            setListcalendar(listcalendar => [...listcalendar,  ...json.data]);
            if (_callback != null) {
                _callback();
            }
          }
          else if (act === "previous")
          {
            setListcalendar(listcalendar => [...json.data , ...listcalendar]);
            if (_callback != null) {
                _callback();
            }
          }
          else
          {
            setPreviousSlide(previousSlide_default);
            setNowSlide(nowSlide_default);
            setNextSlide(nextSlide_default);
            setChecknextSlide(checknextSlide_default);
            setListcalendar(json.data);
            
            let DS = "";
            let uid = "";

            if (_issearch === 1)
            {
              DS = json.data[json.total_Data - 1].date_Start;
              uid = json.data[json.total_Data - 1].uniqueid;
            }
            else
            {
              DS = json.data[0].date_weektoday;
              uid = json.data[0].uniqueid_today;
            }

            if (DS !== "")
            {
              setIsshowDetailTs(true);
              setCalendaractive(uid);
              const Vssp = json.data.filter(e => e.uniqueid === uid);
              BindsetValueSSP(Vssp[0].sun 
                , Vssp[0].mon 
                , Vssp[0].tue 
                , Vssp[0].wed 
                , Vssp[0].thu 
                , Vssp[0].fri 
                , Vssp[0].sat);
                BindsetValueisHoliday(Vssp[0].isholiday_sun
                                    , Vssp[0].isholiday_mon
                                    , Vssp[0].isholiday_tue
                                    , Vssp[0].isholiday_wed
                                    , Vssp[0].isholiday_thu
                                    , Vssp[0].isholiday_fri
                                    , Vssp[0].isholiday_sat);

                                    
                BindsetValuedt(Vssp[0].dt_date_sun
                  , Vssp[0].dt_date_mon
                  , Vssp[0].dt_date_tue
                  , Vssp[0].dt_date_wed
                  , Vssp[0].dt_date_thu
                  , Vssp[0].dt_date_fri
                  , Vssp[0].dt_date_sat
                  , Vssp[0].dt_Full_sun
                  , Vssp[0].dt_Full_mon
                  , Vssp[0].dt_Full_tue
                  , Vssp[0].dt_Full_wed
                  , Vssp[0].dt_Full_thu
                  , Vssp[0].dt_Full_fri
                  , Vssp[0].dt_Full_sat)


              BindListCalenderByProject(DS ,
                                        _issearch , 
                                        ValueDateStart , 
                                        ValueDataEnd ,
                                        ValueProject ,
                                        ValueCus , 
                                        ValueTimeoff ,
                                        ValueStatus ,
                                        ValueTask  , 
                                        function() {
                
                if (_issearch === 1)
                {
                  let cntitem = 0
                  if (window.innerWidth < tabletmax)
                  {
                    cntitem = itemstablet;
                  }
                  else
                  {
                    cntitem = itemsdesktop;
                  }
                  
                  if (json.total_Data - cntitem > 0)
                  {
                    document.getElementById("hd_Slideindex_Goto").value = json.total_Data - cntitem
                    setIsLoadGoto(true)
                    // ไม่ต้อง callback เพราะ เดี๋ยวมันจะ ปิด progress ที่ฝั่ง IsLoadGoto บน useeffect เอง
                  }
                  else
                  {
                    if (_callback != null) {
                      _callback();
                    }
                  }
                }
                else
                {
                  if (_callback != null) {
                    _callback();
                  }
                }
              });
            }
            else
            {
              if (_callback != null) {
                  _callback();
              }
            }

          }

        } else {
          setIsshowDetailTs(false);
          setListcalendar([]);
          setListcalendarbyproject([]);
          if (_callback != null) {
              _callback();
          }
        }
      }
      else if (json.status_ID === 2) 
      {
        Class_ETC_SessionTimeOut();
      }
      else
      {
        setIsshowDetailTs(false);
        setListcalendar([]);
        setListcalendarbyproject([]);
        if (_callback != null) {
            _callback();
        }
      }
    } catch {
      setIsshowDetailTs(false);
      setListcalendar([]);
      setListcalendarbyproject([]);
      if (_callback != null) {
        _callback();
      }
    }


  }

  function Clearsummary_wtot()
  {

    setSummary_wtot(
    {
      total_wt_sun: 0,
      total_ot_sun: 0,
      total_wt_time_hr_sun: "0",
      total_wt_time_mm_sun: "0",
      total_ot_time_hr_sun: "0",
      total_ot_time_mm_sun: "0",
      
      total_wt_mon: 0,
      total_ot_mon: 0,
      total_wt_time_hr_mon: "0",
      total_wt_time_mm_mon: "0",
      total_ot_time_hr_mon: "0",
      total_ot_time_mm_mon: "0",
  
      total_wt_tue: 0,
      total_ot_tue: 0,
      total_wt_time_hr_tue: "0",
      total_wt_time_mm_tue: "0",
      total_ot_time_hr_tue: "0",
      total_ot_time_mm_tue: "0",
  
      total_wt_wed: 0,
      total_ot_wed: 0,
      total_wt_time_hr_wed: "0",
      total_wt_time_mm_wed: "0",
      total_ot_time_hr_wed: "0",
      total_ot_time_mm_wed: "0",
  
      total_wt_thu: 0,
      total_ot_thu: 0,
      total_wt_time_hr_thu: "0",
      total_wt_time_mm_thu: "0",
      total_ot_time_hr_thu: "0",
      total_ot_time_mm_thu: "0",
  
      total_wt_fri: 0,
      total_ot_fri: 0,
      total_wt_time_hr_fri: "0",
      total_wt_time_mm_fri: "0",
      total_ot_time_hr_fri: "0",
      total_ot_time_mm_fri: "0",
  
      total_wt_sat: 0,
      total_ot_sat: 0,
      total_wt_time_hr_sat: "0",
      total_wt_time_mm_sat: "0",
      total_ot_time_hr_sat: "0",
      total_ot_time_mm_sat: "0",
  
      totalall_wt: 0,
      totalall_ot: 0,
      totalall_wt_time_hr: "0",
      totalall_wt_time_mm: "0",
      totalall_ot_time_hr: "0",
      totalall_ot_time_mm: "0",
  
    });
  }

  async function BindListCalenderByProject(date_Start , 
                                            _issearch , 
                                            _searchdateS , 
                                            _searchdateE , 
                                            _searchProject ,
                                            _searchcus,
                                            _searchTimeoff , 
                                            _searchstatus ,
                                            _searchTask ,
                                           _callback){

    try {
      let token = "";
      token = localStorage.getItem("TStoken");
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + token);
      myHeaders.append("Content-Type", "application/json");
      var raw;

      if (_issearch === 1)
      {
        raw = JSON.stringify({
          "start_date": date_Start ,
          "search_project": _searchProject,
          "search_task": _searchTask,
          "search_timeoff": _searchTimeoff,
          "search_stauts": _searchstatus,
          "search_staff_code": searchValueStaff,
          "search_date_start": _searchdateS,
          "search_date_end": _searchdateE,
          "search_cus" : _searchcus

        });
      }
      else
      {
        raw = JSON.stringify({
          "start_date": date_Start
        });
      }

      setListcalendarbyproject([]);
      Clearsummary_wtot();
      setStart_date_byproject(date_Start);
      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      let response;
      if (_issearch === 1)
      {
        response = await fetch(
          configData.API_URL + "Timesheet_GetcalendarByProject_Search",
          requestOptions
        );
      }
      else
      {
        response = await fetch(
          configData.API_URL + "Timesheet_GetcalendarByProject",
          requestOptions
        );
      }

      datatext_Projectday(date_Start);
      const json = await response.json();
      setIsshowDetailTs(true);
      if (json.status_ID === 1) {
        if (json.total_Data > 0) {
          
          setSummary_wtot(
            {
              total_wt_sun: json.data[0].total_wt_sun,
              total_ot_sun: json.data[0].total_ot_sun,
              total_wt_time_hr_sun: json.data[0].total_wt_time_hr_sun,
              total_wt_time_mm_sun: json.data[0].total_wt_time_mm_sun,
              total_ot_time_hr_sun: json.data[0].total_ot_time_hr_sun,
              total_ot_time_mm_sun: json.data[0].total_ot_time_mm_sun,
              
              total_wt_mon: json.data[0].total_wt_mon,
              total_ot_mon: json.data[0].total_ot_mon,
              total_wt_time_hr_mon: json.data[0].total_wt_time_hr_mon,
              total_wt_time_mm_mon: json.data[0].total_wt_time_mm_mon,
              total_ot_time_hr_mon: json.data[0].total_ot_time_hr_mon,
              total_ot_time_mm_mon: json.data[0].total_ot_time_mm_mon,
          
              total_wt_tue: json.data[0].total_wt_tue,
              total_ot_tue: json.data[0].total_ot_tue,
              total_wt_time_hr_tue: json.data[0].total_wt_time_hr_tue,
              total_wt_time_mm_tue: json.data[0].total_wt_time_mm_tue,
              total_ot_time_hr_tue: json.data[0].total_ot_time_hr_tue,
              total_ot_time_mm_tue: json.data[0].total_ot_time_mm_tue,
          
              total_wt_wed: json.data[0].total_wt_wed,
              total_ot_wed: json.data[0].total_ot_wed,
              total_wt_time_hr_wed: json.data[0].total_wt_time_hr_wed,
              total_wt_time_mm_wed: json.data[0].total_wt_time_mm_wed,
              total_ot_time_hr_wed: json.data[0].total_ot_time_hr_wed,
              total_ot_time_mm_wed: json.data[0].total_ot_time_mm_wed,
          
              total_wt_thu: json.data[0].total_wt_thu,
              total_ot_thu: json.data[0].total_ot_thu,
              total_wt_time_hr_thu: json.data[0].total_wt_time_hr_thu,
              total_wt_time_mm_thu: json.data[0].total_wt_time_mm_thu,
              total_ot_time_hr_thu: json.data[0].total_ot_time_hr_thu,
              total_ot_time_mm_thu: json.data[0].total_ot_time_mm_thu,
          
              total_wt_fri: json.data[0].total_wt_fri,
              total_ot_fri: json.data[0].total_ot_fri,
              total_wt_time_hr_fri: json.data[0].total_wt_time_hr_fri,
              total_wt_time_mm_fri: json.data[0].total_wt_time_mm_fri,
              total_ot_time_hr_fri: json.data[0].total_ot_time_hr_fri,
              total_ot_time_mm_fri: json.data[0].total_ot_time_mm_fri,
          
              total_wt_sat: json.data[0].total_wt_sat,
              total_ot_sat: json.data[0].total_ot_sat,
              total_wt_time_hr_sat: json.data[0].total_wt_time_hr_sat,
              total_wt_time_mm_sat: json.data[0].total_wt_time_mm_sat,
              total_ot_time_hr_sat: json.data[0].total_ot_time_hr_sat,
              total_ot_time_mm_sat: json.data[0].total_ot_time_mm_sat,
          
              totalall_wt: json.data[0].totalall_wt,
              totalall_ot: json.data[0].totalall_ot,
              totalall_wt_time_hr: json.data[0].totalall_wt_time_hr,
              totalall_wt_time_mm: json.data[0].totalall_wt_time_mm,
              totalall_ot_time_hr: json.data[0].totalall_ot_time_hr,
              totalall_ot_time_mm: json.data[0].totalall_ot_time_mm,
            });
          setListcalendarbyproject(json.data);
          setIscntreset_TSCall_DP(iscntreset_TSCall_DP + 1)
          if (_callback != null) {
              _callback();
          }
        } else {
          setListcalendarbyproject([]);
          datatext_Projectday(date_Start);
          if (_callback != null) {
                _callback();
            }
          }
      }
      else if (json.status_ID === 2) 
      {
        Class_ETC_SessionTimeOut();
      }
      else
      {
        setListcalendarbyproject([]);
          datatext_Projectday(date_Start);
          if (_callback != null) {
            _callback();
        }
      }
    } catch {
      setListcalendarbyproject([]);
      datatext_Projectday(date_Start);
      if (_callback != null) {
      _callback();
      }
    }

  }

  function datatext_Projectday(date_Start){

    let dayicon = "";
    document.getElementById("span_day_sun").innerHTML = document.getElementById("hdCBP_dt_sun").value.substring(0,2);
    dayicon = (document.getElementById("hdCBP_dt_sun").value === dateToday ? "sun" : dayicon);

    document.getElementById("span_day_mon").innerHTML = document.getElementById("hdCBP_dt_mon").value.substring(0,2);
    dayicon = (document.getElementById("hdCBP_dt_mon").value === dateToday ? "mon" : dayicon);

    document.getElementById("span_day_tue").innerHTML = document.getElementById("hdCBP_dt_tue").value.substring(0,2);
    dayicon = (document.getElementById("hdCBP_dt_tue").value === dateToday ? "tue" : dayicon);

    document.getElementById("span_day_wed").innerHTML = document.getElementById("hdCBP_dt_wed").value.substring(0,2);
    dayicon = (document.getElementById("hdCBP_dt_wed").value === dateToday ? "wed" : dayicon);

    document.getElementById("span_day_thu").innerHTML = document.getElementById("hdCBP_dt_thu").value.substring(0,2);
    dayicon = (document.getElementById("hdCBP_dt_thu").value === dateToday ? "thu" : dayicon);

    document.getElementById("span_day_fri").innerHTML = document.getElementById("hdCBP_dt_fri").value.substring(0,2);
    dayicon = (document.getElementById("hdCBP_dt_fri").value === dateToday ? "fri" : dayicon);

    document.getElementById("span_day_sat").innerHTML = document.getElementById("hdCBP_dt_sat").value.substring(0,2);
    dayicon = (document.getElementById("hdCBP_dt_sat").value === dateToday ? "sat" : dayicon);
    setIcontoday(dayicon);
    
  }

  function BindsetValueSSP(sspsun, sspmon, ssptue, sspwed, sspthu, sspfri, sspsat){
    setSsp_sun(sspsun);
    setSsp_mon(sspmon);
    setSsp_tue(ssptue);
    setSsp_wed(sspwed);
    setSsp_thu(sspthu);
    setSsp_fri(sspfri);
    setSsp_sat(sspsat);
  }
  
  function BindsetValueisHoliday(isholiday_sun, isholiday_mon, isholiday_tue, isholiday_wed, isholiday_thu, isholiday_fri, isholiday_sat)
  {
    setIsholiday_sun(isholiday_sun);
    setIsholiday_mon(isholiday_mon);
    setIsholiday_tue(isholiday_tue);
    setIsholiday_wed(isholiday_wed);
    setIsholiday_thu(isholiday_thu);
    setIsholiday_fri(isholiday_fri);
    setIsholiday_sat(isholiday_sat);
  }
  
  function BindsetValuedt(dt_sun, dt_mon, dt_tue, dt_wed, dt_thu, dt_fri, dt_sat , dt_Full_sun, dt_Full_mon, dt_Full_tue, dt_Full_wed, dt_Full_thu, dt_Full_fri, dt_Full_sat)
  {
    
    setDt_sun(dt_sun)
    setDt_mon(dt_mon)
    setDt_tue(dt_tue)
    setDt_wed(dt_wed)
    setDt_thu(dt_thu)
    setDt_fri(dt_fri)
    setDt_sat(dt_sat)

    document.getElementById("hdCBP_dt_sun").value = dt_sun
    document.getElementById("hdCBP_dt_mon").value = dt_mon
    document.getElementById("hdCBP_dt_tue").value = dt_tue
    document.getElementById("hdCBP_dt_wed").value = dt_wed
    document.getElementById("hdCBP_dt_thu").value = dt_thu
    document.getElementById("hdCBP_dt_fri").value = dt_fri
    document.getElementById("hdCBP_dt_sat").value = dt_sat
    
    setDt_Full_sun(dt_Full_sun)
    setDt_Full_mon(dt_Full_mon)
    setDt_Full_tue(dt_Full_tue)
    setDt_Full_wed(dt_Full_wed)
    setDt_Full_thu(dt_Full_thu)
    setDt_Full_fri(dt_Full_fri)
    setDt_Full_sat(dt_Full_sat)
  

  }

  function BindChangStatusDay(ssun, smon, stue, swed, sthu, sfri, ssat)
  {

    //เอา Data ที่เพิ่งได้มา ยัดใส่ arry
    setListcalendar(list => {
      const itemIndex = list.findIndex(item => item.uniqueid === calendaractive)
      return [...list.slice(0, itemIndex), 
      { 
        ...list[itemIndex],
        "sun": ssun,
        "mon": smon,
        "tue": stue,
        "wed": swed,
        "thu": sthu,
        "fri": sfri,
        "sat": ssat,
      }, ...list.slice(itemIndex + 1),
      ]
    })
  }

  function SelectFocas(act){
    let id = document.getElementById("hd_moal_idfocus").value
    if (id === "project")
    {
      selectRef_Project.current?.focus()
    }
    else if (id === "task")
    {
      selectRef_Task.current?.focus()
    }
    else
    {
      selectRef_Timeoff.current?.focus()
    }

  }
  
  const onValueChange_modelTS_Expenses = (newValue , act) => {
    if (newValue === undefined) {
      if (act === "Extra")
      {
        setData_modalTS_Extra(0.00);
      }
      else if (act === "Travel")
      {
        setData_modalTS_Travel(0.00);
      }
      else if (act === "Extra_day")
      {
        setData_modalTS_Extra_day(0);
      }
      else if (act === "Travel_distance")
      {
        setData_modalTS_Travel_distance(0.00);
      }
      else
      {
        setData_modalTS_Other(0.00);
      }
    } else {
      if (act === "Extra")
      {
        setData_modalTS_Extra(newValue);
      }
      else if (act === "Travel")
      {
        setData_modalTS_Travel(newValue);
      }
      else if (act === "Extra_day")
      {
        setData_modalTS_Extra_day(newValue);
      }
      else if (act === "Travel_distance")
      {
        setData_modalTS_Travel_distance(newValue);
      }
      else
      {
        setData_modalTS_Other(newValue);
      }
    }
  }

  async function SaveTimeSheet(ts_id
                        ,ts_date
                        ,pro_id
                        ,task_id
                        ,timeoff_id
                        ,worktime
                        ,overtime
                        ,extra
                        ,travel
                        ,other
                        
                        ,extra_day
                        ,travel_distance
                        
                        ,desc
                        ,issubmit
                        ,istypesave
                        ,day
                        ,rowindex
                        ,_isresult
                        ,_callback){

                   

      try {
        setIsLoadProgress(true);
        
        let wt = convertTimeToMinutes(worktime);
        let ot = convertTimeToMinutes(overtime);

        let token = "";
        token = localStorage.getItem("TStoken");
        var myHeaders = new Headers();
        myHeaders.append("Authorization", "Bearer " + token);
        myHeaders.append("Content-Type", "application/json");
        
        var raw;
        if (issearch === 1)
        {
          raw = JSON.stringify({
            "ts_id": ts_id.toString(),
            "ts_date": ts_date,
            "pro_id": pro_id.toString(),
            "task_id": task_id.toString(),
            "timeoff_id": timeoff_id.toString(),
            "worktime": wt.toString(),
            "overtime": ot.toString(),
            "extra": extra.toString(),
            "travel": travel.toString(),
            "other": other.toString(),
            "desc": desc,
            "issubmit": issubmit,
            "istypesave": istypesave,
            "extra_day": extra_day.toString(),
            "travel_distance": travel_distance.toString(),
            "search_project": searchValueProject,
            "search_task": searchValueTask,
            "search_timeoff": searchValueTimeoff,
            "search_stauts": searchValuestatus,
            "search_date_start": searchValuedateS,
            "search_date_end": searchValuedateE,
            "search_cus": searchValueCus
          });
        }
        else{
          raw = JSON.stringify({
            "ts_id": ts_id.toString(),
            "ts_date": ts_date,
            "pro_id": pro_id.toString(),
            "task_id": task_id.toString(),
            "timeoff_id": timeoff_id.toString(),
            "worktime": wt.toString(),
            "overtime": ot.toString(),
            "extra": extra.toString(),
            "travel": travel.toString(),
            "other": other.toString(),
            "desc": desc,
            "issubmit": issubmit,
            "istypesave": istypesave,
            "extra_day": extra_day.toString(),
            "travel_distance": travel_distance.toString()
          });
        }
        

        var requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow",
        };

        
        let response;
        if (issearch === 1)
        {
          response = await fetch(
            configData.API_URL + "Timesheet_SaveSearch",
            requestOptions
          );
        }
        else
        {
          response = await fetch(
            configData.API_URL + "Timesheet_Save",
            requestOptions
          );
        }

        const json = await response.json();
        if (_isresult != null)
        {
          _isresult.result = json.status_ID;
        }
        if (json.status_ID === 1) {
          

          //เอา Data ที่เพิ่งได้มา ยัดใส่ arry
          setListcalendarbyproject(list => {
            const itemIndex = list.findIndex(item => item.rowindex === rowindex)
            if (day.toLowerCase() === "sun")
            {
              return [...list.slice(0, itemIndex), 
              { 
			          ...list[itemIndex],
                "tsid_sun" : json.tsid,
                "wt_time_sun": json.wt_time,
                "ot_time_sun": json.ot_time,
                "ot_sun": json.ot,
                "wt_sun": json.wt,
                "tte_sun": json.tte,
                "ee_sun": json.ee,
                "et_sun": json.et,
                "eo_sun": json.eo,
                "eed_sun": json.eed,
                "etd_sun": json.etd,
                "desc_sun": json.ts_desc,
                "tss_sun": json.tss,
                "tsssn_sun": json.tsssn,
                "ud_sun": json.ud,
                "usn_sun": json.usn,
                "tsd_sun": json.tsd,
                "act_edit_sun": json.act_edit,
                "act_cancel_sun": json.act_cancel,
                "act_del_sun": json.act_del,
                "actproject_sun": "Edit",
                "totalweek_wtot_time_hr" : json.totalweek_wtot_time_hr,
                "totalweek_wtot_time_mm" : json.totalweek_wtot_time_mm
              }, ...list.slice(itemIndex + 1),
              ]
            }
            else if (day.toLowerCase() === "mon")
            {
              return [...list.slice(0, itemIndex), 
              {
			          ...list[itemIndex],
                "tsid_mon" : json.tsid,
                "wt_time_mon": json.wt_time,
                "ot_time_mon": json.ot_time,
                "ot_mon": json.ot,
                "wt_mon": json.wt,
                "tte_mon": json.tte,
                "ee_mon": json.ee,
                "et_mon": json.et,
                "eo_mon": json.eo,
                "eed_mon": json.eed,
                "etd_mon": json.etd,
                "desc_mon": json.ts_desc,
                "tss_mon": json.tss,
                "tsssn_mon": json.tsssn,
                "ud_mon": json.ud,
                "usn_mon": json.usn,
                "tsd_mon": json.tsd,
                "act_edit_mon": json.act_edit,
                "act_cancel_mon": json.act_cancel,
                "act_del_mon": json.act_del,
                "actproject_mon": "Edit",
                "totalweek_wtot_time_hr" : json.totalweek_wtot_time_hr,
                "totalweek_wtot_time_mm" : json.totalweek_wtot_time_mm
              }, ...list.slice(itemIndex + 1),
              ]
            }
            else if (day.toLowerCase() === "tue")
            {
              return [...list.slice(0, itemIndex), 
              {
			          ...list[itemIndex],
                "tsid_tue" : json.tsid,
                "wt_time_tue": json.wt_time,
                "ot_time_tue": json.ot_time,
                "ot_tue": json.ot,
                "wt_tue": json.wt,
                "tte_tue": json.tte,
                "ee_tue": json.ee,
                "et_tue": json.et,
                "eo_tue": json.eo,
                "eed_tue": json.eed,
                "etd_tue": json.etd,
                "desc_tue": json.ts_desc,
                "tss_tue": json.tss,
                "tsssn_tue": json.tsssn,
                "ud_tue": json.ud,
                "usn_tue": json.usn,
                "tsd_tue": json.tsd,
                "act_edit_tue": json.act_edit,
                "act_cancel_tue": json.act_cancel,
                "act_del_tue": json.act_del,
                "actproject_tue": "Edit",
                "totalweek_wtot_time_hr" : json.totalweek_wtot_time_hr,
                "totalweek_wtot_time_mm" : json.totalweek_wtot_time_mm
              }, ...list.slice(itemIndex + 1),
              ]
            }
            else if (day.toLowerCase() === "wed")
            {
              return [...list.slice(0, itemIndex),
              { 
			          ...list[itemIndex],
                "tsid_wed" : json.tsid,
                "wt_time_wed": json.wt_time,
                "ot_time_wed": json.ot_time,
                "ot_wed": json.ot,
                "wt_wed": json.wt,
                "tte_wed": json.tte,
                "ee_wed": json.ee,
                "et_wed": json.et,
                "eo_wed": json.eo,
                "eed_wed": json.eed,
                "etd_wed": json.etd,
                "desc_wed": json.ts_desc,
                "tss_wed": json.tss,
                "tsssn_wed": json.tsssn,
                "ud_wed": json.ud,
                "usn_wed": json.usn,
                "tsd_wed": json.tsd,
                "act_edit_wed": json.act_edit,
                "act_cancel_wed": json.act_cancel,
                "act_del_wed": json.act_del,
                "actproject_wed": "Edit",
                "totalweek_wtot_time_hr" : json.totalweek_wtot_time_hr,
                "totalweek_wtot_time_mm" : json.totalweek_wtot_time_mm
              }, ...list.slice(itemIndex + 1),
              ]
            }
            else if (day.toLowerCase() === "thu")
            {
              return [...list.slice(0, itemIndex), 
              {
			          ...list[itemIndex],
                "tsid_thu" : json.tsid,
                "wt_time_thu": json.wt_time,
                "ot_time_thu": json.ot_time,
                "ot_thu": json.ot,
                "wt_thu": json.wt,
                "tte_thu": json.tte,
                "ee_thu": json.ee,
                "et_thu": json.et,
                "eo_thu": json.eo,
                "eed_thu": json.eed,
                "etd_thu": json.etd,
                "desc_thu": json.ts_desc,
                "tss_thu": json.tss,
                "tsssn_thu": json.tsssn,
                "ud_thu": json.ud,
                "usn_thu": json.usn,
                "tsd_thu": json.tsd,
                "act_edit_thu": json.act_edit,
                "act_cancel_thu": json.act_cancel,
                "act_del_thu": json.act_del,
                "actproject_thu": "Edit",
                "totalweek_wtot_time_hr" : json.totalweek_wtot_time_hr,
                "totalweek_wtot_time_mm" : json.totalweek_wtot_time_mm
              }, ...list.slice(itemIndex + 1),
              ]
            }
            else if (day.toLowerCase() === "fri")
            {
              return [...list.slice(0, itemIndex), 
              {
			          ...list[itemIndex],
                "tsid_fri" : json.tsid,
                "wt_time_fri": json.wt_time,
                "ot_time_fri": json.ot_time,
                "ot_fri": json.ot,
                "wt_fri": json.wt,
                "tte_fri": json.tte,
                "ee_fri": json.ee,
                "et_fri": json.et,
                "eo_fri": json.eo,
                "eed_fri": json.eed,
                "etd_fri": json.etd,
                "desc_fri": json.ts_desc,
                "tss_fri": json.tss,
                "tsssn_fri": json.tsssn,
                "ud_fri": json.ud,
                "usn_fri": json.usn,
                "tsd_fri": json.tsd,
                "act_edit_fri": json.act_edit,
                "act_cancel_fri": json.act_cancel,
                "act_del_fri": json.act_del,
                "actproject_fri": "Edit",
                "totalweek_wtot_time_hr" : json.totalweek_wtot_time_hr,
                "totalweek_wtot_time_mm" : json.totalweek_wtot_time_mm
              }, ...list.slice(itemIndex + 1),
              ]
            }
            else
            {
              return [...list.slice(0, itemIndex), 
              {
			          ...list[itemIndex],
                "tsid_sat" : json.tsid,
                "wt_time_sat": json.wt_time,
                "ot_time_sat": json.ot_time,
                "ot_sat": json.ot,
                "wt_sat": json.wt,
                "tte_sat": json.tte,
                "ee_sat": json.ee,
                "et_sat": json.et,
                "eo_sat": json.eo,
                "eed_sat": json.eed,
                "etd_sat": json.etd,
                "desc_sat": json.ts_desc,
                "tss_sat": json.tss,
                "tsssn_sat": json.tsssn,
                "ud_sat": json.ud,
                "usn_sat": json.usn,
                "tsd_sat": json.tsd,
                "act_edit_sat": json.act_edit,
                "act_cancel_sat": json.act_cancel,
                "act_del_sat": json.act_del,
                "actproject_sat": "Edit",
                "totalweek_wtot_time_hr" : json.totalweek_wtot_time_hr,
                "totalweek_wtot_time_mm" : json.totalweek_wtot_time_mm
              }, ...list.slice(itemIndex + 1),
              ]
            }
          })

          //ทำการ คำนวณ ชั่วโมง นาทีใหม่
          setListcalendarbyproject(list => {
            const itemIndex = 0
			      let total_wt = json.total_wt;
            let total_ot = json.total_ot;
            let total_wt_time_hr = json.total_wt_time_hr;
            let total_wt_time_mm = json.total_wt_time_mm;
            let total_ot_time_hr = json.total_ot_time_hr;
            let total_ot_time_mm = json.total_ot_time_mm;
                        
            let totalall_wt = json.totalall_wt;
            let totalall_ot = json.totalall_ot;
            let totalall_wt_time_hr = json.totalall_wt_time_hr;
            let totalall_wt_time_mm = json.totalall_wt_time_mm;
            let totalall_ot_time_hr = json.totalall_ot_time_hr;
            let totalall_ot_time_mm = json.totalall_ot_time_mm;

            if (day.toLowerCase() === "sun")
            {
              return [...list.slice(0, itemIndex), 
              {
			          ...list[itemIndex],
                "total_wt_sun" : total_wt,
                "total_ot_sun" : total_ot,
                "total_wt_time_hr_sun" : total_wt_time_hr,
                "total_wt_time_mm_sun" : total_wt_time_mm,
                "total_ot_time_hr_sun" : total_ot_time_hr,
                "total_ot_time_mm_sun" : total_ot_time_mm,
                "totalall_wt" : totalall_wt,
                "totalall_ot" : totalall_ot,
                "totalall_wt_time_hr" : totalall_wt_time_hr,
                "totalall_wt_time_mm" : totalall_wt_time_mm,
                "totalall_ot_time_hr" : totalall_ot_time_hr,
                "totalall_ot_time_mm" : totalall_ot_time_mm,

              }, ...list.slice(itemIndex + 1),
              ]
            }
            else if (day.toLowerCase() === "mon")
            {
              return [...list.slice(0, itemIndex), 
              {
			          ...list[itemIndex],
                "total_wt_mon" : total_wt,
                "total_ot_mon" : total_ot,
                "total_wt_time_hr_mon" : total_wt_time_hr,
                "total_wt_time_mm_mon" : total_wt_time_mm,
                "total_ot_time_hr_mon" : total_ot_time_hr,
                "total_ot_time_mm_mon" : total_ot_time_mm,
                "totalall_wt" : totalall_wt,
                "totalall_ot" : totalall_ot,
                "totalall_wt_time_hr" : totalall_wt_time_hr,
                "totalall_wt_time_mm" : totalall_wt_time_mm,
                "totalall_ot_time_hr" : totalall_ot_time_hr,
                "totalall_ot_time_mm" : totalall_ot_time_mm,
              }, ...list.slice(itemIndex + 1),
              ]
            }
            else if (day.toLowerCase() === "tue")
            {
              return [...list.slice(0, itemIndex), 
              {
			          ...list[itemIndex],
                "total_wt_tue" : total_wt,
                "total_ot_tue" : total_ot,
                "total_wt_time_hr_tue" : total_wt_time_hr,
                "total_wt_time_mm_tue" : total_wt_time_mm,
                "total_ot_time_hr_tue" : total_ot_time_hr,
                "total_ot_time_mm_tue" : total_ot_time_mm,
                "totalall_wt" : totalall_wt,
                "totalall_ot" : totalall_ot,
                "totalall_wt_time_hr" : totalall_wt_time_hr,
                "totalall_wt_time_mm" : totalall_wt_time_mm,
                "totalall_ot_time_hr" : totalall_ot_time_hr,
                "totalall_ot_time_mm" : totalall_ot_time_mm,
              }, ...list.slice(itemIndex + 1),
              ]
            }
            else if (day.toLowerCase() === "wed")
            {
              return [...list.slice(0, itemIndex),
              { 
			          ...list[itemIndex],
                "total_wt_wed" : total_wt,
                "total_ot_wed" : total_ot,
                "total_wt_time_hr_wed" : total_wt_time_hr,
                "total_wt_time_mm_wed" : total_wt_time_mm,
                "total_ot_time_hr_wed" : total_ot_time_hr,
                "total_ot_time_mm_wed" : total_ot_time_mm,
                "totalall_wt" : totalall_wt,
                "totalall_ot" : totalall_ot,
                "totalall_wt_time_hr" : totalall_wt_time_hr,
                "totalall_wt_time_mm" : totalall_wt_time_mm,
                "totalall_ot_time_hr" : totalall_ot_time_hr,
                "totalall_ot_time_mm" : totalall_ot_time_mm,
              }, ...list.slice(itemIndex + 1),
              ]
            }
            else if (day.toLowerCase() === "thu")
            {
              return [...list.slice(0, itemIndex), 
              {
			          ...list[itemIndex],
                "total_wt_thu" : total_wt,
                "total_ot_thu" : total_ot,
                "total_wt_time_hr_thu" : total_wt_time_hr,
                "total_wt_time_mm_thu" : total_wt_time_mm,
                "total_ot_time_hr_thu" : total_ot_time_hr,
                "total_ot_time_mm_thu" : total_ot_time_mm,
                "totalall_wt" : totalall_wt,
                "totalall_ot" : totalall_ot,
                "totalall_wt_time_hr" : totalall_wt_time_hr,
                "totalall_wt_time_mm" : totalall_wt_time_mm,
                "totalall_ot_time_hr" : totalall_ot_time_hr,
                "totalall_ot_time_mm" : totalall_ot_time_mm,
              }, ...list.slice(itemIndex + 1),
              ]
            }
            else if (day.toLowerCase() === "fri")
            {
              return [...list.slice(0, itemIndex), 
              {
			          ...list[itemIndex],
                "total_wt_fri" : total_wt,
                "total_ot_fri" : total_ot,
                "total_wt_time_hr_fri" : total_wt_time_hr,
                "total_wt_time_mm_fri" : total_wt_time_mm,
                "total_ot_time_hr_fri" : total_ot_time_hr,
                "total_ot_time_mm_fri" : total_ot_time_mm,
                "totalall_wt" : totalall_wt,
                "totalall_ot" : totalall_ot,
                "totalall_wt_time_hr" : totalall_wt_time_hr,
                "totalall_wt_time_mm" : totalall_wt_time_mm,
                "totalall_ot_time_hr" : totalall_ot_time_hr,
                "totalall_ot_time_mm" : totalall_ot_time_mm,
              }, ...list.slice(itemIndex + 1),
              ]
            }
            else
            {
              return [...list.slice(0, itemIndex), 
              {
			          ...list[itemIndex],
                "total_wt_sat" : total_wt,
                "total_ot_sat" : total_ot,
                "total_wt_time_hr_sat" : total_wt_time_hr,
                "total_wt_time_mm_sat" : total_wt_time_mm,
                "total_ot_time_hr_sat" : total_ot_time_hr,
                "total_ot_time_mm_sat" : total_ot_time_mm,
                "totalall_wt" : totalall_wt,
                "totalall_ot" : totalall_ot,
                "totalall_wt_time_hr" : totalall_wt_time_hr,
                "totalall_wt_time_mm" : totalall_wt_time_mm,
                "totalall_ot_time_hr" : totalall_ot_time_hr,
                "totalall_ot_time_mm" : totalall_ot_time_mm,
              }, ...list.slice(itemIndex + 1),
              ]
            }
          })

          //ทำการนำ ชั่วโมง นาที  มาใส่ใน arry
          if (day.toLowerCase() === "sun")
          {
            setSummary_wtot(
            {
              ...summary_wtot,
              total_wt_sun : json.total_wt,
              total_ot_sun : json.total_ot,
              total_wt_time_hr_sun : json.total_wt_time_hr,
              total_wt_time_mm_sun : json.total_wt_time_mm,
              total_ot_time_hr_sun : json.total_ot_time_hr,
              total_ot_time_mm_sun : json.total_ot_time_mm,
              totalall_wt : json.totalall_wt,
              totalall_ot : json.totalall_ot,
              totalall_wt_time_hr : json.totalall_wt_time_hr,
              totalall_wt_time_mm : json.totalall_wt_time_mm,
              totalall_ot_time_hr : json.totalall_ot_time_hr,
              totalall_ot_time_mm : json.totalall_ot_time_mm,
            });
          }
          else if (day.toLowerCase() === "mon")
          {
            setSummary_wtot(
              {
                ...summary_wtot,
                total_wt_mon : json.total_wt,
                total_ot_mon : json.total_ot,
                total_wt_time_hr_mon : json.total_wt_time_hr,
                total_wt_time_mm_mon : json.total_wt_time_mm,
                total_ot_time_hr_mon : json.total_ot_time_hr,
                total_ot_time_mm_mon : json.total_ot_time_mm,
                totalall_wt : json.totalall_wt,
                totalall_ot : json.totalall_ot,
                totalall_wt_time_hr : json.totalall_wt_time_hr,
                totalall_wt_time_mm : json.totalall_wt_time_mm,
                totalall_ot_time_hr : json.totalall_ot_time_hr,
                totalall_ot_time_mm : json.totalall_ot_time_mm,
            });
          }
          else if (day.toLowerCase() === "tue")
          {
            setSummary_wtot(
              {
                ...summary_wtot,
              total_wt_tue : json.total_wt,
              total_ot_tue : json.total_ot,
              total_wt_time_hr_tue : json.total_wt_time_hr,
              total_wt_time_mm_tue : json.total_wt_time_mm,
              total_ot_time_hr_tue : json.total_ot_time_hr,
              total_ot_time_mm_tue : json.total_ot_time_mm,
              totalall_wt : json.totalall_wt,
              totalall_ot : json.totalall_ot,
              totalall_wt_time_hr : json.totalall_wt_time_hr,
              totalall_wt_time_mm : json.totalall_wt_time_mm,
              totalall_ot_time_hr : json.totalall_ot_time_hr,
              totalall_ot_time_mm : json.totalall_ot_time_mm,
            });
          }
          else if (day.toLowerCase() === "wed")
          {
            setSummary_wtot(
              {
                ...summary_wtot,
              total_wt_wed : json.total_wt,
              total_ot_wed : json.total_ot,
              total_wt_time_hr_wed : json.total_wt_time_hr,
              total_wt_time_mm_wed : json.total_wt_time_mm,
              total_ot_time_hr_wed : json.total_ot_time_hr,
              total_ot_time_mm_wed : json.total_ot_time_mm,
              totalall_wt : json.totalall_wt,
              totalall_ot : json.totalall_ot,
              totalall_wt_time_hr : json.totalall_wt_time_hr,
              totalall_wt_time_mm : json.totalall_wt_time_mm,
              totalall_ot_time_hr : json.totalall_ot_time_hr,
              totalall_ot_time_mm : json.totalall_ot_time_mm,
            });
          }
          else if (day.toLowerCase() === "thu")
          {
            setSummary_wtot(
              {
                ...summary_wtot,
              total_wt_thu : json.total_wt,
              total_ot_thu : json.total_ot,
              total_wt_time_hr_thu : json.total_wt_time_hr,
              total_wt_time_mm_thu : json.total_wt_time_mm,
              total_ot_time_hr_thu : json.total_ot_time_hr,
              total_ot_time_mm_thu : json.total_ot_time_mm,
              totalall_wt : json.totalall_wt,
              totalall_ot : json.totalall_ot,
              totalall_wt_time_hr : json.totalall_wt_time_hr,
              totalall_wt_time_mm : json.totalall_wt_time_mm,
              totalall_ot_time_hr : json.totalall_ot_time_hr,
              totalall_ot_time_mm : json.totalall_ot_time_mm,
            });
          }
          else if (day.toLowerCase() === "fri")
          {
            setSummary_wtot(
              {
                ...summary_wtot,
              total_wt_fri : json.total_wt,
              total_ot_fri : json.total_ot,
              total_wt_time_hr_fri : json.total_wt_time_hr,
              total_wt_time_mm_fri : json.total_wt_time_mm,
              total_ot_time_hr_fri : json.total_ot_time_hr,
              total_ot_time_mm_fri : json.total_ot_time_mm,
              totalall_wt : json.totalall_wt,
              totalall_ot : json.totalall_ot,
              totalall_wt_time_hr : json.totalall_wt_time_hr,
              totalall_wt_time_mm : json.totalall_wt_time_mm,
              totalall_ot_time_hr : json.totalall_ot_time_hr,
              totalall_ot_time_mm : json.totalall_ot_time_mm,
            });
          }
          else
          {
            setSummary_wtot(
              {
                ...summary_wtot,
              total_wt_sat : json.total_wt,
              total_ot_sat : json.total_ot,
              total_wt_time_hr_sat : json.total_wt_time_hr,
              total_wt_time_mm_sat : json.total_wt_time_mm,
              total_ot_time_hr_sat : json.total_ot_time_hr,
              total_ot_time_mm_sat : json.total_ot_time_mm,
              totalall_wt : json.totalall_wt,
              totalall_ot : json.totalall_ot,
              totalall_wt_time_hr : json.totalall_wt_time_hr,
              totalall_wt_time_mm : json.totalall_wt_time_mm,
              totalall_ot_time_hr : json.totalall_ot_time_hr,
              totalall_ot_time_mm : json.totalall_ot_time_mm,
            });
          }

          BindsetValueSSP(json.status_sun, json.status_mon, json.status_tue, json.status_wed, json.status_thu, json.status_fri, json.status_sat)
          BindChangStatusDay(json.status_sun, json.status_mon, json.status_tue, json.status_wed, json.status_thu, json.status_fri, json.status_sat);

          BindCntReject(function() {
            if (_callback != null) {
                _callback();
            }
            setIsLoadProgress(false);
            if (istypesave === "popup")
            {
              document.getElementById("modalTS_Close").click();
              Class_ETC_MsgSuccess(MsgDescription.CFM001 , null);
            }
          });

        } 
        else if (json.status_ID === 2) 
        {
          Class_ETC_SessionTimeOut();
        }
        else {
          if (_callback != null) {
              _callback();
          }
          setIsLoadProgress(false);

          if (json.wording_icon === "warning"){
            Class_ETC_MsgWarning(json.status_Desc, null);
          }
          else
          {
            Class_ETC_MsgError(json.status_Desc, null);
          }
        }
      } catch {
        if (_isresult != null)
        {
          _isresult.result = 0;
        }
        if (_callback != null) {
            _callback();
        }
        setIsLoadProgress(false);
        Class_ETC_MsgError(MsgDescription.ERR002, null);
      }
  }

  function BeforeDelTimesheet()
  {

    const _isresult = { result: 0 };
    DelTimesheet(data_modalTS_tsid
      ,data_modalTS_day
      ,data_modalTS_rowindex
      ,"popup"
      ,_isresult
      ,function() {
        if (_isresult.result === 1)
        {
          setIscntreset_TSCall_DP(iscntreset_TSCall_DP + 1)
        }
      })
  }

  async function DelTimesheet(ts_id
                             ,day
                             ,rowindex
                             ,istypedel
                             ,_isresult
                             ,_callback){

    
    try {
      setIsLoadProgress(true);
      
      let token = "";
      token = localStorage.getItem("TStoken");
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + token);
      myHeaders.append("Content-Type", "application/json");
      
      var raw;

      if (issearch === 1)
      {
        raw = JSON.stringify({
          "ts_id": ts_id.toString(),
          "search_project": searchValueProject,
          "search_task": searchValueTask,
          "search_timeoff": searchValueTimeoff,
          "search_stauts": searchValuestatus,
          "search_date_start": searchValuedateS,
          "search_date_end": searchValuedateE,
          "search_cus": searchValueCus
        });
      }
      else
      {
        raw = JSON.stringify({
          "ts_id": ts_id.toString()
        });
      }
      
      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      let response;
      if (issearch === 1)
      {
        response = await fetch(
          configData.API_URL + "Timesheet_DelSearch",
          requestOptions
        );
      }
      else
      {
        response = await fetch(
          configData.API_URL + "Timesheet_Del",
          requestOptions
        );
      }

      const json = await response.json();
      if (_isresult != null)
      {
        _isresult.result = json.status_ID
      }

      if (json.status_ID === 1) {
        
        //ทำการ Clear Data ที่เพิ่งลบ
        setListcalendarbyproject(list => {
          const itemIndex = list.findIndex(item => item.rowindex === rowindex)
          if (day.toLowerCase() === "sun")
          {
            return [...list.slice(0, itemIndex), 
            { 
              ...list[itemIndex],
              "tsid_sun" : 0,
              "wt_time_sun": "",
              "ot_time_sun": "",
              "ot_sun": 0,
              "wt_sun": 0,
              "tte_sun": 0,
              "ee_sun": 0,
              "et_sun": 0,
              "eo_sun": 0,
              "eed_sun": 0,
              "etd_sun": 0,
              "desc_sun": "",
              "tss_sun": 0,
              "tsssn_sun": "",
              "ud_sun": "",
              "usn_sun": "",
              "tsd_sun": "",
              "tsrd_sun":"",
              "act_edit_sun": (issearch === 1 || json.pro_status === 0 ? "" : "y"),
              "act_cancel_sun": "",
              "act_del_sun": "",
              "actproject_sun": "Add",
              "totalweek_wtot_time_hr" : json.totalweek_wtot_time_hr,
              "totalweek_wtot_time_mm" : json.totalweek_wtot_time_mm
            }, ...list.slice(itemIndex + 1),
            ]
          }
          else if (day.toLowerCase() === "mon")
          {
            return [...list.slice(0, itemIndex), 
            {
              ...list[itemIndex],
              "tsid_mon" : 0,
              "wt_time_mon": "",
              "ot_time_mon": "",
              "ot_mon": 0,
              "wt_mon": 0,
              "tte_mon": 0,
              "ee_mon": 0,
              "et_mon": 0,
              "eo_mon": 0,
              "eed_mon": 0,
              "etd_mon": 0,
              "desc_mon": "",
              "tss_mon": 0,
              "tsssn_mon": "",
              "ud_mon": "",
              "usn_mon": "",
              "tsd_mon": "",
              "tsrd_mon":"",
              "act_edit_mon": (issearch === 1 || json.pro_status === 0 ? "" : "y"),
              "act_cancel_mon": "",
              "act_del_mon": "",
              "actproject_mon": "Add",
              "totalweek_wtot_time_hr" : json.totalweek_wtot_time_hr,
              "totalweek_wtot_time_mm" : json.totalweek_wtot_time_mm
            }, ...list.slice(itemIndex + 1),
            ]
          }
          else if (day.toLowerCase() === "tue")
          {
            return [...list.slice(0, itemIndex), 
            {
              ...list[itemIndex],
              "tsid_tue" : 0,
              "wt_time_tue": "",
              "ot_time_tue": "",
              "ot_tue": 0,
              "wt_tue": 0,
              "tte_tue": 0,
              "ee_tue": 0,
              "et_tue": 0,
              "eo_tue": 0,
              "eed_tue": 0,
              "etd_tue": 0,
              "desc_tue": "",
              "tss_tue": 0,
              "tsssn_tue": "",
              "ud_tue": "",
              "usn_tue": "",
              "tsd_tue": "",
              "tsrd_tue":"",
              "act_edit_tue": (issearch === 1 || json.pro_status === 0 ? "" : "y"),
              "act_cancel_tue": "",
              "act_del_tue": "",
              "actproject_tue": "Add",
              "totalweek_wtot_time_hr" : json.totalweek_wtot_time_hr,
              "totalweek_wtot_time_mm" : json.totalweek_wtot_time_mm
            }, ...list.slice(itemIndex + 1),
            ]
          }
          else if (day.toLowerCase() === "wed")
          {
            return [...list.slice(0, itemIndex),
            { 
              ...list[itemIndex],
              "tsid_wed" : 0,
              "wt_time_wed": "",
              "ot_time_wed": "",
              "ot_wed": 0,
              "wt_wed": 0,
              "tte_wed": 0,
              "ee_wed": 0,
              "et_wed": 0,
              "eo_wed": 0,
              "eed_wed": 0,
              "etd_wed": 0,
              "desc_wed": "",
              "tss_wed": 0,
              "tsssn_wed": "",
              "ud_wed": "",
              "usn_wed": "",
              "tsd_wed": "",
              "tsrd_wed":"",
              "act_edit_wed": (issearch === 1 || json.pro_status === 0 ? "" : "y"),
              "act_cancel_wed": "",
              "act_del_wed": "",
              "actproject_wed": "Add",
              "totalweek_wtot_time_hr" : json.totalweek_wtot_time_hr,
              "totalweek_wtot_time_mm" : json.totalweek_wtot_time_mm
            }, ...list.slice(itemIndex + 1),
            ]
          }
          else if (day.toLowerCase() === "thu")
          {
            return [...list.slice(0, itemIndex), 
            {
              ...list[itemIndex],
              "tsid_thu" : 0,
              "wt_time_thu": "",
              "ot_time_thu": "",
              "ot_thu": 0,
              "wt_thu": 0,
              "tte_thu": 0,
              "ee_thu": 0,
              "et_thu": 0,
              "eo_thu": 0,
              "eed_thu": 0,
              "etd_thu": 0,
              "desc_thu": "",
              "tss_thu": 0,
              "tsssn_thu": "",
              "ud_thu": "",
              "usn_thu": "",
              "tsd_thu": "",
              "tsrd_thu":"",
              "act_edit_thu": (issearch === 1 || json.pro_status === 0 ? "" : "y"),
              "act_cancel_thu": "",
              "act_del_thu": "",
              "actproject_thu": "Add",
              "totalweek_wtot_time_hr" : json.totalweek_wtot_time_hr,
              "totalweek_wtot_time_mm" : json.totalweek_wtot_time_mm
            }, ...list.slice(itemIndex + 1),
            ]
          }
          else if (day.toLowerCase() === "fri")
          {
            return [...list.slice(0, itemIndex), 
            {
              ...list[itemIndex],
              "tsid_fri" : 0,
              "wt_time_fri": "",
              "ot_time_fri": "",
              "ot_fri": 0,
              "wt_fri": 0,
              "tte_fri": 0,
              "ee_fri": 0,
              "et_fri": 0,
              "eo_fri": 0,
              "eed_fri": 0,
              "etd_fri": 0,
              "desc_fri": "",
              "tss_fri": 0,
              "tsssn_fri": "",
              "ud_fri": "",
              "usn_fri": "",
              "tsd_fri": "",
              "tsrd_fri":"",
              "act_edit_fri": (issearch === 1 || json.pro_status === 0 ? "" : "y"),
              "act_cancel_fri": "",
              "act_del_fri": "",
              "actproject_fri": "Add",
              "totalweek_wtot_time_hr" : json.totalweek_wtot_time_hr,
              "totalweek_wtot_time_mm" : json.totalweek_wtot_time_mm
            }, ...list.slice(itemIndex + 1),
            ]
          }
          else
          {
            return [...list.slice(0, itemIndex), 
            {
              ...list[itemIndex],
              "tsid_sat" : 0,
              "wt_time_sat": "",
              "ot_time_sat": "",
              "ot_sat": 0,
              "wt_sat": 0,
              "tte_sat": 0,
              "ee_sat": 0,
              "et_sat": 0,
              "eo_sat": 0,
              "eed_sat": 0,
              "etd_sat": 0,
              "desc_sat": "",
              "tss_sat": 0,
              "tsssn_sat": "",
              "ud_sat": "",
              "usn_sat": "",
              "tsd_sat": "",
              "tsrd_sat":"",
              "act_edit_sat": (issearch === 1 || json.pro_status === 0 ? "" : "y"),
              "act_cancel_sat": "",
              "act_del_sat": "",
              "actproject_sat": "Add",
              "totalweek_wtot_time_hr" : json.totalweek_wtot_time_hr,
              "totalweek_wtot_time_mm" : json.totalweek_wtot_time_mm
            }, ...list.slice(itemIndex + 1),
            ]
          }
        })

        //ทำการ คำนวณ ชั่วโมง นาทีใหม่
        setListcalendarbyproject(list => {
          const itemIndex = 0
          let total_wt = json.total_wt;
          let total_ot = json.total_ot;
          let total_wt_time_hr = json.total_wt_time_hr;
          let total_wt_time_mm = json.total_wt_time_mm;
          let total_ot_time_hr = json.total_ot_time_hr;
          let total_ot_time_mm = json.total_ot_time_mm;
                      
          let totalall_wt = json.totalall_wt;
          let totalall_ot = json.totalall_ot;
          let totalall_wt_time_hr = json.totalall_wt_time_hr;
          let totalall_wt_time_mm = json.totalall_wt_time_mm;
          let totalall_ot_time_hr = json.totalall_ot_time_hr;
          let totalall_ot_time_mm = json.totalall_ot_time_mm;

          if (day.toLowerCase() === "sun")
          {
            return [...list.slice(0, itemIndex), 
            {
              ...list[itemIndex],
              "total_wt_sun" : total_wt,
              "total_ot_sun" : total_ot,
              "total_wt_time_hr_sun" : total_wt_time_hr,
              "total_wt_time_mm_sun" : total_wt_time_mm,
              "total_ot_time_hr_sun" : total_ot_time_hr,
              "total_ot_time_mm_sun" : total_ot_time_mm,
              "totalall_wt" : totalall_wt,
              "totalall_ot" : totalall_ot,
              "totalall_wt_time_hr" : totalall_wt_time_hr,
              "totalall_wt_time_mm" : totalall_wt_time_mm,
              "totalall_ot_time_hr" : totalall_ot_time_hr,
              "totalall_ot_time_mm" : totalall_ot_time_mm,

            }, ...list.slice(itemIndex + 1),
            ]
          }
          else if (day.toLowerCase() === "mon")
          {
            return [...list.slice(0, itemIndex), 
            {
              ...list[itemIndex],
              "total_wt_mon" : total_wt,
              "total_ot_mon" : total_ot,
              "total_wt_time_hr_mon" : total_wt_time_hr,
              "total_wt_time_mm_mon" : total_wt_time_mm,
              "total_ot_time_hr_mon" : total_ot_time_hr,
              "total_ot_time_mm_mon" : total_ot_time_mm,
              "totalall_wt" : totalall_wt,
              "totalall_ot" : totalall_ot,
              "totalall_wt_time_hr" : totalall_wt_time_hr,
              "totalall_wt_time_mm" : totalall_wt_time_mm,
              "totalall_ot_time_hr" : totalall_ot_time_hr,
              "totalall_ot_time_mm" : totalall_ot_time_mm,
            }, ...list.slice(itemIndex + 1),
            ]
          }
          else if (day.toLowerCase() === "tue")
          {
            return [...list.slice(0, itemIndex), 
            {
              ...list[itemIndex],
              "total_wt_tue" : total_wt,
              "total_ot_tue" : total_ot,
              "total_wt_time_hr_tue" : total_wt_time_hr,
              "total_wt_time_mm_tue" : total_wt_time_mm,
              "total_ot_time_hr_tue" : total_ot_time_hr,
              "total_ot_time_mm_tue" : total_ot_time_mm,
              "totalall_wt" : totalall_wt,
              "totalall_ot" : totalall_ot,
              "totalall_wt_time_hr" : totalall_wt_time_hr,
              "totalall_wt_time_mm" : totalall_wt_time_mm,
              "totalall_ot_time_hr" : totalall_ot_time_hr,
              "totalall_ot_time_mm" : totalall_ot_time_mm,
            }, ...list.slice(itemIndex + 1),
            ]
          }
          else if (day.toLowerCase() === "wed")
          {
            return [...list.slice(0, itemIndex),
            { 
              ...list[itemIndex],
              "total_wt_wed" : total_wt,
              "total_ot_wed" : total_ot,
              "total_wt_time_hr_wed" : total_wt_time_hr,
              "total_wt_time_mm_wed" : total_wt_time_mm,
              "total_ot_time_hr_wed" : total_ot_time_hr,
              "total_ot_time_mm_wed" : total_ot_time_mm,
              "totalall_wt" : totalall_wt,
              "totalall_ot" : totalall_ot,
              "totalall_wt_time_hr" : totalall_wt_time_hr,
              "totalall_wt_time_mm" : totalall_wt_time_mm,
              "totalall_ot_time_hr" : totalall_ot_time_hr,
              "totalall_ot_time_mm" : totalall_ot_time_mm,
            }, ...list.slice(itemIndex + 1),
            ]
          }
          else if (day.toLowerCase() === "thu")
          {
            return [...list.slice(0, itemIndex), 
            {
              ...list[itemIndex],
              "total_wt_thu" : total_wt,
              "total_ot_thu" : total_ot,
              "total_wt_time_hr_thu" : total_wt_time_hr,
              "total_wt_time_mm_thu" : total_wt_time_mm,
              "total_ot_time_hr_thu" : total_ot_time_hr,
              "total_ot_time_mm_thu" : total_ot_time_mm,
              "totalall_wt" : totalall_wt,
              "totalall_ot" : totalall_ot,
              "totalall_wt_time_hr" : totalall_wt_time_hr,
              "totalall_wt_time_mm" : totalall_wt_time_mm,
              "totalall_ot_time_hr" : totalall_ot_time_hr,
              "totalall_ot_time_mm" : totalall_ot_time_mm,
            }, ...list.slice(itemIndex + 1),
            ]
          }
          else if (day.toLowerCase() === "fri")
          {
            return [...list.slice(0, itemIndex), 
            {
              ...list[itemIndex],
              "total_wt_fri" : total_wt,
              "total_ot_fri" : total_ot,
              "total_wt_time_hr_fri" : total_wt_time_hr,
              "total_wt_time_mm_fri" : total_wt_time_mm,
              "total_ot_time_hr_fri" : total_ot_time_hr,
              "total_ot_time_mm_fri" : total_ot_time_mm,
              "totalall_wt" : totalall_wt,
              "totalall_ot" : totalall_ot,
              "totalall_wt_time_hr" : totalall_wt_time_hr,
              "totalall_wt_time_mm" : totalall_wt_time_mm,
              "totalall_ot_time_hr" : totalall_ot_time_hr,
              "totalall_ot_time_mm" : totalall_ot_time_mm,
            }, ...list.slice(itemIndex + 1),
            ]
          }
          else
          {
            return [...list.slice(0, itemIndex), 
            {
              ...list[itemIndex],
              "total_wt_sat" : total_wt,
              "total_ot_sat" : total_ot,
              "total_wt_time_hr_sat" : total_wt_time_hr,
              "total_wt_time_mm_sat" : total_wt_time_mm,
              "total_ot_time_hr_sat" : total_ot_time_hr,
              "total_ot_time_mm_sat" : total_ot_time_mm,
              "totalall_wt" : totalall_wt,
              "totalall_ot" : totalall_ot,
              "totalall_wt_time_hr" : totalall_wt_time_hr,
              "totalall_wt_time_mm" : totalall_wt_time_mm,
              "totalall_ot_time_hr" : totalall_ot_time_hr,
              "totalall_ot_time_mm" : totalall_ot_time_mm,
            }, ...list.slice(itemIndex + 1),
            ]
          }
        })

        //ทำการนำ ชั่วโมง นาที  มาใส่ใน arry
        if (day.toLowerCase() === "sun")
        {
          setSummary_wtot(
          {
            ...summary_wtot,
            total_wt_sun : json.total_wt,
            total_ot_sun : json.total_ot,
            total_wt_time_hr_sun : json.total_wt_time_hr,
            total_wt_time_mm_sun : json.total_wt_time_mm,
            total_ot_time_hr_sun : json.total_ot_time_hr,
            total_ot_time_mm_sun : json.total_ot_time_mm,
            totalall_wt : json.totalall_wt,
            totalall_ot : json.totalall_ot,
            totalall_wt_time_hr : json.totalall_wt_time_hr,
            totalall_wt_time_mm : json.totalall_wt_time_mm,
            totalall_ot_time_hr : json.totalall_ot_time_hr,
            totalall_ot_time_mm : json.totalall_ot_time_mm,
          });
        }
        else if (day.toLowerCase() === "mon")
        {
          setSummary_wtot(
            {
              ...summary_wtot,
              total_wt_mon : json.total_wt,
              total_ot_mon : json.total_ot,
              total_wt_time_hr_mon : json.total_wt_time_hr,
              total_wt_time_mm_mon : json.total_wt_time_mm,
              total_ot_time_hr_mon : json.total_ot_time_hr,
              total_ot_time_mm_mon : json.total_ot_time_mm,
              totalall_wt : json.totalall_wt,
              totalall_ot : json.totalall_ot,
              totalall_wt_time_hr : json.totalall_wt_time_hr,
              totalall_wt_time_mm : json.totalall_wt_time_mm,
              totalall_ot_time_hr : json.totalall_ot_time_hr,
              totalall_ot_time_mm : json.totalall_ot_time_mm,
          });
        }
        else if (day.toLowerCase() === "tue")
        {
          setSummary_wtot(
            {
              ...summary_wtot,
            total_wt_tue : json.total_wt,
            total_ot_tue : json.total_ot,
            total_wt_time_hr_tue : json.total_wt_time_hr,
            total_wt_time_mm_tue : json.total_wt_time_mm,
            total_ot_time_hr_tue : json.total_ot_time_hr,
            total_ot_time_mm_tue : json.total_ot_time_mm,
            totalall_wt : json.totalall_wt,
            totalall_ot : json.totalall_ot,
            totalall_wt_time_hr : json.totalall_wt_time_hr,
            totalall_wt_time_mm : json.totalall_wt_time_mm,
            totalall_ot_time_hr : json.totalall_ot_time_hr,
            totalall_ot_time_mm : json.totalall_ot_time_mm,
          });
        }
        else if (day.toLowerCase() === "wed")
        {
          setSummary_wtot(
            {
              ...summary_wtot,
            total_wt_wed : json.total_wt,
            total_ot_wed : json.total_ot,
            total_wt_time_hr_wed : json.total_wt_time_hr,
            total_wt_time_mm_wed : json.total_wt_time_mm,
            total_ot_time_hr_wed : json.total_ot_time_hr,
            total_ot_time_mm_wed : json.total_ot_time_mm,
            totalall_wt : json.totalall_wt,
            totalall_ot : json.totalall_ot,
            totalall_wt_time_hr : json.totalall_wt_time_hr,
            totalall_wt_time_mm : json.totalall_wt_time_mm,
            totalall_ot_time_hr : json.totalall_ot_time_hr,
            totalall_ot_time_mm : json.totalall_ot_time_mm,
          });
        }
        else if (day.toLowerCase() === "thu")
        {
          setSummary_wtot(
            {
              ...summary_wtot,
            total_wt_thu : json.total_wt,
            total_ot_thu : json.total_ot,
            total_wt_time_hr_thu : json.total_wt_time_hr,
            total_wt_time_mm_thu : json.total_wt_time_mm,
            total_ot_time_hr_thu : json.total_ot_time_hr,
            total_ot_time_mm_thu : json.total_ot_time_mm,
            totalall_wt : json.totalall_wt,
            totalall_ot : json.totalall_ot,
            totalall_wt_time_hr : json.totalall_wt_time_hr,
            totalall_wt_time_mm : json.totalall_wt_time_mm,
            totalall_ot_time_hr : json.totalall_ot_time_hr,
            totalall_ot_time_mm : json.totalall_ot_time_mm,
          });
        }
        else if (day.toLowerCase() === "fri")
        {
          setSummary_wtot(
            {
              ...summary_wtot,
            total_wt_fri : json.total_wt,
            total_ot_fri : json.total_ot,
            total_wt_time_hr_fri : json.total_wt_time_hr,
            total_wt_time_mm_fri : json.total_wt_time_mm,
            total_ot_time_hr_fri : json.total_ot_time_hr,
            total_ot_time_mm_fri : json.total_ot_time_mm,
            totalall_wt : json.totalall_wt,
            totalall_ot : json.totalall_ot,
            totalall_wt_time_hr : json.totalall_wt_time_hr,
            totalall_wt_time_mm : json.totalall_wt_time_mm,
            totalall_ot_time_hr : json.totalall_ot_time_hr,
            totalall_ot_time_mm : json.totalall_ot_time_mm,
          });
        }
        else
        {
          setSummary_wtot(
            {
              ...summary_wtot,
            total_wt_sat : json.total_wt,
            total_ot_sat : json.total_ot,
            total_wt_time_hr_sat : json.total_wt_time_hr,
            total_wt_time_mm_sat : json.total_wt_time_mm,
            total_ot_time_hr_sat : json.total_ot_time_hr,
            total_ot_time_mm_sat : json.total_ot_time_mm,
            totalall_wt : json.totalall_wt,
            totalall_ot : json.totalall_ot,
            totalall_wt_time_hr : json.totalall_wt_time_hr,
            totalall_wt_time_mm : json.totalall_wt_time_mm,
            totalall_ot_time_hr : json.totalall_ot_time_hr,
            totalall_ot_time_mm : json.totalall_ot_time_mm,
          });
        }

        
        BindsetValueSSP(json.status_sun, json.status_mon, json.status_tue, json.status_wed, json.status_thu, json.status_fri, json.status_sat)
        BindChangStatusDay(json.status_sun, json.status_mon, json.status_tue, json.status_wed, json.status_thu, json.status_fri, json.status_sat);
        
        BindCntReject(function() {
          setIsLoadProgress(false);
          if (istypedel === "popup")
          {
            document.getElementById("modalTS_Close").click();
            Class_ETC_MsgSuccess(MsgDescription.CFM003, null);
          }
          else
          {
            Class_ETC_MsgSuccess(MsgDescription.CFM003, null);
          }
          
          if (_callback != null) {
              _callback();
          }
        });

      }
      else if (json.status_ID === 2) 
      {
        Class_ETC_SessionTimeOut();
      } 
      else {
        setIsLoadProgress(false);
        Class_ETC_MsgError(json.status_Desc, null);
      }
    } catch {
      if (_isresult != null)
      {
        _isresult.result = 0
      }
      if (_callback != null) {
          _callback();
      }
      setIsLoadProgress(false);
      Class_ETC_MsgError(MsgDescription.ERR003, null);
    }


  }

  function BeforeCencelTimesheet(){
    CencelTimesheet(data_modalTS_tsid
                  ,data_modalTS_day
                  ,data_modalTS_rowindex
                  )
  }

  async function CencelTimesheet(ts_id
                             ,day
                             ,rowindex){

    
    try {
      setIsLoadProgress(true);
      
      let token = "";
      token = localStorage.getItem("TStoken");
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + token);
      myHeaders.append("Content-Type", "application/json");
      
      var raw;
      raw = JSON.stringify({
        "ts_id": ts_id.toString()
      });
      
      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(
        configData.API_URL + "Timesheet_Cancelsubmit",
        requestOptions
      );
      const json = await response.json();

      if (json.status_ID === 1) {
        
        
        BindsetValueSSP(json.status_sun, json.status_mon, json.status_tue, json.status_wed, json.status_thu, json.status_fri, json.status_sat)
        BindChangStatusDay(json.status_sun, json.status_mon, json.status_tue, json.status_wed, json.status_thu, json.status_fri, json.status_sat);

        //เอา Data ที่เพิ่งได้มา ยัดใส่ arry
        setListcalendarbyproject(list => {
          const itemIndex = list.findIndex(item => item.rowindex === rowindex)
          if (day.toLowerCase() === "sun")
          {
            return [...list.slice(0, itemIndex), 
            { 
              ...list[itemIndex],
              "tss_sun": json.tss,
              "tsssn_sun": json.tsssn,
              "ud_sun": json.ud,
              "usn_sun": json.usn,
              "tsd_sun": json.tsd,
              "act_edit_sun": (issearch === 1 && (searchValuestatus === -1 || searchValuestatus === 0) ? "" : json.act_edit),
              "ot_sun": (issearch === 1 && (searchValuestatus === -1 || searchValuestatus === 0) ? 0 : list[itemIndex].ot_sun) ,
              "wt_time_sun" : list[itemIndex].wt_time_sun,
              "act_cancel_sun": json.act_cancel,
              "act_del_sun": json.act_del,
            }, ...list.slice(itemIndex + 1),
            ]
          }
          else if (day.toLowerCase() === "mon")
          {
            return [...list.slice(0, itemIndex), 
            {
              ...list[itemIndex],
              "tss_mon": json.tss,
              "tsssn_mon": json.tsssn,
              "ud_mon": json.ud,
              "usn_mon": json.usn,
              "tsd_mon": json.tsd,
              "act_edit_mon": (issearch === 1 && (searchValuestatus === -1 || searchValuestatus === 0) ? "" : json.act_edit),
              "ot_mon": (issearch === 1 && (searchValuestatus === -1 || searchValuestatus === 0) ? 0 : list[itemIndex].ot_mon) ,
              "wt_time_mon" : list[itemIndex].wt_time_mon,
              "act_cancel_mon": json.act_cancel,
              "act_del_mon": json.act_del,
            }, ...list.slice(itemIndex + 1),
            ]
          }
          else if (day.toLowerCase() === "tue")
          {
            return [...list.slice(0, itemIndex), 
            {
              ...list[itemIndex],
              "tss_tue": json.tss,
              "tsssn_tue": json.tsssn,
              "ud_tue": json.ud,
              "usn_tue": json.usn,
              "tsd_tue": json.tsd,
              "act_edit_tue": (issearch === 1 && (searchValuestatus === -1 || searchValuestatus === 0) ? "" : json.act_edit),
              "ot_tue": (issearch === 1 && (searchValuestatus === -1 || searchValuestatus === 0) ? 0 : list[itemIndex].ot_tue) ,
              "wt_time_tue" : list[itemIndex].wt_time_tue,
              "act_cancel_tue": json.act_cancel,
              "act_del_tue": json.act_del,
            }, ...list.slice(itemIndex + 1),
            ]
          }
          else if (day.toLowerCase() === "wed")
          {
            return [...list.slice(0, itemIndex),
            { 
              ...list[itemIndex],
              "tss_wed": json.tss,
              "tsssn_wed": json.tsssn,
              "ud_wed": json.ud,
              "usn_wed": json.usn,
              "tsd_wed": json.tsd,
              "act_edit_wed": (issearch === 1 && (searchValuestatus === -1 || searchValuestatus === 0) ? "" : json.act_edit),
              "ot_wed": (issearch === 1 && (searchValuestatus === -1 || searchValuestatus === 0) ? 0 : list[itemIndex].ot_wed) ,
              "wt_time_wed" : list[itemIndex].wt_time_wed,
              "act_cancel_wed": json.act_cancel,
              "act_del_wed": json.act_del,
            }, ...list.slice(itemIndex + 1),
            ]
          }
          else if (day.toLowerCase() === "thu")
          {
            return [...list.slice(0, itemIndex), 
            {
              ...list[itemIndex],
              "tss_thu": json.tss,
              "tsssn_thu": json.tsssn,
              "ud_thu": json.ud,
              "usn_thu": json.usn,
              "tsd_thu": json.tsd,
              "act_edit_thu": (issearch === 1 && (searchValuestatus === -1 || searchValuestatus === 0) ? "" : json.act_edit),
              "ot_thu": (issearch === 1 && (searchValuestatus === -1 || searchValuestatus === 0) ? 0 : list[itemIndex].ot_thu) ,
              "wt_time_thu" : list[itemIndex].wt_time_thu,
              "act_cancel_thu": json.act_cancel,
              "act_del_thu": json.act_del,
            }, ...list.slice(itemIndex + 1),
            ]
          }
          else if (day.toLowerCase() === "fri")
          {
            return [...list.slice(0, itemIndex), 
            {
              ...list[itemIndex],
              "tss_fri": json.tss,
              "tsssn_fri": json.tsssn,
              "ud_fri": json.ud,
              "usn_fri": json.usn,
              "tsd_fri": json.tsd,
              "act_edit_fri": (issearch === 1 && (searchValuestatus === -1 || searchValuestatus === 0) ? "" : json.act_edit),
              "ot_fri": (issearch === 1 && (searchValuestatus === -1 || searchValuestatus === 0) ? 0 : list[itemIndex].ot_fri) ,
              "wt_time_fri" : list[itemIndex].wt_time_fri,
              "act_cancel_fri": json.act_cancel,
              "act_del_fri": json.act_del,
            }, ...list.slice(itemIndex + 1),
            ]
          }
          else
          {
            return [...list.slice(0, itemIndex), 
            {
              ...list[itemIndex],
              "tss_sat": json.tss,
              "tsssn_sat": json.tsssn,
              "ud_sat": json.ud,
              "usn_sat": json.usn,
              "tsd_sat": json.tsd,
              "act_edit_sat": (issearch === 1 && (searchValuestatus === -1 || searchValuestatus === 0) ? "" : json.act_edit),
              "ot_sat": (issearch === 1 && (searchValuestatus === -1 || searchValuestatus === 0) ? 0 : list[itemIndex].ot_sat) ,
              "wt_time_sat" : list[itemIndex].wt_time_sat,
              "act_cancel_sat": json.act_cancel,
              "act_del_sat": json.act_del,
            }, ...list.slice(itemIndex + 1),
            ]
          }
        })
        
        BindCntReject(function() {
          setIsLoadProgress(false);
          document.getElementById("modalTS_Close").click();
          Class_ETC_MsgSuccess(MsgDescription.CFM001, null);
        });

      }
      else if (json.status_ID === 2) 
      {
        Class_ETC_SessionTimeOut();
      } 
      else {
        setIsLoadProgress(false);
        Class_ETC_MsgError(json.status_Desc, null);
      }
    } catch {
      setIsLoadProgress(false);
      Class_ETC_MsgError(MsgDescription.ERR002, null);
    }


  }
  
  async function BindGetSubmit(){

    try {

      setIsLoadProgress(true);
      document.getElementById("chk_modalsubmit_all").checked = false;

      let token = "";
      token = localStorage.getItem("TStoken");
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + token);
      myHeaders.append("Content-Type", "application/json");

      var raw;

      if (issearch === 1) {
        raw = JSON.stringify({
          "start_date": start_date_byproject,
          "search_project": searchValueProject,
          "search_task": searchValueTask,
          "search_timeoff": searchValueTimeoff,
          "search_date_start": searchValuedateS,
          "search_date_end": searchValuedateE,
          "search_cus": searchValueCus
        });
      }
      else{
        raw = JSON.stringify({
          "start_date": start_date_byproject
        });
      }

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      let response;
      if (issearch === 1) {
        response = await fetch(
          configData.API_URL + "Timesheet_GetSubmitSearch",
          requestOptions
        );
      }
      else
      {
        response = await fetch(
          configData.API_URL + "Timesheet_GetSubmit",
          requestOptions
        );
      }

      const json = await response.json();
      if (json.status_ID === 1) {
        if (json.total_Data > 0) {
          
          setListtimesheetSubmit(json.data);
          CB_Submit(false);
          setIsLoadProgress(false);
          
        } else {
          setListtimesheetSubmit([]);
          CB_Submit(false);
          setIsLoadProgress(false);
        }
      }
      else if (json.status_ID === 2) 
      {
        Class_ETC_SessionTimeOut();
      }
      else
      {
        setListtimesheetSubmit([]);
        CB_Submit(false);
        setIsLoadProgress(false);
      }
    } catch {
      setListtimesheetSubmit([]);
      CB_Submit(false);
      setIsLoadProgress(false);
    }
  }

  function CB_Submit(checked){

    for (let i = 0 ; i < listtimesheetSubmit.length; i++)
    {
      try
      {
        document.getElementById("chk_modalsubmit_" + listtimesheetSubmit[i].dday).checked = checked;
      }
      catch{

      }
    }
    setIsdisabled_btnsubmitweek(!checked);
  }

  async function SaveSubmitWeek(sun , mon , tue , wed , thu , fri , sat)
  {

    try {
      setIsLoadProgress(true);
      let token = "";
      token = localStorage.getItem("TStoken");
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + token);
      myHeaders.append("Content-Type", "application/json");
      
      var raw;
      if (issearch === 1)
      {
        raw = JSON.stringify({
          "start_date": start_date_byproject,
          "sun": sun,
          "mon": mon,
          "tue": tue,
          "wed": wed,
          "thu": thu,
          "fri": fri,
          "sat": sat,
          "search_project": searchValueProject,
          "search_task": searchValueTask,
          "search_timeoff": searchValueTimeoff,
          "search_date_start": searchValuedateS,
          "search_date_end": searchValuedateE,
          "search_cus": searchValueCus
        });
      }
      else
      {
        raw = JSON.stringify({
          "start_date": start_date_byproject,
          "sun": sun,
          "mon": mon,
          "tue": tue,
          "wed": wed,
          "thu": thu,
          "fri": fri,
          "sat": sat
        });
      }

      
      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };


      let response;
      if (issearch === 1)
      {
        response = await fetch(
          configData.API_URL + "Timesheet_SaveSubmitWeekSearch",
          requestOptions
        );
      }
      else
      {
        response = await fetch(
          configData.API_URL + "Timesheet_SaveSubmitWeek",
          requestOptions
        );
      }

      const json = await response.json();

      if (json.status_ID === 1) {

        //เอา Data ที่เพิ่งได้มา ยัดใส่ arry
        for (let i = 0 ; i < listcalendarbyproject.length ; i ++)
        {
          if (sun === "1" && listcalendarbyproject[i].tsid_sun !== 0 && 
              listcalendarbyproject[i].tss_sun === ConfigETC.TS_InProgress_Value)
          {
            setListcalendarbyproject(list => {
                return [...list.slice(0, i), 
                { 
                  ...list[i],
                  "tss_sun": json.tss,
                  "tsssn_sun": json.tsssn,
                  "ud_sun": json.ud,
                  "usn_sun": json.usn,
                  "tsd_sun": json.tsd,
                  "act_edit_sun": json.act_edit,
                  "act_cancel_sun": json.act_cancel,
                  "act_del_sun": json.act_del,
                }, ...list.slice(i + 1),
                ]
            })
          }
          
          if (mon === "1" && listcalendarbyproject[i].tsid_mon !== 0 && 
          listcalendarbyproject[i].tss_mon === ConfigETC.TS_InProgress_Value)
          {
            setListcalendarbyproject(list => {
                return [...list.slice(0, i), 
                { 
                  ...list[i],
                  "tss_mon": json.tss,
                  "tsssn_mon": json.tsssn,
                  "ud_mon": json.ud,
                  "usn_mon": json.usn,
                  "tsd_mon": json.tsd,
                  "act_edit_mon": json.act_edit,
                  "act_cancel_mon": json.act_cancel,
                  "act_del_mon": json.act_del,
                }, ...list.slice(i + 1),
                ]
            })
          }
          
          if (tue === "1" && listcalendarbyproject[i].tsid_tue !== 0 && 
          listcalendarbyproject[i].tss_tue === ConfigETC.TS_InProgress_Value)
          {
            setListcalendarbyproject(list => {
                return [...list.slice(0, i), 
                { 
                  ...list[i],
                  "tss_tue": json.tss,
                  "tsssn_tue": json.tsssn,
                  "ud_tue": json.ud,
                  "usn_tue": json.usn,
                  "tsd_tue": json.tsd,
                  "act_edit_tue": json.act_edit,
                  "act_cancel_tue": json.act_cancel,
                  "act_del_tue": json.act_del,
                }, ...list.slice(i + 1),
                ]
            })
          }
          
          if (wed === "1" && listcalendarbyproject[i].tsid_wed !== 0 && 
          listcalendarbyproject[i].tss_wed === ConfigETC.TS_InProgress_Value)
          {
            setListcalendarbyproject(list => {
                return [...list.slice(0, i), 
                { 
                  ...list[i],
                  "tss_wed": json.tss,
                  "tsssn_wed": json.tsssn,
                  "ud_wed": json.ud,
                  "usn_wed": json.usn,
                  "tsd_wed": json.tsd,
                  "act_edit_wed": json.act_edit,
                  "act_cancel_wed": json.act_cancel,
                  "act_del_wed": json.act_del,
                }, ...list.slice(i + 1),
                ]
            })
          }

          if (thu === "1" && listcalendarbyproject[i].tsid_thu !== 0 && 
          listcalendarbyproject[i].tss_thu === ConfigETC.TS_InProgress_Value)
          {
            setListcalendarbyproject(list => {
                return [...list.slice(0, i), 
                { 
                  ...list[i],
                  "tss_thu": json.tss,
                  "tsssn_thu": json.tsssn,
                  "ud_thu": json.ud,
                  "usn_thu": json.usn,
                  "tsd_thu": json.tsd,
                  "act_edit_thu": json.act_edit,
                  "act_cancel_thu": json.act_cancel,
                  "act_del_thu": json.act_del,
                }, ...list.slice(i + 1),
                ]
            })
          }
          
          if (fri === "1" && listcalendarbyproject[i].tsid_fri !== 0 && 
          listcalendarbyproject[i].tss_fri === ConfigETC.TS_InProgress_Value)
          {
            setListcalendarbyproject(list => {
                return [...list.slice(0, i), 
                { 
                  ...list[i],
                  "tss_fri": json.tss,
                  "tsssn_fri": json.tsssn,
                  "ud_fri": json.ud,
                  "usn_fri": json.usn,
                  "tsd_fri": json.tsd,
                  "act_edit_fri": json.act_edit,
                  "act_cancel_fri": json.act_cancel,
                  "act_del_fri": json.act_del,
                }, ...list.slice(i + 1),
                ]
            })
          }
          
          if (sat === "1" && listcalendarbyproject[i].tsid_sat !== 0 && 
          listcalendarbyproject[i].tss_sat === ConfigETC.TS_InProgress_Value)
          {
            setListcalendarbyproject(list => {
                return [...list.slice(0, i), 
                { 
                  ...list[i],
                  "tss_sat": json.tss,
                  "tsssn_sat": json.tsssn,
                  "ud_sat": json.ud,
                  "usn_sat": json.usn,
                  "tsd_sat": json.tsd,
                  "act_edit_sat": json.act_edit,
                  "act_cancel_sat": json.act_cancel,
                  "act_del_sat": json.act_del,
                }, ...list.slice(i + 1),
                ]
            })
          }
        } 
        
        
        BindsetValueSSP(json.status_sun, json.status_mon, json.status_tue, json.status_wed, json.status_thu, json.status_fri, json.status_sat)
        BindChangStatusDay(json.status_sun, json.status_mon, json.status_tue, json.status_wed, json.status_thu, json.status_fri, json.status_sat);
        BindCntReject(function() {
          setIsLoadProgress(false);
          document.getElementById("modalsubmit_Close").click();
          Class_ETC_MsgSuccess(MsgDescription.CFM001 , null);
        });
      
      }
      else if (json.status_ID === 2) 
      {
        Class_ETC_SessionTimeOut();
      } 
      else {
        setIsLoadProgress(false);
        Class_ETC_MsgError(json.status_Desc, null);
      }
    
    } catch {
      setIsLoadProgress(false);
      Class_ETC_MsgError(MsgDescription.ERR002, null);
    }
  }
  
  function Bindendfunction_SP(){
    setIsLoadProgress(false)
  }

  //#endregion


  //#region __ Event __

  function onclick_refresh(){

    setIsLoadProgress(true);
    onclick_reset();
    if (listcalendar.length > 0)
    {
      document.getElementById("hd_Slideindex_Goto").value = "0"
      document.getElementById("btn_GotoSet").click();
    }

    if (searchValueStaff === "-1") {
      setIssearch(0);
      BindListcalendarBar("0" , "0" , "" , function() {
        setIsLoadProgress(false);
      });
    }
    else {
      setIssearch(1);
      setIsLoadProgress(true);
      BindListCalendarBarAPI("0" , "0" , "" , 1 , "" , "" , "" , "" , "" , "" , "" , function() {
        setIsLoadProgress(false);
      });
    }



  }

  function onclick_viewProject(date_Start , uniqueid , sspsun, sspmon, ssptue, sspwed, sspthu, sspfri, sspsat
                              ,isholiday_sun
                              ,isholiday_mon
                              ,isholiday_tue
                              ,isholiday_wed
                              ,isholiday_thu
                              ,isholiday_fri
                              ,isholiday_sat
                              ,dt_sun
                              ,dt_mon
                              ,dt_tue
                              ,dt_wed
                              ,dt_thu
                              ,dt_fri
                              ,dt_sat
                              ,dt_Full_sun
                              ,dt_Full_mon
                              ,dt_Full_tue
                              ,dt_Full_wed
                              ,dt_Full_thu
                              ,dt_Full_fri
                              ,dt_Full_sat ){
    setIsLoadProgress(true);
    BindsetValueSSP(sspsun, sspmon, ssptue, sspwed, sspthu, sspfri, sspsat);
    BindsetValueisHoliday(isholiday_sun, isholiday_mon, isholiday_tue, isholiday_wed, isholiday_thu, isholiday_fri, isholiday_sat);
    BindsetValuedt(dt_sun, dt_mon, dt_tue, dt_wed, dt_thu, dt_fri, dt_sat , dt_Full_sun, dt_Full_mon, dt_Full_tue, dt_Full_wed, dt_Full_thu, dt_Full_fri, dt_Full_sat)
    
    
    BindListCalenderByProject(date_Start , 
                              issearch , 
                              searchValuedateS , 
                              searchValuedateE ,
                              searchValueProject ,
                              searchValueCus ,
                              searchValueTimeoff ,
                              searchValuestatus ,
                              searchValueTask , 
                              function() {
      setCalendaractive(uniqueid);
      setIsLoadProgress(false);
    });
  
  }

  function onclick_AddProjectTask(){

    setIschecked_timeofftask("1");
    setIsDisabledTask(false);
    setIsDisabledTimeoff(true);

    document.getElementById("hd_PU_AddPT_Selecttask").value = "-1"
    document.getElementById("hd_PU_AddPT_Selecttimeoff").value = "-1"
    document.getElementById("hd_PU_AddPT_Selectproject").value = "-1"
    document.getElementById("hd_moal_idfocus").value = "";

    setSelectedtask([]);
    setSelectedtimeoff([]);
    setSelectedproject([]);
    setIscntreset_ProjectAdd((iscntreset_ProjectAdd) => iscntreset_ProjectAdd + 1);

  }

  async function onclick_LoadlastestWeek(){

    
    try {

      setIsLoadProgress(true);

      let token = "";
      token = localStorage.getItem("TStoken");
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + token);
      myHeaders.append("Content-Type", "application/json");

      var raw;
      raw = JSON.stringify({
        "start_date": start_date_byproject,
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      let response;
      response = await fetch(
        configData.API_URL + "Timesheet_Getloadlatestweek",
        requestOptions
      );

      const json = await response.json();
      if (json.status_ID === 1) {
        if (json.total_Data > 0) {
          
          let filtered;
          for (let i = 0; i < json.total_Data ; i++)
          {
            
            filtered = listcalendarbyproject.filter(list => {
              return list.pro_id === json.data[i].pro_id && list.task_id === json.data[i].task_id;
            });

            if (filtered.length === 0){

              setListcalendarbyproject(listcalendarbyproject => [...listcalendarbyproject,  {
                "rowindex" : listcalendarbyproject.length + 1
                ,"project_name" : json.data[i].project_Name
                ,"act_task_timeoff" : "T"
                ,"taskname" : json.data[i].taskname
                ,"tasksubname" : json.data[i].taskSubname
                ,"timeoff_name" : ""
      
                ,"totalweek_wtot_time_hr" : "0"
                ,"totalweek_wtot_time_mm" : "0"
      
                ,"pro_id" : json.data[i].pro_id
                ,"task_id" : json.data[i].task_id
                ,"timeoff_id" : "0"
                
                ,"customer_name" : json.data[i].customer_Name
                ,"pos_name" : json.data[i].pos_name
                
                ,"pos_name_sun" : json.data[i].pos_name
                ,"pos_name_mon" : json.data[i].pos_name
                ,"pos_name_tue" : json.data[i].pos_name
                ,"pos_name_wed" : json.data[i].pos_name
                ,"pos_name_thu" : json.data[i].pos_name
                ,"pos_name_fri" : json.data[i].pos_name
                ,"pos_name_sat" : json.data[i].pos_name
                
                ,"parent_sorting" : json.data[i].parent_sorting
                ,"task_sorting" : json.data[i].task_sorting
                
                ,"tsid_sun" : 0
                ,"wt_time_sun" : ""
                ,"tss_sun" : 0
                ,"tte_sun" : 0
                ,"ot_sun" : 0
                ,"act_edit_sun" : "y"
                ,"actproject_sun": "Add"
                ,"ee_sun" : 0
                ,"et_sun" : 0
                ,"eo_sun" : 0
                ,"eed_sun": 0
                ,"etd_sun": 0
          
                ,"desc_sun" : ""
                ,"tsssn_sun" : ""
                ,"tsrd_sun" : ""
                ,"ud_sun" : ""
                ,"usn_sun" : ""
                ,"tsd_sun" : ""
                ,"ot_time_sun" : ""
                ,"act_cancel_sun" : ""
                ,"act_del_sun" : ""
      
                ,"tsid_mon" : 0
                ,"wt_time_mon" : ""
                ,"tss_mon" : 0
                ,"tte_mon" : 0
                ,"ot_mon" : 0
                ,"act_edit_mon" : "y"
                ,"actproject_mon": "Add"
                ,"ee_mon" : 0
                ,"et_mon" : 0
                ,"eo_mon" : 0
                ,"eed_mon": 0
                ,"etd_mon": 0
  
                ,"desc_mon" : ""
                ,"tsssn_mon" : ""
                ,"tsrd_mon" : ""
                ,"ud_mon" : ""
                ,"usn_mon" : ""
                ,"tsd_mon" : ""
                ,"ot_time_mon" : ""
                ,"act_cancel_mon" : ""
                ,"act_del_mon" : ""
                
                ,"tsid_tue" : 0
                ,"wt_time_tue" : ""
                ,"tss_tue" : 0
                ,"tte_tue" : 0
                ,"ot_tue" : 0
                ,"act_edit_tue" : "y"
                ,"actproject_tue": "Add"
                ,"ee_tue" : 0
                ,"et_tue" : 0
                ,"eo_tue" : 0
                ,"eed_tue": 0
                ,"etd_tue": 0

                ,"desc_tue" : ""
                ,"tsssn_tue" : ""
                ,"tsrd_tue" : ""
                ,"ud_tue" : ""
                ,"usn_tue" : ""
                ,"tsd_tue" : ""
                ,"ot_time_tue" : ""
                ,"act_cancel_tue" : ""
                ,"act_del_tue" : ""
      
                ,"tsid_wed" : 0
                ,"wt_time_wed" : ""
                ,"tss_wed" : 0
                ,"tte_wed" : 0
                ,"ot_wed" : 0
                ,"act_edit_wed" : "y"
                ,"actproject_wed": "Add"
                ,"ee_wed" : 0
                ,"et_wed" : 0
                ,"eo_wed" : 0
                ,"eed_wed": 0
                ,"etd_wed": 0
          
                ,"desc_wed" : ""
                ,"tsssn_wed" : ""
                ,"tsrd_wed" : ""
                ,"ud_wed" : ""
                ,"usn_wed" : ""
                ,"tsd_wed" : ""
                ,"ot_time_wed" : ""
                ,"act_cancel_wed" : ""
                ,"act_del_wed" : ""
      
                ,"tsid_thu" : 0
                ,"wt_time_thu" : ""
                ,"tss_thu" : 0
                ,"tte_thu" : 0
                ,"ot_thu" : 0
                ,"act_edit_thu" : "y"
                ,"actproject_thu": "Add"
                ,"ee_thu" : 0
                ,"et_thu" : 0
                ,"eo_thu" : 0
                ,"eed_thu": 0
                ,"etd_thu": 0
          
                ,"desc_thu" : ""
                ,"tsssn_thu" : ""
                ,"tsrd_thu" : ""
                ,"ud_thu" : ""
                ,"usn_thu" : ""
                ,"tsd_thu" : ""
                ,"ot_time_thu" : ""
                ,"act_cancel_thu" : ""
                ,"act_del_thu" : ""
      
                ,"tsid_fri" : 0
                ,"wt_time_fri" : ""
                ,"tss_fri" : 0
                ,"tte_fri" : 0
                ,"ot_fri" : 0
                ,"act_edit_fri" : "y"
                ,"actproject_fri": "Add"
                ,"ee_fri" : 0
                ,"et_fri" : 0
                ,"eo_fri" : 0
                ,"eed_fri": 0
                ,"etd_fri": 0
          
                ,"desc_fri" : ""
                ,"tsssn_fri" : ""
                ,"tsrd_fri" : ""
                ,"ud_fri" : ""
                ,"usn_fri" : ""
                ,"tsd_fri" : ""
                ,"ot_time_fri" : ""
                ,"act_cancel_fri" : ""
                ,"act_del_fri" : ""
                
                ,"tsid_sat" : 0
                ,"wt_time_sat" : ""
                ,"tss_sat" : 0
                ,"tte_sat" : 0
                ,"ot_sat" : 0
                ,"act_edit_sat" : "y"
                ,"actproject_sat": "Add"
                ,"ee_sat" : 0
                ,"et_sat" : 0
                ,"eo_sat" : 0
                ,"eed_sat": 0
                ,"etd_sat": 0

                ,"desc_sat" : ""
                ,"tsssn_sat" : ""
                ,"tsrd_sat" : ""
                ,"ud_sat" : ""
                ,"usn_sat" : ""
                ,"tsd_sat" : ""
                ,"ot_time_sat" : ""
                ,"act_cancel_sat" : ""
                ,"act_del_sat" : ""
              }]);

            }
          }


          setIsLoadProgress(false);
          
        } else {
          setIsLoadProgress(false);
        }
      }
      else if (json.status_ID === 2) 
      {
        Class_ETC_SessionTimeOut();
      }
      else
      {
        setIsLoadProgress(false);
      }
    } catch {
      setIsLoadProgress(false);
    }
  }
  
  function onChageSelectTask(e){
    document.getElementById("hd_PU_AddPT_Selecttask").value = (e !== null ? e.value : "-1")
    setSelectedtask(e);
  }
  
  function onChageSelectTimeoff(e){
    document.getElementById("hd_PU_AddPT_Selecttimeoff").value = (e !== null ? e.value : "-1")
    setSelectedtimeoff(e);
  }
  
  function onChageSelectProject(e){
    document.getElementById("hd_PU_AddPT_Selectproject").value = (e !== null ? e.value : "-1")
    setSelectedproject(e);
  }

  function onChange_Rdo_worktype(e , act){

    setIschecked_timeofftask(e.target.value);
    setSelectedtask([]);
    setSelectedtimeoff([]);
    document.getElementById("hd_PU_AddPT_Selecttask").value = "-1"
    document.getElementById("hd_PU_AddPT_Selecttimeoff").value = "-1"

    if (act === "timeoff")
    {
      setIsDisabledTask(true);
      setIsDisabledTimeoff(false);
    }
    else
    {
      setIsDisabledTimeoff(true);
      setIsDisabledTask(false);
    }
  }
  
  function onclick_AddProject(){

    let iderror = ""
    if (document.getElementById("hd_PU_AddPT_Selectproject").value === "-1")
    {
      iderror = "project";
    }
    else
    {
      if (ischecked_timeofftask === "1")
      {
        if (document.getElementById("hd_PU_AddPT_Selecttask").value === "-1")
        {
          iderror = "task";
        }
      }
      else
      {
        if (document.getElementById("hd_PU_AddPT_Selecttimeoff").value === "-1")
        {
          iderror = "timeoff";
        }
      }
    }

    if (iderror !== "")
    {
      document.getElementById("hd_moal_idfocus").value = iderror;
      Class_ETC_MsgError(MsgDescription.ERR001 , SelectFocas);
    }
    else
    {

      let proid = selectedproject.value;
      let taskid = (ischecked_timeofftask === "1" ? selectedtask.value : 0);
      let timeid = (ischecked_timeofftask === "1" ? 0 : selectedtimeoff.value);
      
      const filtered = listcalendarbyproject.filter(list => {
        return ischecked_timeofftask === "1" ? list.pro_id === proid && list.task_id === taskid
              : list.pro_id === proid && list.timeoff_id === timeid;
      });

      if (filtered.length > 0)
      {
        Class_ETC_MsgError(MsgDescription.ERR021 , null);
      }
      else
      {
        setListcalendarbyproject(listcalendarbyproject => [...listcalendarbyproject,  {
          "rowindex" : listcalendarbyproject.length + 1
          ,"project_name" : selectedproject.label
          ,"act_task_timeoff" : (ischecked_timeofftask === "1" ? "T" : "TO")
          ,"taskname" : (ischecked_timeofftask === "1" ? selectedtask.parent_Name : "")  
          ,"tasksubname" : (ischecked_timeofftask === "1" ? selectedtask.label : "")  
          ,"timeoff_name" : (ischecked_timeofftask === "1" ? "" : selectedtimeoff.label)   

          ,"totalweek_wtot_time_hr" : "0"
          ,"totalweek_wtot_time_mm" : "0"

          ,"pro_id" : proid
          ,"task_id" : taskid
          ,"timeoff_id" : timeid
          
          ,"customer_name" : selectedproject.customer_name
          ,"pos_name" : selectedproject.position_name
          
          ,"pos_name_sun" : selectedproject.position_name
          ,"pos_name_mon" : selectedproject.position_name
          ,"pos_name_tue" : selectedproject.position_name
          ,"pos_name_wed" : selectedproject.position_name
          ,"pos_name_thu" : selectedproject.position_name
          ,"pos_name_fri" : selectedproject.position_name
          ,"pos_name_sat" : selectedproject.position_name
          
          ,"parent_sorting" : (ischecked_timeofftask === "1" ? selectedtask.parent_sorting : 0)  
          ,"task_sorting" : (ischecked_timeofftask === "1" ? selectedtask.task_sorting : 0)  
          
          ,"tsid_sun" : 0
          ,"wt_time_sun" : ""
          ,"tss_sun" : 0
          ,"tte_sun" : 0
          ,"ot_sun" : 0
          ,"act_edit_sun" : "y"
          ,"actproject_sun": "Add"
          ,"ee_sun" : 0
          ,"et_sun" : 0
          ,"eo_sun" : 0
          ,"eed_sun": 0
          ,"etd_sun": 0
    
          ,"desc_sun" : ""
          ,"tsssn_sun" : ""
          ,"tsrd_sun" : ""
          ,"ud_sun" : ""
          ,"usn_sun" : ""
          ,"tsd_sun" : ""
          ,"ot_time_sun" : ""
          ,"act_cancel_sun" : ""
          ,"act_del_sun" : ""

          ,"tsid_mon" : 0
          ,"wt_time_mon" : ""
          ,"tss_mon" : 0
          ,"tte_mon" : 0
          ,"ot_mon" : 0
          ,"act_edit_mon" : "y"
          ,"actproject_mon": "Add"
          ,"ee_mon" : 0
          ,"et_mon" : 0
          ,"eo_mon" : 0
          ,"eed_mon": 0
          ,"etd_mon": 0

          ,"desc_mon" : ""
          ,"tsssn_mon" : ""
          ,"tsrd_mon" : ""
          ,"ud_mon" : ""
          ,"usn_mon" : ""
          ,"tsd_mon" : ""
          ,"ot_time_mon" : ""
          ,"act_cancel_mon" : ""
          ,"act_del_mon" : ""
          
          ,"tsid_tue" : 0
          ,"wt_time_tue" : ""
          ,"tss_tue" : 0
          ,"tte_tue" : 0
          ,"ot_tue" : 0
          ,"act_edit_tue" : "y"
          ,"actproject_tue": "Add"
          ,"ee_tue" : 0
          ,"et_tue" : 0
          ,"eo_tue" : 0
          ,"eed_tue": 0
          ,"etd_tue": 0
    
          ,"desc_tue" : ""
          ,"tsssn_tue" : ""
          ,"tsrd_tue" : ""
          ,"ud_tue" : ""
          ,"usn_tue" : ""
          ,"tsd_tue" : ""
          ,"ot_time_tue" : ""
          ,"act_cancel_tue" : ""
          ,"act_del_tue" : ""

          ,"tsid_wed" : 0
          ,"wt_time_wed" : ""
          ,"tss_wed" : 0
          ,"tte_wed" : 0
          ,"ot_wed" : 0
          ,"act_edit_wed" : "y"
          ,"actproject_wed": "Add"
          ,"ee_wed" : 0
          ,"et_wed" : 0
          ,"eo_wed" : 0
          ,"eed_wed": 0
          ,"etd_wed": 0
    
          ,"desc_wed" : ""
          ,"tsssn_wed" : ""
          ,"tsrd_wed" : ""
          ,"ud_wed" : ""
          ,"usn_wed" : ""
          ,"tsd_wed" : ""
          ,"ot_time_wed" : ""
          ,"act_cancel_wed" : ""
          ,"act_del_wed" : ""

          ,"tsid_thu" : 0
          ,"wt_time_thu" : ""
          ,"tss_thu" : 0
          ,"tte_thu" : 0
          ,"ot_thu" : 0
          ,"act_edit_thu" : "y"
          ,"actproject_thu": "Add"
          ,"ee_thu" : 0
          ,"et_thu" : 0
          ,"eo_thu" : 0
          ,"eed_thu": 0
          ,"etd_thu": 0
    
          ,"desc_thu" : ""
          ,"tsssn_thu" : ""
          ,"tsrd_thu" : ""
          ,"ud_thu" : ""
          ,"usn_thu" : ""
          ,"tsd_thu" : ""
          ,"ot_time_thu" : ""
          ,"act_cancel_thu" : ""
          ,"act_del_thu" : ""

          ,"tsid_fri" : 0
          ,"wt_time_fri" : ""
          ,"tss_fri" : 0
          ,"tte_fri" : 0
          ,"ot_fri" : 0
          ,"act_edit_fri" : "y"
          ,"actproject_fri": "Add"
          ,"ee_fri" : 0
          ,"et_fri" : 0
          ,"eo_fri" : 0
          ,"eed_fri": 0
          ,"etd_fri": 0
    
          ,"desc_fri" : ""
          ,"tsssn_fri" : ""
          ,"tsrd_fri" : ""
          ,"ud_fri" : ""
          ,"usn_fri" : ""
          ,"tsd_fri" : ""
          ,"ot_time_fri" : ""
          ,"act_cancel_fri" : ""
          ,"act_del_fri" : ""
          
          ,"tsid_sat" : 0
          ,"wt_time_sat" : ""
          ,"tss_sat" : 0
          ,"tte_sat" : 0
          ,"ot_sat" : 0
          ,"act_edit_sat" : "y"
          ,"actproject_sat": "Add"
          ,"ee_sat" : 0
          ,"et_sat" : 0
          ,"eo_sat" : 0
          ,"eed_sat": 0
          ,"etd_sat": 0

          ,"desc_sat" : ""
          ,"tsssn_sat" : ""
          ,"tsrd_sat" : ""
          ,"ud_sat" : ""
          ,"usn_sat" : ""
          ,"tsd_sat" : ""
          ,"ot_time_sat" : ""
          ,"act_cancel_sat" : ""
          ,"act_del_sat" : ""
        }]);
        document.getElementById("modalAddProject_Close").click();
      }
    }

  }

  function onclick_ModalEditTimeSheet(ActProject 
                                    , pro_id
                                    , task_id
                                    , timeoff_id
                                    , act_task_timeoff
                                    , project_name
                                    , day
                                    , dt_dayFull
                                    , customer_name
                                    , taskname
                                    , tasksubname
                                    , timeoff_name
                                    , pos_name
                                    , ee
                                    , et
                                    , eo
                                    , eed
                                    , etd
                                    , desc
                                    , tsssn
                                    , tsrd
                                    , ud
                                    , tss
                                    , usn
                                    , tsd
                                    , ot_time
                                    , wt_time
                                    , act_cancel
                                    , act_del
                                    , act_edit
                                    , rowindex
                                    , tsid
                                    , dt_day
                                    ){

                                      

    document.getElementById("lbl_modalTS_ProjectName").innerHTML = project_name
    document.getElementById("lbl_modalTS_CusName").innerHTML = customer_name 

    setData_modalTS_Task(taskname);
    setData_modalTS_SubTask(tasksubname);
    setData_modalTS_Timeoff(timeoff_name);
    
    document.getElementById("lbl_modalTS_PositionName").innerHTML = pos_name;

    document.getElementById("lbl_modalTS_Day").innerHTML = "(" + day + ")"
    document.getElementById("lbl_modalTS_Date").innerHTML = dt_dayFull
    if (icontoday.toLowerCase() === day.toLowerCase() && icontoday !== "")
    {
      document.getElementById("i_model_Today").style.display = "";
    }
    else
    {
      document.getElementById("i_model_Today").style.display = "none";
    }


    if (tss === ConfigETC.TS_InProgress_Value || tss === ConfigETC.TS_Reject_Value)
    {
      document.getElementById("txt_modalTS_Note").value = desc;
      document.getElementById("txt_modalTS_Note").style.display = "";
      document.getElementById("lbl_modalTS_Note").style.display = "none";
    }
    else
    {
      document.getElementById("lbl_modalTS_Note").innerHTML = desc;
      document.getElementById("lbl_modalTS_Note").style.display = "";
      document.getElementById("txt_modalTS_Note").style.display = "none";
    }


    if (act_task_timeoff === "T"){
      document.getElementById("div_modalTS_Expenses1").style.display = "";
      
    }
    else
    {
      document.getElementById("div_modalTS_Expenses1").style.display = "none";
     
    }


    setData_modalTS_ActProject(ActProject);
    setData_modalTS_act_task_timeoff(act_task_timeoff);
    setData_modalTS_Extra(ee);
    setData_modalTS_Travel(et);
    setData_modalTS_Other(eo);

    setData_modalTS_Extra_day(eed);
    setData_modalTS_Travel_distance(etd);



    setData_modalTS_tsid(tsid);
    setData_modalTS_pro_id(pro_id);
    setData_modalTS_task_id(task_id);
    setData_modalTS_timeoff_id(timeoff_id);

    setData_modalTS_ts_date(dt_day);
    setData_modalTS_day(day);

    
    setData_modalTS_tss(tss);
    setData_modalTS_tsssn(tsssn);

    if (tsrd !== "")
    {
      let rejectArray = tsrd.split('|'); 
      if (rejectArray.length === 3){
        setData_modalTS_tsrd(rejectArray[0]);
        setData_modalTS_tsrd2(rejectArray[1]);
        setData_modalTS_tsrd3(rejectArray[2]);
      }
      else
      {
        setData_modalTS_tsrd("");
        setData_modalTS_tsrd2("");
        setData_modalTS_tsrd3("");
      }
    }
    else
    {
      setData_modalTS_tsrd("");
      setData_modalTS_tsrd2("");
      setData_modalTS_tsrd3("");
    }


    setData_modalTS_ud(ud);

    setData_modalTS_usn(usn);
    setData_modalTS_tsd(tsd);
  
    setData_modalTS_wt_time(wt_time);
    setData_modalTS_ot_time(ot_time);


    setData_modalTS_act_edit(act_edit);
    setData_modalTS_act_cancel(act_cancel);
    setData_modalTS_act_del(act_del);
    setData_modalTS_rowindex(rowindex);

  }

  const handleBlur_modalTS_time = (e , act) => {
    if (act === "wt")
    {
      setData_modalTS_wt_time(e.target.value);
    }
    else
    {
      setData_modalTS_ot_time(e.target.value);
    }
  };

  function onclick_savetimesheetpopup(actsubmit){

    let wt = data_modalTS_wt_time
    wt = wt.replace("h", "0");
    wt = wt.replace("h", "0");
    wt = wt.replace("m", "0");
    wt = wt.replace("m", "0");

    
    let ot = data_modalTS_ot_time
    ot = ot.replace("h", "0");
    ot = ot.replace("h", "0");
    ot = ot.replace("m", "0");
    ot = ot.replace("m", "0");
    
    let msgerror = ""
    if (data_modalTS_act_task_timeoff === "T")
    {
      if (isSVOT === true)
      {
        if ((wt === "00:00" || wt === "") && (ot === "00:00" || ot === ""))
        {
          msgerror = MsgDescription.ERR025
        }
      }
      else
      {
        if ((wt === "00:00" || wt === ""))
        {
          msgerror = MsgDescription.ERR026
        }
      }
    }
    else 
    {
      if ((wt === "00:00" || wt === "") )
      {
        msgerror = MsgDescription.ERR023
      }
    }

    if (msgerror === "")
    {

      const _isresult = { result: 0 };
      SaveTimeSheet(data_modalTS_tsid
                  ,data_modalTS_ts_date
                  ,data_modalTS_pro_id
                  ,data_modalTS_task_id
                  ,data_modalTS_timeoff_id
                  ,wt
                  ,ot
                  ,data_modalTS_Extra
                  ,data_modalTS_Travel
                  ,data_modalTS_Other
                  
                  ,data_modalTS_Extra_day
                  ,data_modalTS_Travel_distance

                  ,document.getElementById("txt_modalTS_Note").value
                  ,(actsubmit === "submit" ? "yes" : "")
                  ,"popup"
                  ,data_modalTS_day
                  ,data_modalTS_rowindex
                  ,_isresult
                  ,function() {
                    if (_isresult.result === 1)
                    {
                      setIscntreset_TSCall_DP(iscntreset_TSCall_DP + 1)
                    }
                  });
    }
    else
    {
      Class_ETC_MsgError(msgerror , null);
    }


  }

  function onclick_deltimesheetpopup(){
    Class_ETC_Warning(MsgDescription.CFM002, BeforeDelTimesheet);
  }
  
  function onclick_Cenceltimesheetpopup(){
    Class_ETC_Warning(MsgDescription.CFM004, BeforeCencelTimesheet);
  }

  const onChange_CheckboxAllSubmit = (e) =>{
    const { checked } = e.target;
    CB_Submit(checked);
  }

  function onChange_CheckboxSubmit(){
    let isck = true;
    let isoneck = false;
    for (let i = 0 ; i < listtimesheetSubmit.length; i++)
    {
      try
      {
        if (document.getElementById("chk_modalsubmit_" + listtimesheetSubmit[i].dday).checked === false)
        {
          isck = false;
        }
        else
        {
          isoneck = true;
        }
      }
      catch{}
    }
    setIsdisabled_btnsubmitweek(!isoneck);
    document.getElementById("chk_modalsubmit_all").checked = isck;
  }

  function onclick_SaveSubmitWeek(){

    let sun = "0";
    let mon = "0";
    let tue = "0";
    let wed = "0";
    let thu = "0";
    let fri = "0";
    let sat = "0";
    for (let i = 0 ; i < listtimesheetSubmit.length; i++)
    {
      try
      {
        if (document.getElementById("chk_modalsubmit_" + listtimesheetSubmit[i].dday).checked === true)
        {
          if (listtimesheetSubmit[i].dday.toLowerCase() === "sun")
          {
            sun = "1";
          }
          else if (listtimesheetSubmit[i].dday.toLowerCase() === "mon")
          {
            mon = "1";
          }
          else if (listtimesheetSubmit[i].dday.toLowerCase() === "tue")
          {
            tue = "1";
          }
          else if (listtimesheetSubmit[i].dday.toLowerCase() === "wed")
          {
            wed = "1";
          }
          else if (listtimesheetSubmit[i].dday.toLowerCase() === "thu")
          {
            thu = "1";
          }
          else if (listtimesheetSubmit[i].dday.toLowerCase() === "fri")
          {
            fri = "1";
          }
          else if (listtimesheetSubmit[i].dday.toLowerCase() === "sat")
          {
            sat = "1";
          }
        }
      }
      catch{}
    }

    if (sun === "0" && mon === "0" && tue === "0" && wed === "0" && thu === "0" && fri === "0" && sat === "0")
    {
      Class_ETC_MsgError(MsgDescription.ERR024 , null);
    }
    else
    {
      SaveSubmitWeek(sun , mon , tue , wed , thu , fri , sat)
    }


  }

  function onclick_Search(){
    let ValueDateS = ""
    let ValueDateE = ""
    let ValueStatus = ""
    let ValueProject = ""
    let ValueCus = ""
    let ValueTimeoff = ""
    let ValueTask = ""

    if (searchstatus !== null) {
      ValueStatus = "";
      if (searchstatus.length > 0) {
        for (let i = 0; i < searchstatus.length; i++) {
          ValueStatus = ValueStatus + (ValueStatus === "" ? "" : ",") + searchstatus[i].value;
        }
      }
    }

    
    if (searchProject !== null) {
      ValueProject = "";
      if (searchProject.length > 0) {
        for (let i = 0; i < searchProject.length; i++) {
          ValueProject = ValueProject + (ValueProject === "" ? "" : ",") + searchProject[i].value;
        }
      }
    }

    if (searchCus !== null) {
      ValueCus = searchCus.value;

      if (ValueCus === -1)
      {
        ValueCus = "";
      }
    }

    if (searchTimeoff !== null) {
      ValueTimeoff = "";
      if (searchTimeoff.length > 0) {
        for (let i = 0; i < searchTimeoff.length; i++) {
          ValueTimeoff = ValueTimeoff + (ValueTimeoff === "" ? "" : ",") + searchTimeoff[i].value;
        }
      }
    }

    if (searchTask !== null) {
      ValueTask = "";
      if (searchTask.length > 0) {
        for (let i = 0; i < searchTask.length; i++) {
          ValueTask = ValueTask + (ValueTask === "" ? "" : ",") + searchTask[i].value;
        }
      }
    }
    let date_rang = document.getElementById("txt_SearchDate").value;
    if (date_rang !== "")
    {
      let datevalue =  date_rang.split(" - ");
      if (datevalue.length === 2)
      {
        ValueDateS = datevalue[0];
        ValueDateE   = datevalue[1];
      }
    }
    setIssearch(1);
    setIsLoadProgress(true);
    if (listcalendar.length > 0)
    {
      document.getElementById("hd_Slideindex_Goto").value = "0"
      document.getElementById("btn_GotoSet").click();
    }

    BindListCalendarBarAPI("0" , "0" , "" , 1 , ValueStatus.toString() , ValueProject.toString(), 
                           ValueCus.toString() , ValueTimeoff.toString() , 
                          ValueTask.toString() , ValueDateS , ValueDateE , function() {
      setIsLoadProgress(false);
    });


  }
  
  function onclick_reset(){
    setIscntreset((iscntreset) => iscntreset + 1);
    setSearchstatus(null)
    document.getElementById("txt_SearchDate").value = "";
  }
  
  function SearchonChangevalueproject(e){
    setSearchProject(e)
  }
  
  function SearchonChangevaluecus(e){
    setSearchCus(e)
    if (e === null)
    {
      document.getElementById("hd_cus_id_search").value = "-1";
    }
    else
    {
      document.getElementById("hd_cus_id_search").value = e.value;
    }
    setBindProjectBycusid((bindProjectBycusid) => bindProjectBycusid + 1);
    setIsLoadProgress(true);
  }

  function SearchonChangevaluetimeoff(e){
    setSearchTimeoff(e)
  }

  function SearchonChangevalueTask(e){
    setSearchTask(e)
  }

  function onclickViewReject(){

    setSearchstatus([
      { value : ConfigETC.TS_Reject_Value, label : ConfigETC.TS_Reject_Text } 
    ]);

    setIscntreset(iscntreset + 1)
    document.getElementById("txt_SearchDate").value = "";


    setIssearch(1);
    setIsLoadProgress(true);
    if (listcalendar.length > 0)
    {
      document.getElementById("hd_Slideindex_Goto").value = "0"
      document.getElementById("btn_GotoSet").click();
    }
    BindListCalendarBarAPI("0" , "0" , "" , 1 , "12" , "" ,"" , "" , "" , "" , "" , function() {
      setIsLoadProgress(false);
    });
  }

  //#endregion
  

  //#region __ carousel Bar __
  function onclicknext(next , goToSlide , currentSlide , cntck)
  {
    
    if (issearch === 1)
    {// จากปุ่ม Search เราจะ เลื่อนได้อย่างเดียว ไม่ดึงข้อมูลเพิ่ม
      next()
    }
    else
    {
      let ck_next = nowSlide + checknextSlide - (cntck === 10 ? 0 : 5);
      //console.log("ck : " + ck_next.toString()  + " , now : " + nowSlide.toString() + " , next : " + nextSlide.toString());
      if (nextSlide <= ck_next)
      {
        setIsLoadProgress(true);
        let wb = ck_next;
        BindListcalendarBar( wb.toString() , _slidesToslide.toString() , "next" , function() {
          setNowSlide((nowSlide + _slidesToslide === 0 ? 1 : nowSlide + _slidesToslide));
          setNextSlide(nextSlide + _slidesToslide);
          goToSlide(currentSlide + _slidesToslide);
          setIsLoadProgress(false);
          //next()
        });
      }
      else
      {
        setNowSlide((nowSlide + _slidesToslide === 0 ? 1 : nowSlide + _slidesToslide));
        next()
      }
    }
  }

  function onclickGotoSet(goToSlide)
  {
    let indexGoto = 0;
    try
    {
      indexGoto = parseInt(document.getElementById("hd_Slideindex_Goto").value)
    }
    catch
    {
      indexGoto = 0
    }
    goToSlide(indexGoto);
  }

  function onclickprevious(previous , currentSlide)
  {
    
    if (issearch === 1)
    {// จากปุ่ม Search เราจะ เลื่อนได้อย่างเดียว ไม่ดึงข้อมูลเพิ่ม
      previous()
    }
    else
    {
      // let ck_next = nowSlide + checknextSlide 
      // console.log("ck : " + ck_next.toString()  + " , now : " + nowSlide.toString() + " , next : " + nextSlide.toString());
      if (currentSlide <= 0)
      {
        setIsLoadProgress(true);
        BindListcalendarBar( previousSlide.toString() , _slidesToslide.toString() , "previous" , function() {
          setPreviousSlide(previousSlide + (_slidesToslide * -1)) 
          setNowSlide((nowSlide - _slidesToslide === (1 - _slidesToslide) ? _slidesToslide * -1 : nowSlide - _slidesToslide));
          previous()
          setIsLoadProgress(false);
        });
      }
      else
      {
        setNowSlide((nowSlide - _slidesToslide === (1 - _slidesToslide) ? _slidesToslide * -1 : nowSlide - _slidesToslide));
        previous()
      }
    }

  }

  const ButtonGroup = ({ next, previous, goToSlide, ...rest }) => {
    const {
      carouselState: { currentSlide , deviceType }
    } = rest;
    const cntck = (deviceType === "desktop" ? itemsdesktop : (deviceType === "tablet" ? itemstablet : itemsmobile))
    return (
      (((issearch === 1 && listcalendar.length > 0) || (issearch === 0)) &&
      <> 
        {((issearch === 1 && currentSlide !== 0) || (issearch === 0)) &&
          <button className="carousel-control-prev" onClick={()=> onclickprevious(previous , currentSlide)}  >
            <i className="fa fa-angle-left" />
          </button>
        }
        {((issearch === 1 && currentSlide < (listcalendar.length - cntck)) || (issearch === 0)) &&
          <button className="carousel-control-next " onClick={()=> onclicknext(next , goToSlide , currentSlide , cntck)} >
            <i className="fa fa-angle-right" />
          </button>
        }
        <button id="btn_GotoSet" style={{display:"none"}} onClick={()=> onclickGotoSet(goToSlide)} >
          <i className="fa fa-angle-right" />
        </button>
      </>
      )
    );
  };

  const responsive = {
    desktop: {
      breakpoint: { max: desktopmax, min: tabletmax },
      items: itemsdesktop,
      partialVisibilityGutter: 15
    },
    tablet: {
      breakpoint: { max: tabletmax, min: mobilemax },
      items: itemstablet,
      partialVisibilityGutter: 15
    },
    mobile: {
      breakpoint: { max: mobilemax, min: 0 },
      items: itemsmobile,
      partialVisibilityGutter: 15
    }
  };
  //#endregion


  return (
    <>
      <Helmet>
        <title>My Time sheet</title>
      </Helmet>
      {isLoadProgress && (
        <div
          id="divLoadingProgress"
          name="divLoadingProgress"
          align="center"
          className="divWaiting"
        >
          <img alt="progress" src="../dist/img/loading.gif" />
        </div>
      )}

        

      <div className="content-wrapper">
        <div>
          <div className="content-header">
            <div className="container-fluid">


              {/* ###################### ส่วนบนสุด ###################### */}
             
              <div className="row">
                <div className="col-lg-9 col-md-12 col-12">
                  <div className="text-left">
                      <h1>
                        <i className="fas fa-table" /> My Time sheet
                        <HtmlTooltip
                            title={
                              <React.Fragment>
                                <div className="text-left">
                                  <p><i className="far fa-square text-outline"></i> Blank </p>
                                  <p><i className="fas fa-square text-InProgress"></i> In Progress</p>
                                  <p><i className="fas fa-square text-ToReview"></i> To Review/To Approve<br></br>/Approved/Clearing</p>
                                  <p><i className="fas fa-square text-red"></i> Reject</p>
                              </div> 
                              </React.Fragment>
                            }
                          >
                            <i className="fas fa-info-circle text-smaller"  ></i>
                          </HtmlTooltip>
                      </h1>

                      
                    </div>

                 
                    {(cntReject > 0 && 
                      <>
                        <div className="">
                          <a
                            className="btn btn-default bg-danger btn-sm"
                            onClick={onclickViewReject}
                            href="#!"
                          >
                            <i className="far fa-calendar-times" />{" "}
                            You have<span className="badge text-biger">{cntReject}</span>
                            Reject
                          </a>
                        </div>
                      </>  
                    )}
                    

                </div>
                <div className="col-lg-3 col-md-12 col-12">
                <div className="float-right">
                      <button type="button" className="btn btn-tool"  onClick={onclick_refresh} >
                        <i className="fas fa-sync-alt" /> Refresh
                      </button>
                      <button
                        type="button"
                        className="btn btn-tool"
                        data-toggle="collapse"
                        href="#collapseOne"
                        id="btn_Filter"
                      >
                        <i className="fas fa-filter" /> Filter
                      </button>
                    </div>
                </div>
              </div>
              
              {/* ###################### ส่วนบนสุด ###################### */}


              {/* ###################### Search ###################### */}
              <div className="row mt-1" id="accordion">
                <div className="col-md-10 offset-md-1">
                  <div
                    className="collapse"
                    id="collapseOne"
                    data-parent="#accordion"
                  >

                    <div className="row m-0">
                          <div className="col-lg-5 col-12">
                            <div className="form-group m-0">
                              <label className="text-small p-0 m-0">Date</label>
                              <div className="input-group">
                                <DateRangePickerComponent 
                                    id="txt_SearchDate"
                                    format='dd/MM/yyyy' 
                                    presets={dataPresets}
                                    strictMode={true}
                                >
                                </DateRangePickerComponent>      
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-5 col-12">
                            <div className="form-group">
                              <label className="text-small p-0 m-0">Customer</label>
                              {isLoadedConfigData && 
                                  <SelectCustomer
                                  API_URL={configData.API_URL}
                                  cus_status={"-1"}
                                  selectismulti={false}
                                  SelectTextDefault={ConfigETC.ddl_All}
                                  resetSelect={iscntreset}
                                  onChangevalue={SearchonChangevaluecus}
                                  iscloseMenuOnSelect={true}
                                ></SelectCustomer>
                              }
                            </div>
                            <input type="hidden" id="hd_cus_id_search" ></input>
                          </div>
                    </div>
                    <div className="row m-0">
                      <div className="col-lg-5 col-12">
                        <div className="form-group">
                          <label className="text-small p-0 m-0">Project</label>
                          {isLoadedConfigData && 
                              <SelectProjectByTimeSheetBySearch
                              API_URL={configData.API_URL}
                              pro_status={"-1"}
                              staff_status={"-1"}
                              selectismulti={true} 
                              SelectTextDefault={ConfigETC.ddl_All}
                              resetSelect={iscntreset}
                              onChangevalue={SearchonChangevalueproject}
                              iscloseMenuOnSelect={false}
                              
                              Valueshow={prm_searchProject}
                              setvalueSelect={iscnt_setvalue}
                              BindProjectBycusid={bindProjectBycusid}
                              hd_cus_id={"hd_cus_id_search"}
                              Bindendfunction={Bindendfunction_SP}
                            ></SelectProjectByTimeSheetBySearch>
                          }
                        </div>
                      </div>
                      <div className="col-lg-5 col-12">
                        <div className="form-group">
                          <label className="text-small p-0 m-0">Task</label>
                          {isLoadedConfigData && 
                            <SelectTaskMultiGroup
                              API_URL={configData.API_URL}
                              SelectTextDefault={ConfigETC.ddl_All}
                              resetSelect={iscntreset}
                              onChangevalue={SearchonChangevalueTask}
                              iscloseMenuOnSelect={false}
                              
                              Valueshow={prm_searchTask}
                              setvalueSelect={iscnt_setvalue}
                            ></SelectTaskMultiGroup>       
                          } 
                        </div>
                      </div>
                     
                    </div>
                    <div className="row m-0">
                    <div className="col-lg-5 col-12">
                        <div className="form-group">
                          <label className="text-small p-0 m-0">Time off</label>
                          {isLoadedConfigData && 
                            <SelectTimeoff 
                              API_URL={configData.API_URL}
                              timeoff_status={"-1"}
                              selectismulti={true} 
                              SelectTextDefault={ConfigETC.ddl_All}
                              resetSelect={iscntreset}
                              onChangevalue={SearchonChangevaluetimeoff}
                              iscloseMenuOnSelect={false}
                              
                              
                              Valueshow={prm_searchTimeoff}
                              setvalueSelect={iscnt_setvalue}
                              ></SelectTimeoff>
                          }
                        </div>
                      </div>
                      <div className="col-lg-5 col-12">
                        <div className="form-group m-0">
                          <label className="text-small p-0 m-0">Status</label>
                          <Select
                            closeMenuOnSelect={false}
                            placeholder={ConfigETC.ddl_All}
                            isMulti
                            value={searchstatus}
                            options={Bind_Select_Status('MyTimeSheet')}
                            menuPortalTarget={document.body}
                            onChange={(e) => setSearchstatus(e)}
                              styles={customStylesSelect}
                          />

                        </div>
                      </div>
                      
                      <div className="col-lg-2 col-12">
                        <div className="form-group m-0">
                          <label className="text-small p-0 m-0" />
                          <div className="card-tools">
                            <button
                              type="button"
                              className="btn btn-primary btn-sm"
                              onClick={onclick_Search}
                            >
                              <i className="fas fa-search" /> Search
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* ###################### Search ###################### */}

              <input type="hidden" id="hd_Slideindex_Goto" ></input>
              {(listcalendar.length > 0 && 
                <>
                  <div className="row mt-2">
                    <div className="col-md-12">
                      <div className="MultiCarousel card mb-0">
                          <Carousel
                            responsive={responsive}
                            arrows={false}
                            draggable={false}
                            keyBoardControl={false}
                            additionalTransfrom={0}
                            slidesToSlide={_slidesToslide}
                            renderButtonGroupOutside
                            customButtonGroup={<ButtonGroup />}
                          >
                            {(listcalendar.map((en, index) => (
                              <div key={"div_barweek" + index.toString()} className="item">
                                <div className="page-item ">
                                  <a href="#!" className={en.uniqueid === calendaractive ? "page-link active" : "page-link"}
                                    onClick={() => onclick_viewProject(en.date_Start 
                                                                    , en.uniqueid
                                                                    , en.sun
                                                                    , en.mon
                                                                    , en.tue
                                                                    , en.wed
                                                                    , en.thu
                                                                    , en.fri
                                                                    , en.sat
                                                                    , en.isholiday_sun
                                                                    , en.isholiday_mon
                                                                    , en.isholiday_tue
                                                                    , en.isholiday_wed
                                                                    , en.isholiday_thu
                                                                    , en.isholiday_fri
                                                                    , en.isholiday_sat
                                                                    , en.dt_date_sun
                                                                    , en.dt_date_mon
                                                                    , en.dt_date_tue
                                                                    , en.dt_date_wed
                                                                    , en.dt_date_thu
                                                                    , en.dt_date_fri
                                                                    , en.dt_date_sat
                                                                    , en.dt_Full_sun
                                                                    , en.dt_Full_mon
                                                                    , en.dt_Full_tue
                                                                    , en.dt_Full_wed
                                                                    , en.dt_Full_thu
                                                                    , en.dt_Full_fri
                                                                    , en.dt_Full_sat
                                                                    )}
                                  >
                                    <div>{en.dayShow}</div>
                                    <div className="text-bold">{en.monthShow}</div>
                                    <div className="week-icon">
                                      <TimesheetCalendarbarShowStatus key={"tcbss_sun" + index.toString()} status={en.sun} title={"Sunday status"} />
                                      <TimesheetCalendarbarShowStatus key={"tcbss_mon" + index.toString()} status={en.mon} title={"Monday status"} />
                                      <TimesheetCalendarbarShowStatus key={"tcbss_tue" + index.toString()} status={en.tue} title={"Tuesday status"} />
                                      <TimesheetCalendarbarShowStatus key={"tcbss_wed" + index.toString()} status={en.wed} title={"Wednesday status"} />
                                      <TimesheetCalendarbarShowStatus key={"tcbss_thu" + index.toString()} status={en.thu} title={"Thursday status"} />
                                      <TimesheetCalendarbarShowStatus key={"tcbss_fri" + index.toString()} status={en.fri} title={"Friday status"} />
                                      <TimesheetCalendarbarShowStatus key={"tcbss_sat" + index.toString()} status={en.sat} title={"Saturday status"} />
                                    </div>
                                  </a>
                                </div>
                              </div>
                            )))}
                          </Carousel>
                      </div>
                    </div>
                  </div>
                </>
              ) || ( listcalendar.length === 0 &&
                <>
                  <div className="row mt-2">
                    <div className="col-md-12">
                      <div className="card  shadow">
                        <div className="card-body p-0">

                          <table className="table table-head-fixed text-nowrap table-hover" >
                            <tbody>
                              <tr>
                                <td align="center">
                                  {ConfigETC.NoData}
                                </td>
                              </tr>
                            </tbody>
                          </table>

                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}

            </div>
            {/* /.container-fluid */}
          </div>
          {/* /.content-header */}
          {/* Main content */}

          <input type="hidden" id="hdCBP_dt_sun" ></input>
          <input type="hidden" id="hdCBP_dt_mon" ></input>
          <input type="hidden" id="hdCBP_dt_tue" ></input>
          <input type="hidden" id="hdCBP_dt_wed" ></input>
          <input type="hidden" id="hdCBP_dt_thu" ></input>
          <input type="hidden" id="hdCBP_dt_fri" ></input>
          <input type="hidden" id="hdCBP_dt_sat" ></input>
          {isshowDetailTs && 
          <>

            <section className="content">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-md-12">
                    <div className="card shadow">
                      
                      
                      {/* ###################### Calendar By Project By Day ###################### */}
                      
                      <div
                        className="card-body table-responsive p-0"
                      >

                        <TableContainer sx={{ maxHeight: 500}}  >
                          <Table
                            stickyHeader
                            aria-label="sticky table"
                            className="table table-head-fixed  table-fit"
                            style={{ margin: 0   }}
                            border={0}
                          >
                            <TableHead>
                              <TableRow className="card-footer">
                                <TableCell className="align-top" style={{ width: "10px" }}>
                                  
                                </TableCell>
                                <TableCell className="align-top" style={{ width: "180px" }} >Project</TableCell>
                                <TableCell className="align-top" style={{ width: "240px" }} >Task</TableCell>
                                <TableCell
                                  className={"text-center-input align-top " + 
                                            (isholiday_sun === "y" ? "bg-light" : "")}
                                  style={{ width: "140px" }}
                                >
                                  <div className="ml-1">
                                  <div className="day-icon">
                                    <TimesheetCalendarbarShowStatus status={ssp_sun} title={"Sunday status"} />
                                  </div>
                                  <div className="text-bold">SUN</div>
                                  <div className="text-normal" >
                                    <span id="span_day_sun"  ></span>
                                    <IconTodayShoworNot isshow={icontoday === "sun" ? "show" : ""} ></IconTodayShoworNot>
                                  </div>
                                  </div>
                                </TableCell>
                                <TableCell
                                  className={(isholiday_mon === "y" ? h_holi : h_nholi)}
                                  style={{ width: "140px" }}
                                >
                                  <div className="ml-1">
                                  <div className="day-icon">
                                    <TimesheetCalendarbarShowStatus status={ssp_mon} title={"Monday status"} />
                                  </div>
                                  <div className="text-bold">MON</div>
                                  <div className="text-normal" >
                                    <span id="span_day_mon"  ></span>
                                    <IconTodayShoworNot isshow={icontoday === "mon" ? "show" : ""} ></IconTodayShoworNot>
                                  </div>
                                  </div>
                                </TableCell>
                                <TableCell
                                  className={(isholiday_tue === "y" ? h_holi : h_nholi)}
                                  style={{ width: "140px" }}
                                >
                                  <div className="ml-1">
                                  <div className="day-icon">
                                    <TimesheetCalendarbarShowStatus status={ssp_tue} title={"Tuesday status"} />
                                  </div>
                                  <div className="text-bold">TUE</div>
                                  <div className="text-normal" >
                                    <span id="span_day_tue" ></span>
                                    <IconTodayShoworNot isshow={icontoday === "tue" ? "show" : ""} ></IconTodayShoworNot>
                                  </div>
                                  </div>
                                </TableCell>
                                <TableCell
                                  className={(isholiday_wed === "y" ? h_holi : h_nholi)}
                                  style={{ width: "140px" }}
                                >
                                  <div className="ml-1">
                                  <div className="day-icon">
                                    <TimesheetCalendarbarShowStatus status={ssp_wed} title={"Wednesday status"} />
                                  </div>
                                  <div className="text-bold">WED</div>
                                  <div className="text-normal" >
                                    <span id="span_day_wed" ></span>
                                    <IconTodayShoworNot isshow={icontoday === "wed" ? "show" : ""} ></IconTodayShoworNot>
                                  </div>
                                  </div>
                                </TableCell>
                                <TableCell
                                  className={(isholiday_thu === "y" ? h_holi : h_nholi)}
                                  style={{ width: "140px" }}
                                >
                                  <div className="ml-1">
                                  <div className="day-icon">
                                    <TimesheetCalendarbarShowStatus status={ssp_thu} title={"Thursday status"} />
                                  </div>
                                  <div className="text-bold"> THU</div>
                                  <div className="text-normal"  >
                                    <span id="span_day_thu" ></span>
                                    <IconTodayShoworNot isshow={icontoday === "thu" ? "show" : ""} ></IconTodayShoworNot>
                                  </div>
                                  </div>
                                </TableCell>
                                <TableCell
                                  className={(isholiday_fri === "y" ? h_holi : h_nholi)}
                                  style={{ width: "140px" }}
                                >
                                  <div className="ml-1">
                                  <div className="day-icon">
                                    <TimesheetCalendarbarShowStatus status={ssp_fri} title={"Friday status"} />
                                  </div>
                                  <div className="text-bold">FRI </div>
                                  <div className="text-normal" >
                                    <span id="span_day_fri" ></span>
                                    <IconTodayShoworNot isshow={icontoday === "fri" ? "show" : ""} ></IconTodayShoworNot>
                                  </div>
                                  </div>
                                </TableCell>
                                <TableCell
                                  className={(isholiday_sat === "y" ? h_holi : h_nholi)}
                                  style={{ width: "140px" }}
                                >
                                  <div className="ml-1">
                                  <div className="day-icon">
                                    <TimesheetCalendarbarShowStatus status={ssp_sat} title={"Saturday status"} />
                                  </div>
                                  <div className="text-bold">SAT</div>
                                  <div className="text-normal" >
                                    <span id="span_day_sat" ></span>
                                    <IconTodayShoworNot isshow={icontoday === "sat" ? "show" : ""} ></IconTodayShoworNot>
                                  </div>
                                  </div>
                                </TableCell>
                                <TableCell
                                  className="align-items-center text-muted text-center"
                                  style={{ width: "140px" }}
                                >
                                  Total 
                                  <i className="fas fa-info-circle tip text-muted" data-toggle="tooltip" 
                                  title={isSVOT === true ? "Work time & Time Off + Over time" : "Work time & Time Off"}> </i>
                                  <br />
                                  <span className="text-smaller">
                                    {(isSVOT === true &&
                                      <>
                                        (WT+OT)
                                      </>
                                    )||
                                    <>
                                        (WT)
                                    </>}
                                  </span>
                                </TableCell>
                              </TableRow>
                            </TableHead>


                            <TableBody>
                              {(listcalendarbyproject.length === 0 && (
                                    <TableRow key={1}>
                                      <TableCell colSpan={11} align="center">
                                        {ConfigETC.NoData}
                                      </TableCell>
                                    </TableRow>
                                  )) ||
                                  listcalendarbyproject
                                    .sort(function(a , b) {
                                      if (a.project_name !== b.project_name) {
                                        return a.project_name.localeCompare(b.project_name); 
                                      } 
                                      else if ((a.act_task_timeoff === "T" ? 1 : 2) !== (b.act_task_timeoff === "T" ? 1 : 2)) {
                                        return a.act_task_timeoff.localeCompare(b.act_task_timeoff); 
                                      }
                                      else if (a.parent_sorting !== b.parent_sorting) {
                                        return a.parent_sorting - b.parent_sorting;
                                      }
                                      else if (a.task_sorting !== b.task_sorting) {
                                        return a.task_sorting - b.task_sorting;
                                      }
                                      else
                                      {
                                        return a.timeoff_name.localeCompare(b.timeoff_name); 
                                      }
                                    })
                                    .map((row , index) => (
                                    <TableRow key={"tr_projeact" + row.rowindex.toString()}>
                                      <TableCell >
                                        {index + 1}
                                      </TableCell>
                                      <TableCell  className="text-left">
                                        <div>{row.project_name}</div>
                                      </TableCell>
                                      <TableCell  className="text-left">
                                        {row.act_task_timeoff === "T" &&
                                          <div>
                                            {row.taskname + "/" + row.tasksubname}
                                          </div>
                                        } 
                                        {row.act_task_timeoff === "TO" &&
                                          <div>
                                            <span className="text-italic text-muted">Time Off:</span> {row.timeoff_name}
                                          </div>
                                        }
                                      </TableCell>
                                      <TableCell className={(isholiday_sun === "y" ? b_holi : b_nholi)} align="center">
                                      
                                          <TimesheetCellDayProject tsid={row.tsid_sun} day={"Sun"}
                                          dt_day={dt_sun} 
                                          dt_dayFull={dt_Full_sun} 
                                          wt_time={row.wt_time_sun}
                                          tss={row.tss_sun}
                                          tte={row.tte_sun}
                                          ot={row.ot_sun}
                                          act_edit={row.act_edit_sun}
                                          ActProject={row.actproject_sun}
                                          pro_id={row.pro_id}
                                          project_name={row.project_name}
                                          task_id={row.task_id}
                                          timeoff_id={row.timeoff_id}
                                          act_task_timeoff={row.act_task_timeoff}
                                          onclick_ModalEditTimeSheet={onclick_ModalEditTimeSheet}
                                          customer_name={row.customer_name}
                                          taskname={row.taskname}
                                          tasksubname={row.tasksubname}
                                          timeoff_name={row.timeoff_name}
                                          pos_name={row.pos_name_sun}
                                          ee={row.ee_sun}
                                          et={row.et_sun}
                                          eo={row.eo_sun}
                                          eed={row.eed_sun}
                                          etd={row.etd_sun}

                                          desc={row.desc_sun}
                                          tsssn={row.tsssn_sun}
                                          tsrd={row.tsrd_sun}
                                          ud={row.ud_sun}
                                          usn={row.usn_sun}
                                          tsd={row.tsd_sun}
                                          ot_time={row.ot_time_sun}
                                          act_cancel={row.act_cancel_sun}
                                          act_del={row.act_del_sun}
                                          rowindex={row.rowindex}
                                          holiday={isholiday_sun}     
                                          SaveTimeSheet={SaveTimeSheet}      
                                          DelTimesheet={DelTimesheet}     
                                          resetvalue={iscntreset_TSCall_DP}       
                                          isSVOT={isSVOT}            
                                          >
                                          </TimesheetCellDayProject>
                                      </TableCell>
                                      <TableCell className={(isholiday_mon === "y" ? b_holi : b_nholi)} align="center">
                                          <TimesheetCellDayProject tsid={row.tsid_mon} day={"Mon"} 
                                          dt_day={dt_mon}
                                          dt_dayFull={dt_Full_mon} 
                                          wt_time={row.wt_time_mon}
                                          tss={row.tss_mon}
                                          tte={row.tte_mon}
                                          ot={row.ot_mon}
                                          act_edit={row.act_edit_mon}
                                          ActProject={row.actproject_mon}
                                          pro_id={row.pro_id}
                                          project_name={row.project_name}
                                          task_id={row.task_id}
                                          timeoff_id={row.timeoff_id}
                                          act_task_timeoff={row.act_task_timeoff}
                                          onclick_ModalEditTimeSheet={onclick_ModalEditTimeSheet}
                                          customer_name={row.customer_name}
                                          taskname={row.taskname}
                                          tasksubname={row.tasksubname}
                                          timeoff_name={row.timeoff_name}
                                          pos_name={row.pos_name_mon}
                                          ee={row.ee_mon}
                                          et={row.et_mon}
                                          eo={row.eo_mon}
                                          eed={row.eed_mon}
                                          etd={row.etd_mon}

                                          desc={row.desc_mon}
                                          tsssn={row.tsssn_mon}
                                          tsrd={row.tsrd_mon}
                                          ud={row.ud_mon}
                                          usn={row.usn_mon}
                                          tsd={row.tsd_mon}
                                          ot_time={row.ot_time_mon}
                                          act_cancel={row.act_cancel_mon}
                                          act_del={row.act_del_mon}
                                          rowindex={row.rowindex}
                                          holiday={isholiday_mon}     
                                          SaveTimeSheet={SaveTimeSheet}   
                                          DelTimesheet={DelTimesheet} 
                                          resetvalue={iscntreset_TSCall_DP}        
                                          isSVOT={isSVOT}                      
                                          >
                                          </TimesheetCellDayProject>
                                      </TableCell>
                                      <TableCell className={(isholiday_tue === "y" ? b_holi : b_nholi)} align="center">
                                          <TimesheetCellDayProject tsid={row.tsid_tue} day={"Tue"} 
                                          dt_day={dt_tue}
                                          dt_dayFull={dt_Full_tue} 
                                          wt_time={row.wt_time_tue}
                                          tss={row.tss_tue}
                                          tte={row.tte_tue}
                                          ot={row.ot_tue}
                                          act_edit={row.act_edit_tue}
                                          ActProject={row.actproject_tue}
                                          pro_id={row.pro_id}
                                          project_name={row.project_name}
                                          task_id={row.task_id}
                                          timeoff_id={row.timeoff_id}
                                          act_task_timeoff={row.act_task_timeoff}
                                          onclick_ModalEditTimeSheet={onclick_ModalEditTimeSheet}
                                          customer_name={row.customer_name}
                                          taskname={row.taskname}
                                          tasksubname={row.tasksubname}
                                          timeoff_name={row.timeoff_name}
                                          pos_name={row.pos_name_tue}
                                          ee={row.ee_tue}
                                          et={row.et_tue}
                                          eo={row.eo_tue}
                                          eed={row.eed_tue}
                                          etd={row.etd_tue}


                                          desc={row.desc_tue}
                                          tsssn={row.tsssn_tue}
                                          tsrd={row.tsrd_tue}
                                          ud={row.ud_tue}
                                          usn={row.usn_tue}
                                          tsd={row.tsd_tue}
                                          ot_time={row.ot_time_tue}
                                          act_cancel={row.act_cancel_tue}
                                          act_del={row.act_del_tue}
                                          rowindex={row.rowindex}
                                          holiday={isholiday_tue}     
                                          SaveTimeSheet={SaveTimeSheet}   
                                          DelTimesheet={DelTimesheet}      
                                          resetvalue={iscntreset_TSCall_DP}        
                                          isSVOT={isSVOT}                   
                                          >
                                          </TimesheetCellDayProject>
                                      </TableCell>
                                      <TableCell className={(isholiday_wed === "y" ? b_holi : b_nholi)} align="center">
                                          <TimesheetCellDayProject tsid={row.tsid_wed} day={"Wed"} 
                                          dt_day={dt_wed}
                                          dt_dayFull={dt_Full_wed} 
                                          wt_time={row.wt_time_wed}
                                          tss={row.tss_wed}
                                          tte={row.tte_wed}
                                          ot={row.ot_wed}
                                          act_edit={row.act_edit_wed}
                                          ActProject={row.actproject_wed}
                                          pro_id={row.pro_id}
                                          project_name={row.project_name}
                                          task_id={row.task_id}
                                          timeoff_id={row.timeoff_id}
                                          act_task_timeoff={row.act_task_timeoff}
                                          onclick_ModalEditTimeSheet={onclick_ModalEditTimeSheet}
                                          customer_name={row.customer_name}
                                          taskname={row.taskname}
                                          tasksubname={row.tasksubname}
                                          timeoff_name={row.timeoff_name}
                                          pos_name={row.pos_name_wed}
                                          ee={row.ee_wed}
                                          et={row.et_wed}
                                          eo={row.eo_wed}
                                          eed={row.eed_wed}
                                          etd={row.etd_wed}

                                          desc={row.desc_wed}
                                          tsssn={row.tsssn_wed}
                                          tsrd={row.tsrd_wed}
                                          ud={row.ud_wed}
                                          usn={row.usn_wed}
                                          tsd={row.tsd_wed}
                                          ot_time={row.ot_time_wed}
                                          act_cancel={row.act_cancel_wed}
                                          act_del={row.act_del_wed}
                                          rowindex={row.rowindex}
                                          holiday={isholiday_wed}     
                                          SaveTimeSheet={SaveTimeSheet}   
                                          DelTimesheet={DelTimesheet}   
                                          resetvalue={iscntreset_TSCall_DP}       
                                          isSVOT={isSVOT}                       
                                          >
                                          </TimesheetCellDayProject>
                                      </TableCell>
                                      <TableCell className={(isholiday_thu === "y" ? b_holi : b_nholi)} align="center">
                                          <TimesheetCellDayProject tsid={row.tsid_thu} day={"Thu"} 
                                          dt_day={dt_thu}
                                          dt_dayFull={dt_Full_thu} 
                                          wt_time={row.wt_time_thu}
                                          tss={row.tss_thu}
                                          tte={row.tte_thu}
                                          ot={row.ot_thu}
                                          act_edit={row.act_edit_thu}
                                          ActProject={row.actproject_thu}
                                          pro_id={row.pro_id}
                                          project_name={row.project_name}
                                          task_id={row.task_id}
                                          timeoff_id={row.timeoff_id}
                                          act_task_timeoff={row.act_task_timeoff}
                                          onclick_ModalEditTimeSheet={onclick_ModalEditTimeSheet}
                                          customer_name={row.customer_name}
                                          taskname={row.taskname}
                                          tasksubname={row.tasksubname}
                                          timeoff_name={row.timeoff_name}
                                          pos_name={row.pos_name_thu}
                                          ee={row.ee_thu}
                                          et={row.et_thu}
                                          eo={row.eo_thu}
                                          eed={row.eed_thu}
                                          etd={row.etd_thu}

                                          desc={row.desc_thu}
                                          tsssn={row.tsssn_thu}
                                          tsrd={row.tsrd_thu}
                                          ud={row.ud_thu}
                                          usn={row.usn_thu}
                                          tsd={row.tsd_thu}
                                          ot_time={row.ot_time_thu}
                                          act_cancel={row.act_cancel_thu}
                                          act_del={row.act_del_thu}
                                          rowindex={row.rowindex}
                                          holiday={isholiday_thu}     
                                          SaveTimeSheet={SaveTimeSheet}  
                                          DelTimesheet={DelTimesheet}    
                                          resetvalue={iscntreset_TSCall_DP}        
                                          isSVOT={isSVOT}                      
                                          >
                                          </TimesheetCellDayProject>
                                      </TableCell>
                                      <TableCell className={(isholiday_fri === "y" ? b_holi : b_nholi)} align="center">
                                          <TimesheetCellDayProject tsid={row.tsid_fri} day={"Fri"} 
                                          dt_day={dt_fri}
                                          dt_dayFull={dt_Full_fri} 
                                          wt_time={row.wt_time_fri}
                                          tss={row.tss_fri}
                                          tte={row.tte_fri}
                                          ot={row.ot_fri}
                                          act_edit={row.act_edit_fri}
                                          ActProject={row.actproject_fri}
                                          pro_id={row.pro_id}
                                          project_name={row.project_name}
                                          task_id={row.task_id}
                                          timeoff_id={row.timeoff_id}
                                          act_task_timeoff={row.act_task_timeoff}
                                          onclick_ModalEditTimeSheet={onclick_ModalEditTimeSheet}
                                          customer_name={row.customer_name}
                                          taskname={row.taskname}
                                          tasksubname={row.tasksubname}
                                          timeoff_name={row.timeoff_name}
                                          pos_name={row.pos_name_fri}
                                          ee={row.ee_fri}
                                          et={row.et_fri}
                                          eo={row.eo_fri}
                                          eed={row.eed_fri}
                                          etd={row.etd_fri}

                                          desc={row.desc_fri}
                                          tsssn={row.tsssn_fri}
                                          tsrd={row.tsrd_fri}
                                          ud={row.ud_fri}
                                          usn={row.usn_fri}
                                          tsd={row.tsd_fri}
                                          ot_time={row.ot_time_fri}
                                          act_cancel={row.act_cancel_fri}
                                          act_del={row.act_del_fri}
                                          rowindex={row.rowindex}
                                          holiday={isholiday_fri}     
                                          SaveTimeSheet={SaveTimeSheet}  
                                          DelTimesheet={DelTimesheet}    
                                          resetvalue={iscntreset_TSCall_DP}      
                                          isSVOT={isSVOT}                        
                                          >
                                          </TimesheetCellDayProject>
                                      </TableCell>
                                      <TableCell className={(isholiday_sat === "y" ? b_holi : b_nholi)} align="center">
                                          <TimesheetCellDayProject tsid={row.tsid_sat} day={"Sat"} 
                                          dt_day={dt_sat}
                                          dt_dayFull={dt_Full_sat} 
                                          wt_time={row.wt_time_sat}
                                          tss={row.tss_sat}
                                          tte={row.tte_sat}
                                          ot={row.ot_sat}
                                          act_edit={row.act_edit_sat}
                                          ActProject={row.actproject_sat}
                                          pro_id={row.pro_id}
                                          project_name={row.project_name}
                                          task_id={row.task_id}
                                          timeoff_id={row.timeoff_id}
                                          act_task_timeoff={row.act_task_timeoff}
                                          onclick_ModalEditTimeSheet={onclick_ModalEditTimeSheet}
                                          customer_name={row.customer_name}
                                          taskname={row.taskname}
                                          tasksubname={row.tasksubname}
                                          timeoff_name={row.timeoff_name}
                                          pos_name={row.pos_name_sat}
                                          ee={row.ee_sat}
                                          et={row.et_sat}
                                          eo={row.eo_sat}
                                          eed={row.eed_sat}
                                          etd={row.etd_sat}

                                          desc={row.desc_sat}
                                          tsssn={row.tsssn_sat}
                                          tsrd={row.tsrd_sat}
                                          ud={row.ud_sat}
                                          usn={row.usn_sat}
                                          tsd={row.tsd_sat}
                                          ot_time={row.ot_time_sat}
                                          act_cancel={row.act_cancel_sat}
                                          act_del={row.act_del_sat}
                                          rowindex={row.rowindex}
                                          holiday={isholiday_sat}     
                                          SaveTimeSheet={SaveTimeSheet}   
                                          DelTimesheet={DelTimesheet}    
                                          resetvalue={iscntreset_TSCall_DP}       
                                          isSVOT={isSVOT}                      
                                          >
                                          </TimesheetCellDayProject>
                                      </TableCell>
                                      <TableCell align="center">
                                        <div className="text-bold text-muted">
                                          {(row.totalweek_wtot_time_hr === "00" || row.totalweek_wtot_time_hr === "0") ? "" :
                                            <>
                                              {row.totalweek_wtot_time_hr}
                                              <span className="text-normal">h</span> 
                                            </>
                                          }
                                           
                                          {row.totalweek_wtot_time_mm !== "00" && row.totalweek_wtot_time_mm !== "0" && isSVOT === true  &&
                                            <>
                                            {" "}
                                              {row.totalweek_wtot_time_mm}
                                               <span className="text-normal">m</span> 
                                            </>
                                          }
                                        </div>
                                      </TableCell>
                                    </TableRow>
                              ))}
                            </TableBody>

                            <TableFooter >
                              <TableRow className="card-footer">
                                <TableCell style={{ width: "375px" }} colSpan={3} className="text-sm">
                                  <div className="text-right text-muted pr-1">
                                    <div>
                                      <i
                                        className="far fa-clock text-muted"
                                        title="OT"
                                      />{" "}
                                      Work time & Time Off
                                    </div>
                                    {(isSVOT === true &&
                                      <>
                                        <div>
                                          {" "}
                                          <i
                                            className="far fa-lightbulb text-muted "
                                            title="OT"
                                          />{" "}
                                          Over time
                                        </div>
                                      </>
                                    )}
                                  </div>
                                </TableCell>
                                <TableCell style={{ width: "140px" }} align="center" className="text-sm">
                                  <TimesheetCellDayTotalTime
                                    total_wt={summary_wtot.total_wt_sun}
                                    total_ot={summary_wtot.total_ot_sun}
                                    total_wt_time_hr={summary_wtot.total_wt_time_hr_sun}
                                    total_wt_time_mm={summary_wtot.total_wt_time_mm_sun}
                                    total_ot_time_hr={summary_wtot.total_ot_time_hr_sun}
                                    total_ot_time_mm={summary_wtot.total_ot_time_mm_sun}
                                    isSVOT={isSVOT}
                                  >
                                  </TimesheetCellDayTotalTime>
                                </TableCell>
                                <TableCell style={{ width: "140px" }} align="center" className="text-sm">
                                  <TimesheetCellDayTotalTime
                                    total_wt={summary_wtot.total_wt_mon}
                                    total_ot={summary_wtot.total_ot_mon}
                                    total_wt_time_hr={summary_wtot.total_wt_time_hr_mon}
                                    total_wt_time_mm={summary_wtot.total_wt_time_mm_mon}
                                    total_ot_time_hr={summary_wtot.total_ot_time_hr_mon}
                                    total_ot_time_mm={summary_wtot.total_ot_time_mm_mon}
                                    isSVOT={isSVOT}
                                  >
                                  </TimesheetCellDayTotalTime>
                                </TableCell>
                                <TableCell style={{ width: "140px" }} align="center" className="text-sm">
                                  <TimesheetCellDayTotalTime
                                    total_wt={summary_wtot.total_wt_tue}
                                    total_ot={summary_wtot.total_ot_tue}
                                    total_wt_time_hr={summary_wtot.total_wt_time_hr_tue}
                                    total_wt_time_mm={summary_wtot.total_wt_time_mm_tue}
                                    total_ot_time_hr={summary_wtot.total_ot_time_hr_tue}
                                    total_ot_time_mm={summary_wtot.total_ot_time_mm_tue}
                                    isSVOT={isSVOT}
                                    >
                                  </TimesheetCellDayTotalTime>
                                </TableCell>
                                <TableCell style={{ width: "140px" }} align="center" className="text-sm">
                                  <TimesheetCellDayTotalTime
                                    total_wt={summary_wtot.total_wt_wed}
                                    total_ot={summary_wtot.total_ot_wed}
                                    total_wt_time_hr={summary_wtot.total_wt_time_hr_wed}
                                    total_wt_time_mm={summary_wtot.total_wt_time_mm_wed}
                                    total_ot_time_hr={summary_wtot.total_ot_time_hr_wed}
                                    total_ot_time_mm={summary_wtot.total_ot_time_mm_wed}
                                    isSVOT={isSVOT}
                                    >
                                  </TimesheetCellDayTotalTime>
                                </TableCell>
                                <TableCell style={{ width: "140px" }} align="center" className="text-sm">
                                  <TimesheetCellDayTotalTime
                                    total_wt={summary_wtot.total_wt_thu}
                                    total_ot={summary_wtot.total_ot_thu}
                                    total_wt_time_hr={summary_wtot.total_wt_time_hr_thu}
                                    total_wt_time_mm={summary_wtot.total_wt_time_mm_thu}
                                    total_ot_time_hr={summary_wtot.total_ot_time_hr_thu}
                                    total_ot_time_mm={summary_wtot.total_ot_time_mm_thu}
                                    isSVOT={isSVOT}
                                  >
                                  </TimesheetCellDayTotalTime>
                                </TableCell>
                                <TableCell style={{ width: "140px" }} align="center" className="text-sm">
                                  <TimesheetCellDayTotalTime
                                    total_wt={summary_wtot.total_wt_fri}
                                    total_ot={summary_wtot.total_ot_fri}
                                    total_wt_time_hr={summary_wtot.total_wt_time_hr_fri}
                                    total_wt_time_mm={summary_wtot.total_wt_time_mm_fri}
                                    total_ot_time_hr={summary_wtot.total_ot_time_hr_fri}
                                    total_ot_time_mm={summary_wtot.total_ot_time_mm_fri}
                                    isSVOT={isSVOT}
                                  >
                                  </TimesheetCellDayTotalTime>
                                </TableCell>
                                <TableCell style={{ width: "140px" }} className="bg-light text-sm" align="center">
                                  <TimesheetCellDayTotalTime
                                    total_wt={summary_wtot.total_wt_sat}
                                    total_ot={summary_wtot.total_ot_sat}
                                    total_wt_time_hr={summary_wtot.total_wt_time_hr_sat}
                                    total_wt_time_mm={summary_wtot.total_wt_time_mm_sat}
                                    total_ot_time_hr={summary_wtot.total_ot_time_hr_sat}
                                    total_ot_time_mm={summary_wtot.total_ot_time_mm_sat}
                                    isSVOT={isSVOT}
                                  >
                                  </TimesheetCellDayTotalTime>
                                </TableCell>
                                <TableCell style={{ width: "140px" }} align="center" className="text-sm">
                                  <TimesheetCellDayTotalTime
                                    total_wt={summary_wtot.totalall_wt}
                                    total_ot={summary_wtot.totalall_ot}
                                    total_wt_time_hr={summary_wtot.totalall_wt_time_hr}
                                    total_wt_time_mm={summary_wtot.totalall_wt_time_mm}
                                    total_ot_time_hr={summary_wtot.totalall_ot_time_hr}
                                    total_ot_time_mm={summary_wtot.totalall_ot_time_mm}
                                    isSVOT={isSVOT}
                                  >
                                  </TimesheetCellDayTotalTime>
                                </TableCell>
                              </TableRow>

                              

                          </TableFooter>


                            </Table>
                        </TableContainer>

                      </div>

                        {/* ####### ############### Calendar By Project By Day Total ###################### */}
                     


                      <div className="card-body table-responsive p-0">
                        <table className="table table-head-fixed text-sm  table-fit" 
                        style={{margin: 0}} border={0}
                        >
                          <tfoot >
                              <tr className="card-footer d-none">
                                <td style={{ width: "5px" }}>
                                  {" "}
                                  <div> &nbsp;&nbsp;&nbsp;</div>
                                </td>
                                <td style={{ width: "160px" }}>
                                  <div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</div>
                                </td>
                                <td style={{ width: "210px" }} >
                                  <div className="text-right text-muted pr-1">
                                    <div>
                                    <i
                                        className="far fa-clock text-muted text-sm"
                                        title="OT"
                                      />{" "}
                                      Work time & Time Off
                                      </div>
                                    <div>
                                      {" "}
                                      <i
                                        className="far fa-lightbulb text-muted text-sm"
                                        title="OT"
                                      />{" "}
                                      Over time
                                    </div>
                                  </div>
                                </td>
                                <td style={{ width: "140px" }} align="center">
                                  <TimesheetCellDayTotalTime
                                    total_wt={summary_wtot.total_wt_sun}
                                    total_ot={summary_wtot.total_ot_sun}
                                    total_wt_time_hr={summary_wtot.total_wt_time_hr_sun}
                                    total_wt_time_mm={summary_wtot.total_wt_time_mm_sun}
                                    total_ot_time_hr={summary_wtot.total_ot_time_hr_sun}
                                    total_ot_time_mm={summary_wtot.total_ot_time_mm_sun}
                                  >
                                  </TimesheetCellDayTotalTime>
                                </td>
                                <td style={{ width: "140px" }} align="center">
                                  <TimesheetCellDayTotalTime
                                    total_wt={summary_wtot.total_wt_mon}
                                    total_ot={summary_wtot.total_ot_mon}
                                    total_wt_time_hr={summary_wtot.total_wt_time_hr_mon}
                                    total_wt_time_mm={summary_wtot.total_wt_time_mm_mon}
                                    total_ot_time_hr={summary_wtot.total_ot_time_hr_mon}
                                    total_ot_time_mm={summary_wtot.total_ot_time_mm_mon}
                                  >
                                  </TimesheetCellDayTotalTime>
                                </td>
                                <td style={{ width: "140px" }} align="center">
                                  <TimesheetCellDayTotalTime
                                      total_wt={summary_wtot.total_wt_tue}
                                      total_ot={summary_wtot.total_ot_tue}
                                      total_wt_time_hr={summary_wtot.total_wt_time_hr_tue}
                                      total_wt_time_mm={summary_wtot.total_wt_time_mm_tue}
                                      total_ot_time_hr={summary_wtot.total_ot_time_hr_tue}
                                      total_ot_time_mm={summary_wtot.total_ot_time_mm_tue}
                                    >
                                  </TimesheetCellDayTotalTime>
                                </td>
                                <td style={{ width: "140px" }} align="center">
                                  <TimesheetCellDayTotalTime
                                      total_wt={summary_wtot.total_wt_wed}
                                      total_ot={summary_wtot.total_ot_wed}
                                      total_wt_time_hr={summary_wtot.total_wt_time_hr_wed}
                                      total_wt_time_mm={summary_wtot.total_wt_time_mm_wed}
                                      total_ot_time_hr={summary_wtot.total_ot_time_hr_wed}
                                      total_ot_time_mm={summary_wtot.total_ot_time_mm_wed}
                                    >
                                  </TimesheetCellDayTotalTime>
                                </td>
                                <td style={{ width: "140px" }} align="center">
                                  <TimesheetCellDayTotalTime
                                    total_wt={summary_wtot.total_wt_thu}
                                    total_ot={summary_wtot.total_ot_thu}
                                    total_wt_time_hr={summary_wtot.total_wt_time_hr_thu}
                                    total_wt_time_mm={summary_wtot.total_wt_time_mm_thu}
                                    total_ot_time_hr={summary_wtot.total_ot_time_hr_thu}
                                    total_ot_time_mm={summary_wtot.total_ot_time_mm_thu}
                                  >
                                  </TimesheetCellDayTotalTime>
                                </td>
                                <td style={{ width: "140px" }} align="center">
                                  <TimesheetCellDayTotalTime
                                    total_wt={summary_wtot.total_wt_fri}
                                    total_ot={summary_wtot.total_ot_fri}
                                    total_wt_time_hr={summary_wtot.total_wt_time_hr_fri}
                                    total_wt_time_mm={summary_wtot.total_wt_time_mm_fri}
                                    total_ot_time_hr={summary_wtot.total_ot_time_hr_fri}
                                    total_ot_time_mm={summary_wtot.total_ot_time_mm_fri}
                                  >
                                  </TimesheetCellDayTotalTime>
                                </td>
                                <td style={{ width: "140px" }} className="bg-light" align="center">
                                  <TimesheetCellDayTotalTime
                                    total_wt={summary_wtot.total_wt_sat}
                                    total_ot={summary_wtot.total_ot_sat}
                                    total_wt_time_hr={summary_wtot.total_wt_time_hr_sat}
                                    total_wt_time_mm={summary_wtot.total_wt_time_mm_sat}
                                    total_ot_time_hr={summary_wtot.total_ot_time_hr_sat}
                                    total_ot_time_mm={summary_wtot.total_ot_time_mm_sat}
                                  >
                                  </TimesheetCellDayTotalTime>
                                </td>
                                <td style={{ width: "140px" }} align="center">
                                  <TimesheetCellDayTotalTime
                                    total_wt={summary_wtot.totalall_wt}
                                    total_ot={summary_wtot.totalall_ot}
                                    total_wt_time_hr={summary_wtot.totalall_wt_time_hr}
                                    total_wt_time_mm={summary_wtot.totalall_wt_time_mm}
                                    total_ot_time_hr={summary_wtot.totalall_ot_time_hr}
                                    total_ot_time_mm={summary_wtot.totalall_ot_time_mm}
                                  >
                                  </TimesheetCellDayTotalTime>
                                </td>
                              </tr>

                              <tr className="">
                                <td className="text-left" style={{ width: "375px" }} colSpan={3}>
                                  {(issearch === 0 && 
                                    <>
                                    <span className="btn-group btn-group-sm">
                                        <a
                                          href="#!"
                                          onClick={onclick_AddProjectTask}
                                          title="Add New Transaction"
                                          data-target="#modal-AddProject"
                                          data-toggle="modal"
                                          className="btn btn-outline-secondary"
                                        >
                                          <i className="fas fa-plus" /> New Transaction
                                        </a>
                                        {/*{" "}*/}
                                        <a
                                          href="#!"
                                          onClick={onclick_LoadlastestWeek}
                                          title="load latest week"
                                          className="btn btn-outline-secondary"
                                        >
                                          <i className="fas fa-download"/> Load latest week
                                        </a>
                                    </span>
                                    </>
                                  )}
                                </td>
                                
                                <td
                                  className="text-center"
                                  colSpan={7}
                                  style={{ width: "980px" }}
                                >
                                  {((issearch === 1 && (searchValuestatus === "0" || searchValuestatus === "-1")) || (issearch === 0)) &&
                                    <a
                                      href="#!"
                                      className="btn btn-primary "
                                      onClick={BindGetSubmit}
                                      data-target="#modal-submit"
                                      data-toggle="modal"
                                    >
                                      <i className="far fa-paper-plane" /> Save and
                                      Submit
                                    </a>
                                  }
                                </td>
                                <td  style={{ width: "140px" }}
                                >
                                  <span>&nbsp;</span>
                                </td>
                              </tr>

                          </tfoot>
                            
                        </table>
                      </div>



                        {/* ###################### Calendar By Project By Day Total ###################### */}


                      {/* ###################### Calendar By Project By Day ###################### */}

                      

                    </div>
                  </div>
                </div>
              </div>
            </section>

          </>
          }


          {/* /.row (main row) */}
          {/* /.content-wrapper */}
        </div>
      </div>



      {/* ###################### Modal Add Project ###################### */}
      
      <div className="modal fade" id="modal-AddProject">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">
                <i className="fas fa-plus" /> New Transaction{" "}
                <span className="text-sm text-muted">(add)</span>
              </h4>
              <button
                id="modalAddProject_Close"
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="form-horizontal">
                <div className="form-group row m-1">
                  <label className="text-sm col-sm-2 col-form-label text-right">
                    Project <span className="text-danger">*</span>
                  </label>
                  <div className="col-sm-10">
                    {isLoadedConfigData && 
                      <SelectProjectByTimeSheetByAdd
                        refid={selectRef_Project}
                        API_URL={configData.API_URL}
                        pro_status={"1"}
                        staff_status={"1"}
                        selectismulti={false} 
                        SelectTextDefault={ConfigETC.ddl_pleaseselect}
                        resetSelect={iscntreset_ProjectAdd}
                        onChangevalue={onChageSelectProject}
                        iscloseMenuOnSelect={true}
                      ></SelectProjectByTimeSheetByAdd>
                    }
                    <input type="hidden" id="hd_PU_AddPT_Selectproject" ></input>
                  </div>
                </div>
                <div className="form-group row m-1">
                  <label className="text-sm col-lg-2 col-sm-2 col-2 col-form-label text-right">
                    <span className="icheck-primary d-inline ">
                      
                      <label htmlFor="rdo_task">
                        Task <span className="text-danger">*</span>
                      </label>
                     
                    </span>
                  </label>
                  <div className="col-lg-1 col-sm-1 col-1 text-right">
                  <input type="radio" id="rdo_task" name="work_type" value="1"
                      checked={ischecked_timeofftask === "1"}
                      onChange={(e)=>onChange_Rdo_worktype(e , "task")} />
                  </div>
                  <div className="col-lg-9 col-sm-9 col-9">
                    <Select
                      ref={selectRef_Task}
                      options={listddlTask}
                      isDisabled={isDisabledTask}
                      placeholder={ConfigETC.ddl_pleaseselect}
                      isClearable={true}
                      menuPortalTarget={document.body}
                      formatGroupLabel={RSelect_Group}
                      value={selectedtask}
                      onChange={(e) => onChageSelectTask(e)}
                       //styles={{
                          //  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        //}}
                      styles={customStylesSelect}
                    />
                    <input type="hidden" id="hd_PU_AddPT_Selecttask" ></input>
                  </div>
                </div>
                <div className="form-group row m-1">
                  <label className="text-sm col-lg-2 col-sm-2 col-2 col-form-label text-right">
                    <span className="icheck-primary d-inline">
                     
                      <label htmlFor="rdo_timeoff">
                        Time Off <span className="text-danger">*</span>
                      </label>
                      
                    </span>
                  </label>
                  <div className="col-lg-1 col-sm-1 col-1 text-right">
                  <input type="radio" id="rdo_timeoff" name="work_type" value="2"
                      checked={ischecked_timeofftask === "2"}
                      onChange={(e)=>onChange_Rdo_worktype(e , "timeoff")} />
                  </div>
                  <div className="col-lg-9 col-sm-9 col-9">
                  
                    <Select
                      ref={selectRef_Timeoff}
                      options={listddltimeoff}
                      isDisabled={isDisabledTimeoff}
                      placeholder={ConfigETC.ddl_pleaseselect}
                      isClearable={true}
                      menuPortalTarget={document.body}
                      value={selectedtimeoff}
                      onChange={(e) => onChageSelectTimeoff(e)}
                       //styles={{
                              //  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                            //}}
                      styles={customStylesSelect}
                    />
                    <div style={{cursor: 'pointer', color: '#21529'}} />

                    <input type="hidden" id="hd_PU_AddPT_Selecttimeoff" ></input>

                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer float-right">
              <button
                type="button"
                className="btn btn-primary btn-sm"
                onClick={onclick_AddProject}
              >
                <i className="fas fa-plus" /> Add New
              </button>
              <input type="hidden" id="hd_moal_idfocus" ></input>
              
            </div>
          </div>
        </div>
      </div>
      
      {/* ###################### Modal Add Project ###################### */}

      
      {/* ###################### Modal Edit TimeSheet  ###################### */}
        
      <div className="modal fade" id="modal-TimeSheet" >
        <div className="modal-dialog modal-lg ">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">
                <i className="fa fa-table" /> Time sheet - Transaction{" "}
                <span className="text-sm text-muted">({data_modalTS_ActProject})</span>
              </h4>
              <button
                id="modalTS_Close"
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body pt-1">
              <div className="form-horizontal ">
              <div className="form-group row m-0">
                  <span className="text-sm col-sm-2 col-form-label text-bold">
                    Customer
                  </span>
                  <span className="text-sm col-sm-10 col-form-label ">
                    <span id="lbl_modalTS_CusName" className="text-normal"></span>
                  </span>
                </div>

                <div className="form-group row m-0">
                  <span className="text-sm col-sm-2 col-form-label text-bold">
                    Project
                  </span>
                  <span className="text-sm col-sm-10 col-form-label ">
                    <span id="lbl_modalTS_ProjectName" className="text-normal"></span>{" "}
                  
                  </span>
                </div>

                {(data_modalTS_act_task_timeoff === "T" && 
                  <>
                    <div className="form-group row m-0">
                      <span className="text-sm col-sm-2 col-form-label text-bold">Task</span>
                      <span className="text-sm col-sm-10 col-form-label ">
                        <span className="text-normal">{data_modalTS_Task}</span>
                      </span>
                    </div>
                    <div className="form-group row m-0">
                      <span className="text-sm col-sm-2 col-form-label text-bold">Sub Task</span>
                      <span className="text-sm col-sm-10 col-form-label ">
                        <span className="text-normal">{data_modalTS_SubTask}</span>
                      </span>
                    </div>
                  </>
                ) ||
                (
                  <>
                    <div className="form-group row m-0">
                        <span className="text-sm col-sm-2 col-form-label text-bold">Time off</span>
                        <span className="text-sm col-sm-10 col-form-label ">
                            <span className="text-normal">{data_modalTS_Timeoff}</span>
                        </span>
                    </div>
                  </>
                )}

                
                <div className="form-group row m-0">
                  <span className="text-sm col-sm-2 col-form-label text-bold">Position</span>
                  <span className="text-sm col-sm-10 col-form-label">
                    <span id="lbl_modalTS_PositionName" className="text-normal"></span>
                  </span>
                </div>
                <div className="form-group row m-0">
                  <span className="text-sm col-sm-2 col-form-label text-bold">Date</span>
                  <span className="text-sm col-sm-10 col-form-label ">
                    <span className="text-normal" id="lbl_modalTS_Day" ></span>{" "}
                    <span className="text-normal">
                      <span id="lbl_modalTS_Date"></span>{" "}<i id="i_model_Today" className="far fa-star text-warning" title="Today" />
                    </span>
                  </span>
                </div>
                
              </div>
              
              <div className="form-horizontal">
                <div className="form-group row m-0 mt-2">
                  <span className="text-sm col-lg-2 col-sm-2 col-12 col-form-label text-bold">
                    {(data_modalTS_act_task_timeoff === "T" && 
                    <>
                      <span id="span_modalTS_WorkTime" >
                      Work Time{" "}<i className="far fa-clock" />
                      </span>
                    </>) ||
                    <>
                      <span id="span_modalTS_Timeoff" >
                       Timeoff{" "}<i className="far fa-pause-circle" />
                      </span>
                    </>
                    }
                    <span className="text-danger">*</span>{" "}
                  </span>
                  <div className="col-lg-10 col-sm-10 col-12">
                    <div className="row">
                      <div className="col-lg-5 col-sm-12 col-12">
                        
                          {((data_modalTS_tss === ConfigETC.TS_InProgress_Value || data_modalTS_tss === ConfigETC.TS_Reject_Value) &&
                            
                            <>
                            <div className="input-group">
                              <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <TimeField ampm={false}  
                                   size="small"
                                    error={false}
                                    value={(data_modalTS_wt_time === "" ? null :  dayjs("2022-04-17T" + data_modalTS_wt_time))}
                                    onBlur={(e) => handleBlur_modalTS_time(e , "wt")}
                                    onChange={()=>undefined}
                                    className="form-control form-control-sm"
                                    inputProps={{min: 0, style: { textAlign: 'left' }}} // the change is here
                                    sx={{
                                      "& .MuiOutlinedInput-notchedOutline": {
                                        borderColor: "#d9dfe5",
                                        borderStyle:"solid",
                                        borderWidth:"1px"
                                      },
                                      
                                    "& .MuiOutlinedInput-root": {
                                      "&:hover:not(.Mui-focused)": {
                                        "& .MuiOutlinedInput-notchedOutline": {
                                          borderColor: "#d9dfe5",
                                          borderStyle:"solid",
                                          borderWidth:"1px"
                                        },
                                      },
                                    }
                                  }}

                                />
                              </LocalizationProvider>
                              </div>
                            </>

                          ) ||
                          (
                          <>
                            {data_modalTS_wt_time === "" || data_modalTS_wt_time === "00:00" ? 
                              <>
                                <div className="span-lable text-bold mt-0 border p-1 bg-light">
                                  -
                                </div>
                              </>
                               :  
                              <>
                                <div className="form-control form-control-sm pl-2  span-lable mt-0 border p-1 bg-light">
                                  {data_modalTS_wt_time.substring(0, 2) === "00" ? "" : 
                                  <>
                                    {data_modalTS_wt_time.substring(0, 1) === "0" ? 
                                        <>
                                            {data_modalTS_wt_time.substring(1,2)}
                                           <span >h</span> 
                                        </> 
                                        : 
                                        <>
                                            {data_modalTS_wt_time.substring(0, 2)}
                                            <span >h</span>
                                        </>
                                    }
                                  </>
                                  }
                                  
                                  {data_modalTS_wt_time.substring(3) === "00" ? "" : 
                                  <>
                                    {" "}
                                  {/* {data_modalTS_wt_time.substring(3)} */}
                                  {parseInt(data_modalTS_wt_time.substring(3))} 
                                    <span >m</span>  
                                  </>
                                  }
                                </div>
                              </>
                            }
                          </>
                          )}
                        
                      </div>
                      
                      {(data_modalTS_act_task_timeoff === "T" && isSVOT === true && 
                      <>
                        <span id="span_modalTS_OverTime" className="col-lg-2 col-sm-12 col-12 text-sm col-form-label text-right text-bold">
                          {" "}
                           Over Time{" "}<i className="far fa-lightbulb" />
                        </span>
                        <div id="div_modalTS_OverTime" className="col-lg-5 col-sm-12 col-12">
                         

                            {((data_modalTS_tss === ConfigETC.TS_InProgress_Value || data_modalTS_tss === ConfigETC.TS_Reject_Value) &&
                              <>
                               <div className="input-group">
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                  <TimeField ampm={false}  
                                     size="small"
                                      error={false}
                                      value={(data_modalTS_ot_time === "" ? null :  dayjs("2022-04-17T" + data_modalTS_ot_time))}
                                      onBlur={(e) => handleBlur_modalTS_time(e , "ot")}
                                      onChange={()=>undefined}
                                      className="form-control form-control-sm"
                                      inputProps={{min: 0, style: { textAlign: 'left' }}} // the change is here
                                      sx={{
                                      "& .MuiOutlinedInput-notchedOutline": {
                                        borderColor: "#d9dfe5",
                                        borderStyle:"solid",
                                        borderWidth:"1px"
                                      },
                                      
                                    "& .MuiOutlinedInput-root": {
                                      "&:hover:not(.Mui-focused)": {
                                        "& .MuiOutlinedInput-notchedOutline": {
                                          borderColor: "#d9dfe5",
                                          borderStyle:"solid",
                                          borderWidth:"1px"
                                        },
                                      },
                                    }
                                  }}

                                  />
                                </LocalizationProvider>
                                </div>
                              </>
                            ) ||
                            (
                            <>
                              {data_modalTS_ot_time === "" || data_modalTS_ot_time === "00:00" ? 
                                <>
                                  <div className="span-lable text-bold mt-0 border p-1 bg-light">
                                   &nbsp;
                                  </div>
                                </>
                                :  
                                <>
                                  <div className="form-control form-control-sm pl-2  span-lable mt-0 border p-1 bg-light">
                                    {data_modalTS_ot_time.substring(0, 2) === "00" ? "" : 
                                    <>
                                      {data_modalTS_ot_time.substring(0, 1) === "0" ? 
                                          <>
                                              {data_modalTS_ot_time.substring(1,2)}
                                              <span >h</span>
                                          </> 
                                          : 
                                          <>
                                              {data_modalTS_ot_time.substring(0, 2)}
                                               <span >h</span> 
                                          </>
                                      }
                                    </>
                                    }
                                     
                                    {data_modalTS_ot_time.substring(3) === "00" ? "" : 
                                    <>
                                     {" "}
                                      {/* {data_modalTS_ot_time.substring(3)} */}
                                      {parseInt(data_modalTS_ot_time.substring(3))} 
                                      <span >m</span> 
                                    </>
                                    }
                                  </div>
                                </>
                              }
                            </>
                            )}
                         
                        </div>
                      </>)}

                    </div>
                  </div>
                </div>

                


                <div className="row m-0 mt-2" id="div_modalTS_Expenses1" >
                  <span
                    className="text-sm col-lg-2 col-sm-2 col-12 col-form-label text-bold"
                  >
                    Expenses{" "}<i className="far fa-money-bill-alt" />
                  </span>
                  <div className="col-sm-10 m-0">
                    <div className="row">
                      <div className="col-sm-5 ">
                        <span className="text-sm"> Per diem allowance </span>
                        {((data_modalTS_tss === ConfigETC.TS_InProgress_Value || data_modalTS_tss === ConfigETC.TS_Reject_Value) &&
                          <>
                            <div className="input-group">
                            <CurrencyInput
                             
                              id="txt_modelTS_Extra"
                              name="input-name"
                              className="form-control form-control-sm  pl-1"
                              decimalsLimit={2}
                              decimalScale={2}
                              value={(data_modalTS_Extra > 0  ? (data_modalTS_Extra) : "")}
                              onValueChange={(value) => onValueChange_modelTS_Expenses(value , "Extra")}
                            />
                              <div className="input-group-append">
                                <span className="input-group-text text-sm"><i className="fab fa-btc" title="baht"></i> </span>
                              </div>
                            </div>
                          </>
                        ) ||
                        (
                        <>
                        <div className="input-group">
                          <div className="form-control form-control-sm pl-2  span-lable mt-0 border p-1 bg-light">
                            {(data_modalTS_Extra > 0 ? Returncomma(data_modalTS_Extra) : " ")}
                          </div>
                          <div className="input-group-append">
                            <span className="input-group-text text-sm"><i className="fab fa-btc" title="baht"></i>&nbsp; </span>
                          </div>
                        </div>
                        </>
                        )}
                      </div>
                      <div className="col-sm-2">
                        &nbsp;
                      </div>
                      <div className="col-sm-5">
                        <span className="text-sm"> Per diem allowance </span>
                        {((data_modalTS_tss === ConfigETC.TS_InProgress_Value || data_modalTS_tss === ConfigETC.TS_Reject_Value) &&
                          <>
                           <div className="input-group">
                           <CurrencyInput
                              
                              id="txt_modelTS_Extra_day"
                              name="input-name"
                              className="form-control form-control-sm pl-1"
                              decimalsLimit={0}
                              decimalScale={0}
                              value={(data_modalTS_Extra_day > 0 ? data_modalTS_Extra_day : "")}
                              onValueChange={(value) => onValueChange_modelTS_Expenses(value , "Extra_day")}
                            />
                              <div className="input-group-append">
                                <span className="input-group-text text-sm">day </span>
                              </div>
                            </div>
                           
                          </>
                        ) ||
                        (
                        <>
                        <div className="input-group">
                          <div className="form-control form-control-sm pl-2 span-lable mt-0 border p-1 bg-light">
                            {(data_modalTS_Extra_day > 0 ? ReturncommaCustom(data_modalTS_Extra_day, 0 , 0): " ")}
                          </div>
                          <div className="input-group-append">
                                <span className="input-group-text text-sm">day </span>
                              </div>
                          </div>
                        </>
                        )}
                      </div>


                    </div>
                    
                    <div className="row mt-1">
                      <div className="col-sm-5">
                        <span className="text-sm"> Travel  </span>
                        {((data_modalTS_tss === ConfigETC.TS_InProgress_Value || data_modalTS_tss === ConfigETC.TS_Reject_Value) &&
                          <>
                          <div className="input-group">
                            <CurrencyInput
                              id="txt_modelTS_Travel"
                              name="input-name"
                              className="form-control form-control-sm pl-1"
                              decimalsLimit={2}
                              decimalScale={2}
                              value={(data_modalTS_Travel > 0 ? data_modalTS_Travel : "")}
                              onValueChange={(value) => onValueChange_modelTS_Expenses(value , "Travel")}
                            />
                            <div className="input-group-append">
                                <span className="input-group-text text-sm"><i className="fab fa-btc" title="baht"></i> </span>
                            </div>
                          </div>
                          </>
                        ) ||
                        (
                        <>
                        <div className="input-group">
                          <div className="form-control form-control-sm pl-2 span-lable  mt-0 border p-1 bg-light">
                            {(data_modalTS_Travel > 0 ? Returncomma(data_modalTS_Travel) : " ")}
                          </div>
                          <div className="input-group-append">
                                <span className="input-group-text text-sm"><i className="fab fa-btc" title="baht"></i> &nbsp;</span>
                          </div>
                        </div>
                        </>
                        )}
                      </div>
                      <div className="col-sm-2">
                        &nbsp;
                      </div>
                      <div className="col-sm-5">
                        <span className="text-sm"> Travel Distance  </span>
                        {((data_modalTS_tss === ConfigETC.TS_InProgress_Value || data_modalTS_tss === ConfigETC.TS_Reject_Value) &&
                          <>
                          <div className="input-group">
                            <CurrencyInput
                              id="txt_modelTS_Travel_distance"
                              name="input-name"
                              className="form-control form-control-sm pl-1"
                              decimalsLimit={2}
                              decimalScale={2}
                              value={(data_modalTS_Travel_distance > 0 ? data_modalTS_Travel_distance:"")}
                              onValueChange={(value) => onValueChange_modelTS_Expenses(value , "Travel_distance")}
                            />
                            <div className="input-group-append">
                                <span className="input-group-text text-sm">km </span>
                            </div>
                          </div>
                          </>
                        ) ||
                        (
                        <>
                          <div className="input-group">
                            <div className="form-control form-control-sm pl-2 span-lable  mt-0 border p-1 bg-light">
                              {(data_modalTS_Travel_distance > 0 ? Returncomma(data_modalTS_Travel_distance) : " ")}
                            </div>
                            <div className="input-group-append">
                                <span className="input-group-text text-sm">km</span>
                            </div>
                          </div>
                        </>
                        )}
                      </div>

                    </div>

                    <div className="row mt-1">
                      <div className="col-sm-5">
                        <span className="text-sm"> Other  </span>
                        {((data_modalTS_tss === ConfigETC.TS_InProgress_Value || data_modalTS_tss === ConfigETC.TS_Reject_Value) &&
                          <>
                          <div className="input-group">
                            <CurrencyInput
                              id="txt_modelTS_Other"
                              name="input-name"
                              className="form-control form-control-sm pl-1"
                              decimalsLimit={2}
                              decimalScale={2}
                              value={(data_modalTS_Other > 0 ? data_modalTS_Other :"")}
                              onValueChange={(value) => onValueChange_modelTS_Expenses(value , "Other")}
                            />
                            <div className="input-group-append">
                                <span className="input-group-text text-sm"><i className="fab fa-btc" title="baht"></i> </span>
                              </div>
                          </div>
                          </>
                        ) ||
                        (
                        <>
                          <div className="input-group">
                            <div className="form-control form-control-sm pl-2 span-lable  mt-0 border p-1 bg-light">
                              {(data_modalTS_Other > 0 ? Returncomma(data_modalTS_Other) : " ")}
                            </div>
                              <div className="input-group-append">
                                <span className="input-group-text text-sm"><i className="fab fa-btc" title="baht"></i> &nbsp;</span>
                              </div>
                          </div>
                        </>
                        )}
                      </div>
                    </div>

                  </div>
                </div>
                



                <div className="form-group row m-0 mt-2">
                  <span className="text-sm col-sm-2 col-form-label text-bold">
                    Note
                  </span>
                  <div className="col-sm-10">
                    <textarea
                      id="txt_modalTS_Note"
                      className="form-control text-sm"
                      rows={3}
                      placeholder="please explain details ..."
                      defaultValue={""}
                    />
                    <span id="lbl_modalTS_Note" className="span-lable">
                    </span>
                  </div>
                </div>


                <div className="form-group row m-0">
                  <span className="text-sm col-sm-2 col-form-label text-bold">
                    Status
                  </span>
                  <div className="col-sm-10 mt-1">

                    {
                    (data_modalTS_tss === ConfigETC.TS_ToReview_Value && 
                      <span className={ConfigETC.TS_ToReview_Class}>{ConfigETC.TS_ToReview_Text}</span>
                    ) ||
                    (data_modalTS_tss === ConfigETC.TS_ToApprove_Value && 
                      <span className={ConfigETC.TS_ToApprove_Class}>{ConfigETC.TS_ToApprove_Text}</span>
                    ) ||
                    (data_modalTS_tss === ConfigETC.TS_Approved_Value && 
                      <span className={ConfigETC.TS_Approved_Class}>{ConfigETC.TS_Approved_Text}</span>
                    ) ||
                    (data_modalTS_tss === ConfigETC.TS_Clearing_Value && 
                      <span className={ConfigETC.TS_Clearing_Class}>{ConfigETC.TS_Clearing_Text}</span>
                    )||
                    (data_modalTS_tss === ConfigETC.TS_Reject_Value && 
                      <span className={ConfigETC.TS_Reject_Class}>{ConfigETC.TS_Reject_Text}</span>
                    ) ||
                    (<span className={ConfigETC.TS_InProgress_Class}>{ConfigETC.TS_InProgress_Text}</span>
                    )
                    }
                    {(data_modalTS_tsssn !== "" || data_modalTS_tsd !== "") && <>
                      <span className="text-sm col-sm-10 col-form-label text-small">
                        <i className="fa fa-user" />{" "}{data_modalTS_tsssn}{" "}{data_modalTS_tsd}
                      </span>
                    </>}


                  </div>
                </div>


                {(data_modalTS_tsrd !== "" && (    (data_modalTS_tss !== ConfigETC.TS_Approved_Value) 
                                                && (data_modalTS_tss !== ConfigETC.TS_Clearing_Value)
                                            ) && 
                  <>
                    <div className="form-group row m-0">
                      <span className="text-sm col-sm-2 col-form-label">
                        Reject desc
                      </span>
                      <span className="text-sm col-sm-10 col-form-label text-small">
                        {data_modalTS_tsrd}{" "}<i className="fa fa-user" />{" "}{data_modalTS_tsrd2}{" "}{data_modalTS_tsrd3}
                      </span>
                    </div>
                  </>
                )}

                {data_modalTS_ActProject === "Edit" && 
                <>
                  <div className="form-group row m-0">
                    <span className="text-sm col-sm-2 col-form-label text-bold">
                      Last Update{" "}
                    </span>
                    <span className="text-sm col-sm-10 col-form-label text-small">
                      <i className="fa fa-user" />{" "}{data_modalTS_usn}{" "}{data_modalTS_ud}
                    </span>
                  </div>
                </>
                }
              </div>
            </div>



            {((data_modalTS_act_del === "y" || data_modalTS_act_cancel === "y" || data_modalTS_act_edit === "y" ) && 
              <>
                <div className="modal-footer justify-content-between">
                  {(data_modalTS_act_del === "y" && 
                    <button
                      type="button"
                      className="btn btn-default btn-sm"
                      onClick={onclick_deltimesheetpopup}
                    >
                      <i className="fas fa-trash-alt " /> Delete
                    </button>
                  ) || 
                  <>
                    <a href="#!" >{" "}</a>
                  </>
                  }

                  <span className="float-right">
                  {(data_modalTS_act_cancel === "y" && 
                    <button
                      type="button"
                      className="btn btn-danger btn-sm"
                      onClick={onclick_Cenceltimesheetpopup}
                    >
                      <i className="far fa-window-close" /> Cancel submit
                    </button>
                    )}
                    {" "}
                    {(data_modalTS_act_edit === "y" && 
                      <>
                        <button
                          type="button"
                          className="btn btn-primary btn-sm"
                          onClick={() => onclick_savetimesheetpopup("")}
                        >
                          <i className="far  fa-save" /> Save
                        </button>
                        {" "}
                        <button
                          type="button"
                          className="btn btn-primary btn-sm"
                          onClick={() => onclick_savetimesheetpopup("submit")}
                        >
                          <i className="far fa-paper-plane" /> Save and Submit
                        </button>
                      </>
                    )}
                  </span>
                </div>
              </>
            )}


          </div>
          {/* /.modal-content */}
        </div>
        {/* /.modal-dialog */}
      </div>
      
      {/* ###################### Modal Edit TimeSheet  ###################### */}
      

      {/* ###################### Modal Submit  ###################### */}

      <div className="modal fade" id="modal-submit">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">
                <i className="far fa-paper-plane" /> Submit{" "}
                <span className="text-sm text-muted">
                  (Send timesheet for approve)
                </span>
              </h4>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                id="modalsubmit_Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body p-0">
              <div className="form-horizontal">

                <TableContainer>
                  <Table
                    stickyHeader
                    aria-label="sticky table"
                    className="table table-head-fixed table-hover text-sm table-fit"
                    style={{ margin: 0 }}
                    border={0}
                  >
                    <TableHead>
                      <TableRow>
                        
                        <TableCell className="align-top  border-right" style={{ width: "20%" }} />
                        <TableCell
                          className="align-top text-normal"
                          style={{ width: "10%" }}
                        >
                          Work time
                        </TableCell>
                        <TableCell
                          className={isSVOT === true ? "align-top text-normal" : "align-top text-normal border-right"}
                          style={{ width: "10%" }}
                        >
                          TimeOff
                        </TableCell>

                        {isSVOT === true &&
                          <TableCell
                            className="align-top text-normal border-right"
                            style={{ width: "10%" }}
                          >
                            Over time
                          </TableCell>
                        }

                        <TableCell className="align-top text-normal border-right" style={{ width: "10%" }}>
                          Timesheet Total
                        </TableCell>
                        <TableCell className="align-top text-normal " style={{ width: "10%" }}>
                          Expenses (baht) Total
                        </TableCell>


                        <TableCell className="align-top text-normal" style={{ width: "10%" }}>
                          Per diem allowance (day) Total
                        </TableCell>
                        <TableCell className="align-top border-right text-normal" style={{ width: "10%" }}>
                        Travel distance (km.) Total
                        </TableCell>

                        <TableCell
                          className="align-top text-right"
                          style={{ width: "10%" }}
                        >
                          <span className="icheck-primary d-inline">
                            <input
                              id="chk_modalsubmit_all"
                              type="checkbox"
                              className="form-check-input"
                              onChange={onChange_CheckboxAllSubmit}
                            />
                            <label htmlFor="chk_modalsubmit_all" className="text-normal" />
                          </span>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>

                      {(listtimesheetSubmit.length === 0 && (
                          <TableRow key={1}>
                            <TableCell colSpan={7} align="center">
                              {ConfigETC.NoData}
                            </TableCell>
                          </TableRow>
                        )) ||
                        listtimesheetSubmit.map((row) => (
                          <TableRow key={"tb_submit_" + row.rowindex.toString()}>
                           
                            <TableCell className="border-right">
                            <span className="text-small text-muted">({row.dday})</span>{" "}
                              <span className=" text-normal">
                                {row.fulldate} 
                                {" "}
                                {(row.isToday === 1 ? <i className="far fa-star text-sm text-warning" title="today"></i> : "")}
                              </span>
                            </TableCell>
                            <TableCell>
                              <TimesheetSubmitCellShowTime 
                                hh={row.worktime_hh} 
                                mm={row.worktime_mm} >
                                </TimesheetSubmitCellShowTime>
                            </TableCell>
                            <TableCell className={isSVOT === true ? "" : "border-right"}>
                              <TimesheetSubmitCellShowTime 
                                hh={row.timeoff_hh} 
                                mm={row.timeoff_mm} >
                                </TimesheetSubmitCellShowTime>
                            </TableCell>
                            {isSVOT === true &&
                              <TableCell className="border-right">
                                <TimesheetSubmitCellShowTime 
                                  hh={row.overtime_hh} 
                                  mm={row.overtime_mm} >
                                  </TimesheetSubmitCellShowTime>
                              </TableCell>
                            }
                            <TableCell className="border-right">
                              <TimesheetSubmitCellShowTime 
                                hh={row.timesheettotal_hh} 
                                mm={row.timesheettotal_mm} >
                                </TimesheetSubmitCellShowTime>
                            </TableCell>
                            <TableCell  >
                              <span>
                                {(row.timesheettotal_hh + row.timesheettotal_mm > 0 ? row.expensestotal_str : "")}
                              </span>
                            </TableCell>
                            
                            <TableCell >
                              <span>
                                {(row.timesheettotal_hh + row.timesheettotal_mm > 0 ? row.extra_day_str : "")}
                              </span>
                            </TableCell>
                            <TableCell className="border-right">
                              <span>
                                {(row.timesheettotal_hh + row.timesheettotal_mm > 0 ? row.travel_distance_str : "")}
                              </span>
                            </TableCell>


                            <TableCell className="text-right">
                              <span className="icheck-primary d-inline">
                                {(row.timesheettotal_hh + row.timesheettotal_mm > 0 && 
                                <>
                                  <input
                                    id={"chk_modalsubmit_" + row.dday}
                                    type="checkbox"
                                    className="form-check-input"
                                    onChange={onChange_CheckboxSubmit}
                                  />
                                  <label htmlFor={"chk_modalsubmit_" + row.dday} className="text-normal" />
                                </>)}
                              </span>
                            </TableCell>
                          </TableRow>
                      ))}

                    </TableBody>
                  </Table>
                </TableContainer>


              </div>
            </div>
            {(listtimesheetSubmit.length > 0 &&
              <>
                <div className="modal-footer  float-right">
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={onclick_SaveSubmitWeek}
                    disabled={isdisabled_btnsubmitweek}
                  >
                    <i className="far fa-paper-plane" /> Submit
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
        {/* /.modal-content */}
        {/* /.modal-dialog */}
      </div>

      {/* ###################### Modal Submit  ###################### */}
      


    </>
  );
}



function IconTodayShoworNot(props) {
  const { isshow } = props;
  if (isshow === "show")
  {
    return(
      <>
        <span className="today-icon">
          <i
            className="far fa-star text-small text-warning"
            title="today"
          />
        </span>   
      </>
    )
  }
  else
  {
    return(
      <>
      </>
    )
  };
}




export default Timesheet;
